webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {


exports.dtConfig = {
    "pageLength": 100,
    "columnDefs": [{

        "targets": '_all',
        "createdCell": function createdCell(td, cellData, rowData, row, col) {
            $(td).html($(td).html().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"));
        }
    }],
    "sDom": '<"top">rt<"bottom"><"clear">'
};

exports.renderTable = function (hc, tableId) {
    var series = '<th></th>';
    var row = '<tr>';
    var tSeries = '';

    for (var i = 0; i < hc.series.length; i++) {
        series = series + ("<th> " + hc.series[i].name + "</th>");
    }

    for (var _i = 0; _i < hc.series[0].data.length; _i++) {
        row = row + ("<td class=\"strong\">" + hc.xAxis.categories[_i] + "</td>");
        for (var j = 0; j < hc.series.length; j++) {

            var tmp = hc.series[j].data[_i];
            row = row + ("<td> " + tmp + " </td>");
        }
        row = row + "</tr>";
    }

    var hcTable = '';
    return hcTable = "\n                            <table id=\"" + tableId + "\" class=\"ordered striped\">\n                                <thead>\n                                    <tr>\n                                        " + series + "\n                                    </tr>\n                                </thead>\n                                    <tbody>\n                                    " + row + "\n                                    </tbody>\n                            </table> ";
};

exports.guid = function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4();
};

exports.objSize = function (obj) {
    var size = 0,
        key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

exports.parseBool = function (str) {

    if (str == null) return false;

    if (typeof str === 'boolean') {
        return str === true;
    }

    if (typeof str === 'string') {
        if (str == "") return false;

        str = str.replace(/^\s+|\s+$/g, '');
        if (str.toLowerCase() == 'true' || str.toLowerCase() == 'yes') return true;

        str = str.replace(/,/g, '.');
        str = str.replace(/^\s*\-\s*/g, '-');
    }

    if (!isNaN(str)) return parseFloat(str) != 0;

    return false;
};

exports.titleCase = function (str) {
    var words = str.toLowerCase().split(' ');

    for (var i = 0; i < words.length; i++) {
        var letters = words[i].split('');
        letters[0] = letters[0].toUpperCase();
        words[i] = letters.join('');
    }
    return words.join(' ');
};

exports.camelCase = function (str) {
    return str.toLowerCase().replace(/[-_]+/g, ' ').replace(/[^\w\s]/g, '').replace(/ (.)/g, function ($1) {
        return $1.toUpperCase();
    }).replace(/ /g, '');
};

exports.stripTags = function (str) {
    str = str.replace(/<\/?[^>]+>/g, '');

    str = str.replace(/[\n\r]/g, '');
    return str;
};

exports.truncateString = function (str, num) {

    if (str === undefined) return;

    if (str.length <= num) {
        return str;
    } else {
        return str.slice(0, num > 3 ? num - 3 : num) + '...';
    }
};

exports.truncateStringMiddle = function (text, startChars, endChars, maxLength) {
    if (text.length > maxLength) {
        var start = text.substring(0, startChars);
        var end = text.substring(text.length - endChars, text.length);
        while (start.length + end.length < maxLength) {
            start = start + '.';
        }
        return start + end;
    }
    return text;
};

function stripCarriageReturns(str) {
    return str.replace(/[\n\r]/g, '');
}

exports.componentToRouterPath = function (c) {
    String.prototype.camelCaseToDashed = function () {
        return this.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    };
    path = _.replace(c, "./views", "");
    path = _.replace(path, ".vue", "");
    path = path.camelCaseToDashed();
    return path;
};

exports.generateRoutes = function (arr) {
    var _REDIRECT_ROUTE = {
        path: '/*',
        title: 'Redirect',
        type: 'redirect',
        created: new Date(),
        status: 'live',
        name: 'Redirect',
        redirect: '/'
    };

    var _r = [];
    var _obj = {};
    var _name = 'NoNameSpecified';
    var _created = new Date();
    var _posted = _created;
    var _expired = new Date(String('2999-12-31').replace(/-/g, "/"));
    var _title = 'No Title Specified';
    var _description = 'No Description specified';
    var _status = 'live';
    var _type = 'page';

    arr.forEach(function (eachObj) {
        _obj = {};
        _obj.path = eachObj["path"];

        _obj.component = eachObj["component"];

        if ('pageData' in eachObj["component"]) {

            if ('name' in eachObj["component"]) {
                _obj.name = String(eachObj["component"].pageData.title).replace(/\s+/g, '');
            } else {
                _obj.name = _name;
            }

            if ('created' in eachObj["component"].pageData) {
                _obj.created = new Date(String(eachObj["component"].pageData.created).replace(/-/g, "/"));
            } else {
                _obj.created = _created;
            }

            if ('posted' in eachObj["component"].pageData) {
                _obj.posted = new Date(String(eachObj["component"].pageData.posted).replace(/-/g, "/"));
            } else {
                _obj.posted = _obj.created;
            }

            if ('expired' in eachObj["component"].pageData) {
                _obj.expired = new Date(String(eachObj["component"].pageData.expired).replace(/-/g, "/"));
            } else {
                _obj.expired = _expired;
            }

            if ('title' in eachObj["component"].pageData) {
                _obj.title = eachObj["component"].pageData.title, 100;
            } else {
                _obj.title = _title;
            }

            if ('description' in eachObj["component"].pageData) {
                _obj.description = stripCarriageReturns(eachObj["component"].pageData.description);
            } else {
                _obj.description = _description;
            }
            if ('status' in eachObj["component"].pageData) {
                _obj.status = eachObj["component"].pageData.status;
            } else {
                _obj.status = _status;
            }

            if ('type' in eachObj["component"].pageData) {
                _obj.type = eachObj["component"].pageData.type;
            } else {
                _obj.type = _type;
            }
        } else {
            _obj.name = _name;
            _obj.created = _created;
            _obj.posted = _created;
            _obj.expired = _expired;
            _obj.title = _title;
            _obj.description = _description;
            _obj.status = _status;
            _obj.type = _type;
        }
        _r.push(_obj);
    });
    _r.push(_REDIRECT_ROUTE);

    return _r;
};

exports.nameCheck = function (str) {
    if (!isNaN(str.charAt(0))) {
        return 'x' + str;
    } else {
        return str;
    }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(374),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(281)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(288)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var utilities = __webpack_require__(2);

var views = [{
  path: "/",
  component: __webpack_require__(315)
}, {
  path: utilities.componentToRouterPath("./views/Overview.vue"),
  component: __webpack_require__(317)
}, {
  path: utilities.componentToRouterPath("./views/Contact.vue"),
  component: __webpack_require__(310)
}, {
  path: utilities.componentToRouterPath("./views/News.vue"),
  component: __webpack_require__(316)
}, {
  path: utilities.componentToRouterPath("./views/GrantInformation.vue"),
  component: __webpack_require__(313)
}, {
  path: utilities.componentToRouterPath("./views/Documents.vue"),
  component: __webpack_require__(311)
}, {
  path: utilities.componentToRouterPath("./views/Webinars.vue"),
  component: __webpack_require__(318)
}, {
  path: utilities.componentToRouterPath("./views/Faqs.vue"),
  component: __webpack_require__(312)
}, {
  path: utilities.componentToRouterPath("./views/news/CatalogOfStateFinancialAssistance.vue"),
  component: __webpack_require__(350)
}, {
  path: utilities.componentToRouterPath("./views/Grants.vue"),
  component: __webpack_require__(314)
}, {
  path: utilities.componentToRouterPath("./views/grants/NofoVocaLegalAssist.vue"),
  component: __webpack_require__(349)
}, {
  path: utilities.componentToRouterPath("./views/grants/JagComprehensiveResponse.vue"),
  component: __webpack_require__(348)
}, {
  path: utilities.componentToRouterPath("./views/grants/201704RsatNofo.vue"),
  component: __webpack_require__(322)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170427VocaSA.vue"),
  component: __webpack_require__(321)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170427VocaCACI.vue"),
  component: __webpack_require__(319)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170427VocaDV.vue"),
  component: __webpack_require__(320)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170602UnmetNeeds.vue"),
  component: __webpack_require__(323)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170620CommunityViolence.vue"),
  component: __webpack_require__(324)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170819ViolenceInterventionAndPrevention.vue"),
  component: __webpack_require__(325)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170824VOCAcourts.vue"),
  component: __webpack_require__(326)
}, {
  path: utilities.componentToRouterPath("./views/grants/20170913ARISFY18.vue"),
  component: __webpack_require__(327)
}, {
  path: utilities.componentToRouterPath("./views/grants/20171031TRC.vue"),
  component: __webpack_require__(328)
}, {
  path: utilities.componentToRouterPath("./views/grants/20171102SORNA.vue"),
  component: __webpack_require__(329)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180205LeadEntityCAC.vue"),
  component: __webpack_require__(330)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180205LeadEntityDV.vue"),
  component: __webpack_require__(331)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180205LeadEntitySA.vue"),
  component: __webpack_require__(332)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180227JAGoperations.vue"),
  component: __webpack_require__(333)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180608VOCAHotline.vue"),
  component: __webpack_require__(334)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180705ARIimplementation.vue"),
  component: __webpack_require__(335)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180821VAWAMulti.vue"),
  component: __webpack_require__(336)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180911CLEP.vue"),
  component: __webpack_require__(337)
}, {
  path: utilities.componentToRouterPath("./views/grants/20180927ARIPlanning.vue"),
  component: __webpack_require__(338)
}, {
  path: utilities.componentToRouterPath("./views/grants/20181102rsatmat.vue"),
  component: __webpack_require__(339)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190111DPAservicesNOFO.vue"),
  component: __webpack_require__(340)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190115ResponsiveSchools.vue"),
  component: __webpack_require__(341)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190129lawEnforcement.vue"),
  component: __webpack_require__(345)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190129CACI.vue"),
  component: __webpack_require__(342)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190129ICADV.vue"),
  component: __webpack_require__(343)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190129ICASA.vue"),
  component: __webpack_require__(344)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190306ifvcc.vue"),
  component: __webpack_require__(346)
}, {
  path: utilities.componentToRouterPath("./views/grants/20190329vawa.vue"),
  component: __webpack_require__(347)
}];

/* harmony default export */ __webpack_exports__["a"] = (utilities.generateRoutes(views));

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(370),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(367),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */,
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__routes_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);




var grants = [];
var news = [];
var pages = [];
var types = ['grant', 'news', 'page'];
var dateNow = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format();

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
    var _loop = function _loop() {
        var type = _step.value;


        _.forOwn(__WEBPACK_IMPORTED_MODULE_1__routes_js__["a" /* default */], function (value, key) {

            if (value.type === type && value.status === 'live') {
                var obj = {};
                obj.name = value.name;
                obj.path = value.path;
                obj.title = value.title;
                obj.status = value.status;
                obj.posted = value.posted;

                obj.created = value.created;
                if (String(obj.created) === 'Invalid Date') {
                    obj.created = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format();
                }
                obj.expired = value.expired;
                if (String(obj.expired) === 'Invalid Date') {
                    obj.expired = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.expired).format();
                }

                obj.posted = value.posted;
                if (String(obj.expired) === 'Invalid Date') {
                    obj.posted = __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.posted).format();
                }

                obj.description = value.description;

                if (obj.name != 'direct' && obj.name != 'Redirect') {
                    if (type === 'news') {
                        news.push(obj);
                    }
                    if (type === 'grant') {
                        var pushToArray = dateNow > __WEBPACK_IMPORTED_MODULE_2_moment___default()(value.posted).format();

                        if (pushToArray) {
                            grants.push(obj);
                        }
                    }

                    if (type === 'page') {
                        pages.push(obj);
                    }
                }
            }
        });
    };

    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally {
    try {
        if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
        }
    } finally {
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    grants: grants,
    news: news,
    pages: pages
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function appendScript() {
  var script = document.createElement("script");
  script.async = true;
  script.src = "https://www.google-analytics.com/analytics.js";
  document.body.appendChild(script);
}

function stripTrailingSlash(str, min) {
  if (str.substr(-1) === "/" && str.length > min) {
    return str.substr(0, str.length - 1);
  } else {
    return str;
  }
}

function init(id) {
  if (!window.ga) {
    appendScript();
    window.ga = window.ga || function () {
      (ga.q = ga.q || []).push(arguments);
    };
    ga.l = Number(new Date());
    ga("create", id, "auto");
  }
}

function collect(id, prefix, title, path) {
  init(id);
  ga("set", "page", path);
  ga("set", "title", prefix + title);
  ga("send", "pageview");
}

/* harmony default export */ __webpack_exports__["a"] = (function (id, prefix, router) {
  router.afterEach(function (from) {
    var routes = router.options.routes;
    var title = "(undefined)";
    var path = "(undefined)";

    for (var o = 0; o < routes.length; o++) {
      if (routes[o].path === stripTrailingSlash(from.fullPath, 1)) {
        title = routes[o].title;
        path = routes[o].path;
      }
    }

    collect(id, prefix, title, path);
  });
});

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(368),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_meta__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_meta__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  metaInfo: __WEBPACK_IMPORTED_MODULE_2_meta___default.a,
  created: function created() {},

  mounted: function mounted() {
    $(function () {
      outdatedBrowser({
        bgColor: "#f25648",
        color: "#ffffff",
        lowerThan: "borderImage",
        languagePath: "/static/outdated-browser/outdatedbrowser/lang/en.html"
      });
    });

    if (typeof jQuery != "undefined") {
      jQuery(document).ready(function ($) {
        var filetypes = /\.(zip|exe|pdf|doc*|xls*|ppt*|mp3)$/i;
        var baseHref = "";
        if (jQuery("base").attr("href") != undefined) baseHref = jQuery("base").attr("href");
        jQuery("a").each(function () {
          var href = jQuery(this).attr("href");
          if (href && href.match(/^https?\:/i) && !href.match(document.domain)) {
            jQuery(this).click(function () {
              var extLink = href.replace(/^https?\:\/\//i, "");
              ga("send", "event", "External Link", "click", extLink);
              if (jQuery(this).attr("target") != undefined && jQuery(this).attr("target").toLowerCase() != "_blank") {
                setTimeout(function () {
                  location.href = href;
                }, 200);
                return false;
              }
            });
          } else if (href && href.match(/^mailto\:/i)) {
            jQuery(this).click(function () {
              var mailLink = href.replace(/^mailto\:/i, "");
              ga("send", "event", "Email Link", "click", mailLink);
            });
          } else if (href && href.match(filetypes)) {
            jQuery(this).click(function () {
              var extension = /[.]/.exec(href) ? /[^.]+$/.exec(href) : undefined;
              var filePath = href;
              ga("send", "event", "Download Link", "click-" + extension, filePath);
              if (jQuery(this).attr("target") != undefined && jQuery(this).attr("target").toLowerCase() != "_blank") {
                setTimeout(function () {
                  location.href = baseHref + href;
                }, 200);
                return false;
              }
            });
          }
        });
      });
    }
  },
  components: {
    Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar___default.a,
    MyFooter: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _obj = {};

    this.url = this.$route.fullPath.replace(/\/\s*$/, '').split('/');

    this.url.shift();
    console.log(this.url);
    this.breadcrumb = '<li class="breadcrumb-item" >\n      <router-link to="/">Home</router-link>\n    </li>';
  },
  data: function data() {
    return {
      url: [],
      breadcrumb: ''
    };
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utilities__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, 'days')
    };
  },

  props: {
    expired: {
      type: String,
      require: false
    }
  },
  methods: {
    checkExpire: function checkExpire(d) {
      if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(d) < this.now) {
        return true;
      }
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  components: {},
  name: 'Footer',
  methods: {

    getFullYear: function getFullYear() {
      var today = new Date();
      return today.getFullYear();
    }

  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities__);





/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {

        var dateNow = this.now;
        var filtered = [];
        var showExpired = __WEBPACK_IMPORTED_MODULE_2__utilities___default.a.parseBool(this.showExpired);
        if (!showExpired) {
            filtered = _.filter(this.$store.grants, function (o) {
                return o.expired > dateNow;
            });
        } else {
            filtered = this.$store.grants;
        }

        var grants = _.orderBy(filtered, this.sortBy, this.sortDirection);
        this.grants = grants;

        var self = this;
    },


    data: function data() {
        return {
            grants: [],
            now: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'days'),
            weeksForNewBanner: 1
        };
    },
    props: {
        showExpired: {
            type: String,
            default: 'false'
        },
        sortBy: {
            type: String,
            default: 'expired'
        },
        sortDirection: {
            type: String,
            default: 'asc'
        }
    },
    methods: {
        isItExpired: function isItExpired(d) {
            return d < this.now;
        },
        isItNew: function isItNew(d) {
            var target = __WEBPACK_IMPORTED_MODULE_1_moment___default()(d).add(this.weeksForNewBanner, 'weeks');
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(target).isAfter(__WEBPACK_IMPORTED_MODULE_1_moment___default()());
        }
    },
    filters: {
        limit: function limit(arr, _limit) {
            return arr.slice(0, _limit);
        },
        moment: function moment(date) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMMM Do YYYY');
        }
    }

});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        $(document).ready(function () {
            $('.hamburger').click(function () {
                $(this).toggleClass('is-active');
            });
        });

        var dateNow = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'days');

        var filtered = _.filter(this.$store.grants, function (o) {
            return o.expired > dateNow;
        });
        var grants = _.orderBy(filtered, 'title', 'asc');

        this.grants = grants;
    },

    components: {},

    name: 'Navbar',
    filters: {
        limit: function limit(arr, _limit) {
            return arr.slice(0, _limit);
        },
        moment: function moment(date) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMMM Do YYYY');
        },

        truncateMiddle: function truncateMiddle(text) {
            var startChars = 15;
            var endChars = 25;
            var maxLength = 43;
            if (text.length > maxLength) {
                var start = text.substring(0, startChars);
                var end = text.substring(text.length - endChars, text.length);
                while (start.length + end.length < maxLength) {
                    start = start + '.';
                }
                return start + end;
            }
            return text;
        },

        truncate: function truncate(str) {
            var num = 30;
            if (str === undefined) return;

            if (str.length <= num) {
                return str;
            } else {
                return str.slice(0, num > 3 ? num - 3 : num) + '...';
            }
        }

    },
    data: function data() {
        return {
            grants: []
        };
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utilities__);





/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {

    var newsItems = _.orderBy(this.$store.news, 'created', 'desc');

    if (this.maxItems) {

      this.newsItems = newsItems.slice(0, Number(this.maxItems));
    } else {

      this.newsItems = newsItems;
    }
  },


  data: function data() {
    return {
      newsItems: []
    };
  },
  props: {
    maxItems: {
      type: Number,
      required: false
    }
  },
  filters: {
    limit: function limit(arr, _limit) {
      return arr.slice(0, _limit);
    },
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMMM Do YYYY');
    }
  }

});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CheckExpiration__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CheckExpiration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CheckExpiration__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_0__components_Breadcrumb___default.a,
    CheckExpiration: __WEBPACK_IMPORTED_MODULE_1__components_CheckExpiration___default.a
  },
  props: {
    header: {
      type: String,
      required: true,
      default: 'GATA Heading'
    },
    expired: {
      type: String,
      required: false
    },
    breadcrumb: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {

    $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

        if (target.length) {
          event.preventDefault();

          $('html, body').animate({
            scrollTop: target.offset().top - 20

          }, 1000, function () {
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) {
              return false;
            } else {
              $target.attr('tabindex', '-1');
              $target.focus();
            };
          });
        }
      }
    });
  }

});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    $(document).ready(function () {
      var stickyElements = document.getElementsByClassName('sticky');

      for (var i = stickyElements.length - 1; i >= 0; i--) {
        Stickyfill.add(stickyElements[i]);
      }
    });
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'Contact ICJIA';
var title = "Contact ICJIA";
var created = '2017-03-26';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Contact',
    pageData: {
        created: created,
        description: description,
        title: title,
        type: type,
        status: status
    },
    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

    },
    data: function data() {
        return {
            title: title
        };
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'Documents';
var title = "Documents";
var created = '2017-03-26';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Documents',
    pageData: {
        created: created,
        description: description,
        title: title,
        type: type,
        status: status
    },
    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {
        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a
    },
    data: function data() {
        return {
            title: title
        };
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'FAQs';
var title = "FAQs";
var created = '2017-03-26';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FAQs',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },
  mounted: function mounted() {
    $(document).ready(function () {

      $(function () {
        $(".youtube").each(function () {
          $(this).css('background-image', 'url(https://i.ytimg.com/vi/' + this.id + '/mqdefault.jpg)');

          $(this).append($('<div/>', { 'class': 'play' }));

          $(document).delegate('#' + this.id, 'click', function () {
            var iframe_url = "https://www.youtube.com/embed/" + this.id + "?allowfullscreen&autoplay=1&autohide=1";
            if ($(this).data('params')) iframe_url += '&' + $(this).data('params');

            var iframe = $('<iframe/>', { 'frameborder': '0', 'allowfullscreen': 'true', 'src': iframe_url, 'width': $(this).width(), 'height': $(this).height() });

            $(this).replaceWith(iframe);
          });
        });
      });
    });
  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'Grant Information';
var title = "sGrant Information";
var created = '2017-03-26';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GrantInformation',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grantfeed__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Grantfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_Grantfeed__);


var description = "Grant Opportunities";
var title = "Archived Grant Opportunities";
var created = "2017-03-26";
var posted = "2017-03-26";
var type = "page";
var status = "live";





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Grants",
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    posted: posted,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_1__utilities___default.a.stripTags(description)
    }]
  },
  mounted: function mounted() {
    this.filter(this.filterType);


    var vm = this;
    $(document).ready(function () {
      $(".btn-filter").click(function () {
        var ft = $(this).val();
        console.log("Filter choice", ft);
        vm.filter(ft);
      });
    });
  },


  methods: {
    checkExpire: function checkExpire(d) {
      if (d < this.now) {
        return true;
      }
    },
    changeFilter: function changeFilter(event) {
      this.filter(event.target.value);
    },
    isItExpired: function isItExpired(d) {
      return d < this.now;
    },
    isItNew: function isItNew(d) {
      var target = __WEBPACK_IMPORTED_MODULE_0_moment___default()(d).add(this.weeksForNewBanner, "weeks");
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(target).isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()());
    },
    changeSortBy: function changeSortBy(event) {
      this.sortFiltered(event.target.value);
    },
    changeSortDirection: function changeSortDirection(event) {
      this.sortDirection(event.target.value);
    },
    sortDirection: function sortDirection(s) {
      this.direction = s;
      this.grants = _.orderBy(this.grants, this.sort, this.direction);
    },
    sortFiltered: function sortFiltered(s) {
      this.sort = s;
      this.grants = _.orderBy(this.grants, this.sort, this.direction);
    },
    filter: function filter(filterType) {
      var self = this;
      var filtered = [];
      this.filterType = filterType;
      this.warning = "";

      if (filterType === "expired") {
        filtered = _.filter(this.$store.grants, function (o) {
          return o.expired < self.now;
        });
      } else if (filterType === "current") {
        filtered = _.filter(this.$store.grants, function (o) {
          return o.expired > self.now;
        });
      } else {
        filtered = this.$store.grants;
      }

      this.filtered = filtered;
      this.grants = _.orderBy(this.filtered, this.sort, this.direction);

      if (this.grants.length === 0) {
        this.warning = "There are no " + filterType + " grants to display.";
      }
    }
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_2__components_PageHeader___default.a,
    Grantfeed: __WEBPACK_IMPORTED_MODULE_3_components_Grantfeed___default.a
  },
  filters: {
    limit: function limit(arr, _limit) {
      return arr.slice(0, _limit);
    },
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("MMMM Do YYYY");
    }
  },
  data: function data() {
    return {
      title: title,
      grants: _.orderBy(this.$store.grants, "title", "asc"),
      now: __WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(1, "days"),
      warning: "",
      sort: "posted",
      direction: "desc",
      filtered: [],
      isActive: true,
      filterType: "expired",
      selectedButton: "",
      selected: "A",
      weeksForNewBanner: 1
    };
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Newsfeed__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_Newsfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grantfeed__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Grantfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Grantfeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_PageHeader__);


var description = 'Home';
var title = "Home";
var created = '2017-03-26';
var type = 'page';
var status = 'live';





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},


  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_3_components_PageHeader___default.a,
    Newsfeed: __WEBPACK_IMPORTED_MODULE_1_components_Newsfeed___default.a,
    Grantfeed: __WEBPACK_IMPORTED_MODULE_2_components_Grantfeed___default.a

  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Newsfeed__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Newsfeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Newsfeed__);


var description = 'News & Announcements';
var title = "News & Announcements";
var created = '2017-03-26';
var type = 'page';
var status = 'live';




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NewsAndInformation',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    Newsfeed: __WEBPACK_IMPORTED_MODULE_2_components_Newsfeed___default.a

  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'The Grant Accountability and Transparency Act, also known as GATA, was passed by the Illinois Legislature in 2014.\nGATA confirms ICJIA\'s commitment to the Federal Uniform Guidance 2 CFR 200, which went into effect in December 2014. The Uniform Guidance already applies to all federal grants and federal pass-through funds.\n GATA also requires Illinois\u2019 state grants to follow these federal rules for grants which are state funded.\n This landmark legislations will increase accountability and transparency in the use of grant funds.\n Once fully implemented,\n it will unify processes and reduce administrative burdens for state agencies and grantees.';

var title = "Overview";
var created = '2017-03-24';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Overview',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'Webinars';
var title = "Webinars";
var created = '2017-03-24';
var type = 'page';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Webinars',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  data: function data() {
    return {
      title: title
    };
  },

  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },

  mounted: function mounted() {
    $(document).ready(function () {

      $(function () {
        $(".youtube").each(function () {
          $(this).css('background-image', 'url(https://i.ytimg.com/vi/' + this.id + '/mqdefault.jpg)');

          $(this).append($('<div/>', { 'class': 'play' }));

          $(document).delegate('#' + this.id, 'click', function () {
            var iframe_url = "https://www.youtube.com/embed/" + this.id + "?allowfullscreen&autoplay=1&autohide=1";
            if ($(this).data('params')) iframe_url += '&' + $(this).data('params');

            var iframe = $('<iframe/>', { 'frameborder': '0', 'allowfullscreen': 'true', 'src': iframe_url, 'width': $(this).width(), 'height': $(this).height() });

            $(this).replaceWith(iframe);
          });
        });
      });
    });
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act Victim Assistance Formula Grant Program. As part of the recommendations established by the Victim Services Ad Hoc Committee the strengthening and expansion of core services for victims of crime was a priority.  To fulfill this priority, ICJIA has made available $7.1 million in VOCA grant funding for core services and related support costs for minor victims of abuse services.  These funds will be made available to the Children\u2019s Advocacy Centers of Illinois (CACI).';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR CHILDREN’S ADVOCACY CENTERS PROGRAM");
var created = '2017-04-27';
var expired = '2017-05-22';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(title),
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);







var description = 'ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act Victim Assistance Formula Grant Program. As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was identified as a priority.  To fulfill this priority, ICJIA has made available $17.3 million in VOCA grant funding for core services and related support costs for victims of domestic violence.  These funds will be made available to the Illinois Coalition Against Domestic Violence.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR VICTIMS OF DOMESTIC VIOLENCE PROGRAM");
var created = '2017-04-27';
var expired = '2017-05-22';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(title),
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);







var description = 'ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act Victim Assistance Formula Grant Program. As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was a priority.  To fulfill this priority, ICJIA has made available $16.3 million in VOCA grant funding for core services and related support costs for victims of sexual assault.  These funds will be made available to the Illinois Coalition Against Sexual Assault.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR VICTIMS OF SEXUAL ASSAULT PROGRAM");
var created = '2017-04-27';
var expired = '2017-05-22';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(title),
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);


var description = 'The Illinois Criminal Justice Information Authority is requesting proposals for grants supporting residential substance abuse treatment and aftercare services. Grants will be made with federal fiscal year 2014-17 (FFY14-17) Residential Substance Abuse Treatment (RSAT) funds. Approximately $315,000 in funding is available in three program categories for use over a period of 12 months.';
var title = "FY14-17 Residential Substance Abuse Treatment Program Residential Substance Abuse Treatment and Aftercare";
var created = '2017-04-15';
var expired = '2017-06-13';
var type = 'grant';
var status = 'live';




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'RSATTreatmentProgramResidentialSubstanceAbuseTreatmentAndAftercare',
  mounted: function mounted() {},

  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The purpose of this funding opportunity is to fund direct services for victims of crime under at least one of the three following focus areas: child abuse (minors and adults survivors of child abuse), financial crime, and impaired driving. Applicants may request a minimum of $75,000 to a maximum of $500,000 in federal funding for use over a 12-month period. The term of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("Federal Fiscal Year 2017 VICTIMS OF CRIME ACT FUNDING OPPORTUNITY FOR CHILD ABUSE, FINANCIAL CRIME AND IMPAIRED DRIVING VICTIM PROGRAMS");
var created = '2017-06-02';
var expired = '2017-07-19';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(title),
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The purpose of this grant opportunity is to fund direct services for victims of community violence. Applicants may request a minimum of $75,000 to a maximum of $1,000,000 in federal funding for use over a 12-month period. The term of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("2017 VICTIMS OF CRIME ACT FUNDING OPPORTUNITY FOR SERVICES TO VICTIMS OF COMMUNITY VIOLENCE");
var created = '2017-06-20';
var expired = '2017-08-10';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The State Fiscal Year 2018 (SFY18) Illinois State budget includes $8,000,000 for Community-Based Violence Prevention and Intervention grants and administration. The Authority anticipates that approximately $6,700,000 \u2013 $7,200,000 will be available under this Notice of Funding Opportunity. This Notice of Funding Opportunity is contingent upon the appropriation of Community-Based Violence Prevention funds to ICJIA in FY 18. Grant awards resulting from this opportunity are projected to have a performance period of October 1, 2017 through June 30, 2018. Contingent on future state fiscal year appropriations and satisfactory performance, ICJIA staff may recommend to its Board a maximum of an additional two, 12 month grants for each project. Funding amounts in future years may be reduced depending on appropriation.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("COMMUNITY-BASED VIOLENCE INTERVENTION AND PREVENTION PROGRAM");
var created = '2017-07-19';
var expired = '2017-08-18';
var type = 'grant';
var status = 'live';
var posted = "2017-07-19";

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        posted: posted,
        description: description,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The Illinois Criminal Justice Information Authority is requesting proposals to fund direct services for victims of crime through municipal police departments, county sheriff departments, county state\u2019s attorney\u2019s offices, and county CASA programs.  Grants will be made with Federal Fiscal Year 2016 (FFY16) Victims of Crime Act (VOCA) funds. A total of $6.0 million in funding is available through this solicitation for use over a period of 12 months.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("Federal Fiscal Year 2016 Victims of Crime Act Grant Program");
var created = '2017-08-24';
var posted = "2017-08-30";
var expired = '2017-10-15';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The Illinois Criminal Justice Information Authority is requesting proposals for Adult Redeploy Illinois \u2013 State Fiscal Year 2018 (SFY18) Planning and Implementation Grants. Grants will be made with SFY18 ARI funds. A total of $500,000 in funding for Planning and Implementation Grants is available through this solicitation for use over a period of 6 months. ';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("Adult Redeploy Illinois -- SFY18 Planning and Implementation Grants");
var created = '2017-09-13';
var posted = "2017-09-13";
var expired = '2017-10-30';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The purpose of this funding opportunity is to serve hard-to-reach victims of crime through Illinois Level 1 Adult or Pediatric Trauma Centers. Applicants may request a maximum of $1.1 million in federal funding for use over a 15-month period. The term of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("VICTIMS OF CRIME ACT FUNDING OPPORTUNITY FOR TRAUMA RECOVERY CENTERS");
var created = '2017-10-31';
var posted = "2017-10-31";
var expired = '2018-01-10';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = 'The Illinois Criminal Justice Information Authority is requesting proposals for SORNA Electronic Transmission and Livescan grants. Grants will be made with SORNA Federal Fiscal Year 2016 and 2017 funds. A total of $463,307 in funding  is available through this solicitation for use over a period of six months. ';
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("Sex Offender Registration and Notification Act Electronic Transmission and Livescan grants");
var created = '2017-11-02';
var posted = "2017-11-06";
var expired = '2017-12-21';
var type = 'grant';
var status = 'live';

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: 'description',
            name: 'description',
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {

        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act (VOCA) Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated\nto states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2016, Illinois received a VOCA award of $87 million.";
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("Federal Fiscal Year 2016 VICTIM OF CRIME ACT LEAD ENTITY SERVICES FOR CHILDREN’S ADVOCACY CENTERS PROGRAM");
var created = "2018-02-05";
var posted = "2018-02-05";
var expired = "2018-03-09";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: "description",
            name: "description",
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {
        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act (VOCA) Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated\nto states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2016, Illinois received a VOCA award of $87 million.";
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("FEDERAL FISCAL YEAR 2016 VICTIMOF CRIME ACT LEAD ENTITY SERVICES FOR VICTIMS OF DOMESTIC VIOLENCE PROGRAM");
var created = "2018-02-05";
var posted = "2018-02-05";
var expired = "2018-03-09";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
    pageData: {
        created: created,
        description: description,
        posted: posted,
        expired: expired,
        title: title,
        type: type,
        status: status
    },
    mounted: function mounted() {},

    metaInfo: {
        title: title,
        meta: [{
            vmid: "description",
            name: "description",
            content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
        }]
    },
    components: {
        PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
        SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
        StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
    },
    data: function data() {
        return {
            title: title,
            expired: expired
        };
    }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "ICJIA is the state agency charged with the administration of the Illinois\u2019 Victims of Crime Act (VOCA) Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated\n  to states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2016, Illinois received a VOCA award of $87 million.";
var title = __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.titleCase("FEDERAL FISCAL YEAR 2016 VICTIM OF CRIME ACT LEAD ENTITY SERVICES FOR VICTIMS OF SEXUAL ASSAULT PROGRAM");
var created = "2018-02-05";
var posted = "2018-02-05";
var expired = "2018-03-09";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for continuing support for nine current prosecution, public defense and court programs currently supported with ICJIA-administered JAG funds. Grants will be made with Federal Fiscal Year 2014-16 (FFY14-16) Edward Byrne Memorial Justice Assistance Grant (JAG) funds. A total of $600,000 in funding is available through this solicitation for use over a period of 12 months. Awards resulting from this NOFO will range from a minimum of $40,000 to a maximum of $225,000.";
var title = "FFY14-16 Edward Byrne Memorial Justice Assistance Grant Program Notice of Funding Opportunity: JAG Operations";
var created = "2018-02-27";
var posted = "2018-02-28";
var expired = "2018-04-16";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority seeks to fund a Statewide Domestic Violence Hotline Service program. The grant will be made with Federal Fiscal Year 2016 (FFY16) Victim of Crime Act (VOCA) funds. A total of $455,000 in funding is available through this solicitation for use over a period of 12 months.";
var title = "FFY16 Victim of Crime Act (VOCA) Notice of Funding Opportunity: Statewide Domestic Violence Hotline Services Program";
var created = "2018-06-08";
var posted = "2018-06-08";
var expired = "2018-07-18";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for SFY19 Adult Redeploy Illinois\n            implementation grants. A total of $700,000 in SFY19 Adult Redeploy Illinois funding is available through this\n            solicitation for use over a 9-month period.";
var title = "SFY19 Adult Redeploy Illinois Implementation Grants";
var created = "2018-07-05";
var posted = "2018-07-05";
var expired = "2018-08-06";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is soliciting proposals from county criminal justice and victim service agencies interested in maintaining or expanding multidisciplinary programs incorporating prosecution, county and/or local law enforcement, probation, and victim service agency partnerships. Grants will be made with Violence Against Women Act (VAWA) funds. A total of $3,250,000 in funding is available through this solicitation.";
var title = "Violence Against Women Act Multidisciplinary Team Response Program";
var created = "2018-08-21";
var posted = "2018-08-21";
var expired = "2018-09-21";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for grants supporting a comprehensive community-law enforcement response to drugs. Grants will be made with State Fiscal Year 2019 Community-Law Enforcement Partnership Deflection & Substance Use Disorder Treatment ACT funds. A total of $500,000 in funding is available through this solicitation for use over a six-month period. Grant requests are limited to a minimum of $20,000, and maximum of $80,000.";
var title = "SFY19 Community-Law Enforcement Partnership for Deflection & Substance Use Disorder Treatment Act";
var created = "2018-09-11";
var posted = "2018-09-11";
var expired = "2018-10-25";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for SFY19 Adult Redeploy Illinois planning grants. A total of $200,000 in SFY19 Adult Redeploy Illinois funding is available through this solicitation for use over a six-month period.";
var title = "Adult Redeploy Illinois Notice of Funding Opportunity: SFY19 Planning Grant";
var created = "2018-09-27";
var posted = "2018-09-27";
var expired = "2018-10-26";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority (ICJIA) administers the federal Residential Substance Abuse Treatment for State Prisoners Program (RSAT) in Illinois. RSAT assists state and local governments in the development and implementation of substance use disorder treatment programs in state and local correctional and detention facilities. Funds also are available to create and maintain community-based aftercare services for individuals after release from incarceration. A total of approximately $700,000 from FFY18 funds shall be made available for state and local government agencies, $75,000 of which must be reserved for local government agencies for corrections-based or jail-based substance use disorder treatment or aftercare programs that meet the criteria detailed in the notice of funding opportunity. Awards range from $75,000 to $150,000.";
var title = "FFY18 Residential Substance Abuse Treatment (RSAT) Program: Medication-Assisted Treatment";
var created = "2018-11-02";
var posted = "2018-11-02";
var expired = "2018-12-31";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for grants for services to families of homicide victims. Grants will be made with State Fiscal Year 2019 (SFY19) Death Penalty Abolition (DPA) funds. A total of $300,000 in funding\n    is available through this solicitation for use over a period of three months. Contingent on future appropriation and satisfactory performance $1,700,000 in SFY20 DPA funds may also be available through this opportunity.";
var title = "DEATH PENALTY ABOLITION FUND";
var created = "2019-01-11";
var posted = "2019-01-11";
var expired = "2019-02-12";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is posting this notice regarding grants for Trauma Responsive Schools. Grants will be made with state fiscal year 2019 bullying prevention funds. A total of $398,700 is available through June 30, 2019.";
var title = "Trauma Responsive Schools Notice of Funding Opportunity";
var created = "2019-01-14";
var posted = "2019-01-14";
var expired = "2019-02-15";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting applications for grants Services for Children\u2019s Advocacy Centers Program. Grants will be made with FFY17 Victims of Crime Act funds. A total of $7.1 million is available through this solicitation for use over a period of 12 months.";
var title = "Services for Children’s Advocacy Centers Program";
var created = "2019-01-29";
var posted = "2019-01-29";
var expired = "2019-03-03";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting applications for grants for the Services for Victims of Domestic Violence Program. Grants will be made with FFY17 Victims of Crime Act funds. A total of $21.3 million is available through this solicitation for use over a period of 12 months.";
var title = "Victims of Domestic Violence Program";
var created = "2019-01-29";
var posted = "2019-01-29";
var expired = "2019-03-03";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for grants for the Services for Victims of Sexual Assault Program. Grants will be made with Victims of Crime Act FFY17 funds. A total of $18,300,000 in funding is available through this solicitation for use over a period of 12 months.";
var title = "Victims of Sexual Assault Program";
var created = "2019-01-29";
var posted = "2019-01-29";
var expired = "2019-03-03";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for grants funding training of law enforcement personnel. Grants will be made with State Fiscal Year 2019 Death Penalty Abolition (DPA) funds. A total of $4.5 million in funding is available through this solicitation for use over a period of two months. Contingent on future appropriation and satisfactory performance, State Fiscal Year 2020 DPA funds also may be made available through this opportunity.";
var title = "Law Enforcement Personnel Training";
var created = "2019-01-29";
var posted = "2019-01-29";
var expired = "2019-03-18";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting proposals for grants funding local Illinois Family Violence Coordinating Council (IFVCC). Grants will be made with IFVCC state fiscal year 2020 funds. A total of $435,000 in funding is available through this solicitation for use over a period of 12 months.";
var title = "Illinois Family Violence Coordinating Council Notice of Funding Opportunity";
var created = "2019-03-06";
var posted = "2019-03-06";
var expired = "2019-04-05";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);








var description = "The Illinois Criminal Justice Information Authority is requesting applications for grants for the Services for Underserved Areas and Victim Groups Program. Grants will be made with FFY18 Violence Against Women Act funds. A total of $1.4 million is available through this solicitation for use over a period of 12 months.";
var title = "Violence Against Women Act (VAWA) Notice of Funding Opportunity Services for Underserved Areas & Victim Groups";
var created = "2019-03-29";
var posted = "2019-04-01";
var expired = "2019-04-30";
var type = "grant";
var status = "live";

/* harmony default export */ __webpack_exports__["default"] = ({
  name: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.camelCase(__WEBPACK_IMPORTED_MODULE_0__utilities___default.a.nameCheck(title)),
  pageData: {
    created: created,
    description: description,
    posted: posted,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  mounted: function mounted() {},

  metaInfo: {
    title: title,
    meta: [{
      vmid: "description",
      name: "description",
      content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description)
    }]
  },
  components: {
    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a
  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_StickySidebar__);


var description = 'The Illinois  Criminal Justice Information\n    Authority is requesting proposals for grants\n    supporting a comprehensive law enforcement response to drugs.\n     Grants will be  made with Federal Fiscal Year 2013-16\n     (FFY13-16) Edward Byrne Memorial Justice  Assistance Grant (JAG) funds.\n     A total of $4.2 million in funding in three  program categories\n     is available through this solicitation for use over a period\n      of 12 months. Minimum and maximum grant requests vary by the program  category.';
var title = "JAG Comprehensive Law Enforcement Response to Drugs";
var created = '2017-03-31';
var expired = '2017-05-30';
var type = 'grant';
var status = 'live';






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'JAGComprehensiveLawEnforcementResponseToDrugs',
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a,
    SmoothScroll: __WEBPACK_IMPORTED_MODULE_2__components_SmoothScroll___default.a,
    StickySidebar: __WEBPACK_IMPORTED_MODULE_3__components_StickySidebar___default.a

  },
  mounted: function mounted() {},
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = 'The Illinois Criminal Justice Information Authority is requesting applications for federal Victims of Crime Act grants to support legal assistance programs. Approximately $6 million is available for this funding opportunity.';
var title = "NOFO VOCA Legal Assistance Grant";
var created = '2017-02-08';
var expired = '2017-04-07';
var type = 'grant';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NOFOVOCALegalAssistance',
  pageData: {
    created: created,
    description: description,
    expired: expired,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },
  data: function data() {
    return {
      title: title,
      expired: expired
    };
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utilities__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PageHeader__);


var description = '\n<p>Announcing the public release of the Catalog of State Financial Assistance (CSFA) and the Grantee Compliance Enforcement System.</p>\n<p>\n<strong>The Catalog of State Financial Assistance (CSFA)</strong> is\nrequired by GATA and provides a single,\nauthoritative, statewide, comprehensive source\nof financial assistance program information.</p>\n\n<p><strong>The Grantee Compliance Enforcement System</strong> drives grantee compliance with grant requirements.  This system promotes cross-agency information sharing to improve risk\nassessment processes and enhance fiscal management transparency. </p>\n\n<p><strong>Indirect Cost Rate Negotiation for Illinois Grantees</strong>. The Governor\u2019s Office of Management and Budget has contracted with Crowe Horwath to negotiate Indirect Cost Rate Agreements with Illinois Grantees.</p>\n\n';

var title = "IMPORTANT ANNOUNCEMENT TO ALL STATE AGENCIES AND GRANTEE ORGANIZATIONS";
var created = '2017-04-4';
var type = 'news';
var status = 'live';



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Sample0',
  pageData: {
    created: created,
    description: description,
    title: title,
    type: type,
    status: status
  },
  metaInfo: {
    title: title,
    meta: [{ vmid: 'description', name: 'description', content: __WEBPACK_IMPORTED_MODULE_0__utilities___default.a.stripTags(description) }]
  },
  components: {

    PageHeader: __WEBPACK_IMPORTED_MODULE_1__components_PageHeader___default.a

  },
  data: function data() {
    return {
      title: title
    };
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tether__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tether___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tether__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_base_scss__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scss_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__scss_base_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_router__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__routes_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feeds__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_stash__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_stash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_stash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__googleAnalytics_js__ = __webpack_require__(154);




window._ = window.lodash = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a;





__WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_meta___default.a);



__WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_stash___default.a);

var SocialSharing = __webpack_require__(163);
__WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */].use(SocialSharing);




var router = new __WEBPACK_IMPORTED_MODULE_5_vue_router__["a" /* default */]({
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

    linkActiveClass: 'active',
    base: __dirname,
    routes: __WEBPACK_IMPORTED_MODULE_6__routes_js__["a" /* default */]
});


window['NODE_ENV'] = "production";
if (NODE_ENV === 'production') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__googleAnalytics_js__["a" /* default */])('UA-10798495-20', 'ICJIA GATA | ', router);
}

var vue = new __WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */]({
    el: '#app',
    router: router,

    data: { store: __WEBPACK_IMPORTED_MODULE_8__feeds__["a" /* default */] },
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_11__App___default.a }
}).$mount('#app');
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = {
  meta: [{ charset: "utf-8" }, { name: "viewport", content: "width=device-width, initial-scale=1" }, {
    name: "google-site-verification",
    content: "FTf_VAGmkX6nvkYTl9S4vtCK-1Dy3N9kyOteR0poBE8"
  }, {
    property: "og:title",
    content: "ICJIA Grant Accountability & Transparency Act"
  }, {
    property: "og:site_name",
    content: "ICJIA Grant Accountability & Transparency Act"
  }, { property: "og:url", content: "https://grants.icjia.cloud" }, {
    property: "og:description",
    content: "ICJIA Grant Accountability & Transparency Act. "
  }, { property: "fb:app_id", content: "963916987072512" }, { property: "og:type", content: "article" }, { property: "og:locale", content: "en_US" }, { property: "article:author", content: "https://www.facebook.com/ICJIA" }, {
    property: "og:image",
    content: "http://www.icjia.state.il.us/assets/img/icjia-default.jpg"
  }],
  script: [],
  link: [{
    rel: "icon",
    type: "image/png",
    sizes: "192x192",
    href: "/static/icons/android-icon-192x192.png?v=1440170181"
  }, {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "/static/icons/favicon-32x32.png?v=1440170181"
  }, {
    rel: "icon",
    type: "image/png",
    sizes: "96x96",
    href: "/static/icons/favicon-96x96.png?v=1440170181"
  }, {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "/static/icons/favicon-16x16.png?v=1440170181"
  }],

  title: "ICJIA Grant Accountability & Transparency Act",

  titleTemplate: "ICJIA GATA | %s"
};

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 31,
	"./af.js": 31,
	"./ar": 38,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 38,
	"./az": 39,
	"./az.js": 39,
	"./be": 40,
	"./be.js": 40,
	"./bg": 41,
	"./bg.js": 41,
	"./bm": 42,
	"./bm.js": 42,
	"./bn": 43,
	"./bn.js": 43,
	"./bo": 44,
	"./bo.js": 44,
	"./br": 45,
	"./br.js": 45,
	"./bs": 46,
	"./bs.js": 46,
	"./ca": 47,
	"./ca.js": 47,
	"./cs": 48,
	"./cs.js": 48,
	"./cv": 49,
	"./cv.js": 49,
	"./cy": 50,
	"./cy.js": 50,
	"./da": 51,
	"./da.js": 51,
	"./de": 54,
	"./de-at": 52,
	"./de-at.js": 52,
	"./de-ch": 53,
	"./de-ch.js": 53,
	"./de.js": 54,
	"./dv": 55,
	"./dv.js": 55,
	"./el": 56,
	"./el.js": 56,
	"./en-au": 57,
	"./en-au.js": 57,
	"./en-ca": 58,
	"./en-ca.js": 58,
	"./en-gb": 59,
	"./en-gb.js": 59,
	"./en-ie": 60,
	"./en-ie.js": 60,
	"./en-nz": 61,
	"./en-nz.js": 61,
	"./eo": 62,
	"./eo.js": 62,
	"./es": 65,
	"./es-do": 63,
	"./es-do.js": 63,
	"./es-us": 64,
	"./es-us.js": 64,
	"./es.js": 65,
	"./et": 66,
	"./et.js": 66,
	"./eu": 67,
	"./eu.js": 67,
	"./fa": 68,
	"./fa.js": 68,
	"./fi": 69,
	"./fi.js": 69,
	"./fo": 70,
	"./fo.js": 70,
	"./fr": 73,
	"./fr-ca": 71,
	"./fr-ca.js": 71,
	"./fr-ch": 72,
	"./fr-ch.js": 72,
	"./fr.js": 73,
	"./fy": 74,
	"./fy.js": 74,
	"./gd": 75,
	"./gd.js": 75,
	"./gl": 76,
	"./gl.js": 76,
	"./gom-latn": 77,
	"./gom-latn.js": 77,
	"./gu": 78,
	"./gu.js": 78,
	"./he": 79,
	"./he.js": 79,
	"./hi": 80,
	"./hi.js": 80,
	"./hr": 81,
	"./hr.js": 81,
	"./hu": 82,
	"./hu.js": 82,
	"./hy-am": 83,
	"./hy-am.js": 83,
	"./id": 84,
	"./id.js": 84,
	"./is": 85,
	"./is.js": 85,
	"./it": 86,
	"./it.js": 86,
	"./ja": 87,
	"./ja.js": 87,
	"./jv": 88,
	"./jv.js": 88,
	"./ka": 89,
	"./ka.js": 89,
	"./kk": 90,
	"./kk.js": 90,
	"./km": 91,
	"./km.js": 91,
	"./kn": 92,
	"./kn.js": 92,
	"./ko": 93,
	"./ko.js": 93,
	"./ky": 94,
	"./ky.js": 94,
	"./lb": 95,
	"./lb.js": 95,
	"./lo": 96,
	"./lo.js": 96,
	"./lt": 97,
	"./lt.js": 97,
	"./lv": 98,
	"./lv.js": 98,
	"./me": 99,
	"./me.js": 99,
	"./mi": 100,
	"./mi.js": 100,
	"./mk": 101,
	"./mk.js": 101,
	"./ml": 102,
	"./ml.js": 102,
	"./mr": 103,
	"./mr.js": 103,
	"./ms": 105,
	"./ms-my": 104,
	"./ms-my.js": 104,
	"./ms.js": 105,
	"./mt": 106,
	"./mt.js": 106,
	"./my": 107,
	"./my.js": 107,
	"./nb": 108,
	"./nb.js": 108,
	"./ne": 109,
	"./ne.js": 109,
	"./nl": 111,
	"./nl-be": 110,
	"./nl-be.js": 110,
	"./nl.js": 111,
	"./nn": 112,
	"./nn.js": 112,
	"./pa-in": 113,
	"./pa-in.js": 113,
	"./pl": 114,
	"./pl.js": 114,
	"./pt": 116,
	"./pt-br": 115,
	"./pt-br.js": 115,
	"./pt.js": 116,
	"./ro": 117,
	"./ro.js": 117,
	"./ru": 118,
	"./ru.js": 118,
	"./sd": 119,
	"./sd.js": 119,
	"./se": 120,
	"./se.js": 120,
	"./si": 121,
	"./si.js": 121,
	"./sk": 122,
	"./sk.js": 122,
	"./sl": 123,
	"./sl.js": 123,
	"./sq": 124,
	"./sq.js": 124,
	"./sr": 126,
	"./sr-cyrl": 125,
	"./sr-cyrl.js": 125,
	"./sr.js": 126,
	"./ss": 127,
	"./ss.js": 127,
	"./sv": 128,
	"./sv.js": 128,
	"./sw": 129,
	"./sw.js": 129,
	"./ta": 130,
	"./ta.js": 130,
	"./te": 131,
	"./te.js": 131,
	"./tet": 132,
	"./tet.js": 132,
	"./th": 133,
	"./th.js": 133,
	"./tl-ph": 134,
	"./tl-ph.js": 134,
	"./tlh": 135,
	"./tlh.js": 135,
	"./tr": 136,
	"./tr.js": 136,
	"./tzl": 137,
	"./tzl.js": 137,
	"./tzm": 139,
	"./tzm-latn": 138,
	"./tzm-latn.js": 138,
	"./tzm.js": 139,
	"./uk": 140,
	"./uk.js": 140,
	"./ur": 141,
	"./ur.js": 141,
	"./uz": 143,
	"./uz-latn": 142,
	"./uz-latn.js": 142,
	"./uz.js": 143,
	"./vi": 144,
	"./vi.js": 144,
	"./x-pseudo": 145,
	"./x-pseudo.js": 145,
	"./yo": 146,
	"./yo.js": 146,
	"./zh-cn": 147,
	"./zh-cn.js": 147,
	"./zh-hk": 148,
	"./zh-hk.js": 148,
	"./zh-tw": 149,
	"./zh-tw.js": 149
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;

/***/ }),
/* 305 */,
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(297)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(263)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(363),
  /* scopeId */
  "data-v-33d722cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(301)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  "data-v-f672dae2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(300)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(373),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(291)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  "data-v-a085f130",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(262)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(362),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(284)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-5c7df32a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  "data-v-595d8578",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(371),
  /* scopeId */
  "data-v-4a25b014",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(286)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(287)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(372),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(295)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(257)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(357),
  /* scopeId */
  "data-v-17fe16e3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  "data-v-634f9ccf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(255)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(355),
  /* scopeId */
  "data-v-11d3a598",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(261)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(361),
  /* scopeId */
  "data-v-29e144aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(369),
  /* scopeId */
  "data-v-4284c281",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(298)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(398),
  /* scopeId */
  "data-v-d2b67512",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(265)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(365),
  /* scopeId */
  "data-v-3efc0356",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(285)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-72102666",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(258)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(358),
  /* scopeId */
  "data-v-1f0da1cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(251)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(351),
  /* scopeId */
  "data-v-08e9f2d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(253)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(353),
  /* scopeId */
  "data-v-0d749aa3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(375),
  /* scopeId */
  "data-v-528858ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(366),
  /* scopeId */
  "data-v-42251668",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(299)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(399),
  /* scopeId */
  "data-v-dce0456a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  "data-v-5a0b6e7f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(296)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  "data-v-c90586d6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(264)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(205),
  /* template */
  __webpack_require__(364),
  /* scopeId */
  "data-v-3d6c4b78",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(290)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  "data-v-86032b2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(254)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(354),
  /* scopeId */
  "data-v-11564ada",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(259)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(359),
  /* scopeId */
  "data-v-23b632e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(292)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  "data-v-a0d9b604",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-6ff82e8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(256)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(356),
  /* scopeId */
  "data-v-176d746e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(294)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  "data-v-c4212a86",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(289)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  "data-v-7ec04dfc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(252)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(352),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(260)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(360),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(293)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(393),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act (VOCA) Victim\n              Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals\n              convicted of federal crimes and allocated to states by formula by the Office for Victims of Crime of the U.S.\n              Department of Justice. In federal fiscal year 2016, Illinois received a VOCA award of $87 million.")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are required to\n              allocate a minimum of 10 percent of funds received for services to each of the following: victims of sexual\n              assault, domestic violence, child abuse, and underserved victims of violent crime. VOCA funds may not be used\n              to supplant or replace state and local funds that would otherwise be available for crime victim services and\n              must be used to develop new projects or expand existing projects.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Sexual Assault, 100 N. 16th Street, Springfield,\n              Illinois, 62703.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("This Notice of Funding Opportunity and application materials were provided to the Illinois Coalition Against\n              Sexual Assault.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/20180205LeadEntitySA/VOCA Lead Entity NOFO - SA - Final -5.0.docx"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $16.3 million in FFY16 VOCA funding is available through this solicitation.")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July 1, 2018, through September\n              30, 2019.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to ICJIA monthly fiscal and quarterly data reports.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit:\n              "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("http://ojp.gov/ovc/about/victimsfund.html")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Last year, ICJIA completed a statewide assessment of victim services in Illinois. The report was presented to\n              the Ad Hoc Victim Services Committee for consultation and coordination with other state agencies and victim\n              stakeholder groups. The final report’s recommendations were approved by the ICJIA Board in January 2017. These\n              recommendations outline a comprehensive plan to address victims’ needs in Illinois and are reflected in this\n              funding opportunity Please see the following link to access the report and recommendations:\n              "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report")]), _vm._v(". The Ad Hoc Victim\n              Services Committee made a priority of strengthening and expansion of core services for victims of crime. To\n              fulfill this priority, ICJIA made available $17.3 million in VOCA grant funding for core services and related\n              support costs for victims of domestic violence. These funds will be made available to the Illinois Coalition\n              Against Domestic Violence. To fulfill this priority, ICJIA made available $16.3 million in VOCA grant funding\n              for core services and related support costs for victims of sexual assault. These funds are available to the\n              Illinois Coalition Against Sexual Assault.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at\n              "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Friday, March 09, 2018.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Wednesday, February 07, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Application deadline")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., Friday, March 09, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("May 25, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Program start date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("July 1, 2018")])])])])])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', [_c('h1', {
    staticClass: "h2 grant-main-head text-center"
  }, [_vm._v("FFY13-16 Edward Byrne Memorial Justice  Assistance Grant Program\n  Comprehensive Law  Enforcement Response to Drugs")]), _vm._v(" "), _c('p', [_vm._v("The Illinois  Criminal Justice Information\n  Authority is requesting proposals for grants\n  supporting a comprehensive law enforcement response to drugs.\n   Grants will be  made with Federal Fiscal Year 2013-16\n   (FFY13-16) Edward Byrne Memorial Justice  Assistance Grant (JAG) funds.\n   A total of $4.2 million in funding in three  program categories\n   is available through this solicitation for use over a period\n    of 12 months. Minimum and maximum grant requests vary by the program  category.\n\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head first",
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "additional-requirements"
    }
  }, [_vm._v("Additional  Requirements: Law Enforcement Task Forces ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants:")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("Application Materials:")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head ",
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head ",
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head ",
    attrs: {
      "id": "contact"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "technical-assistance"
    }
  }, [_vm._v("Required Technical  Assistance Session")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_vm._m(12), _vm._v(" "), _c('p', [_vm._v("View a webinar describing the FFY13-16 Edward Byrne Memorial Justice Assistance Grant Program Comprehensive Law Enforcement Response to Drugs: Notice of Funding Opportunity:")]), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/ZkHCWo8Qs3k",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("View a webinar describing the FFY13-16 Edward Byrne Memorial Justice Assistance Grant Program Comprehensive Law Enforcement Response to Drugs: Category 1 / Law Enforcement – Led Diversion and Deflections Models:")]), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/kLlub8J6DXo",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', [_vm._v("View a webinar describing the FFY13-16 Edward Byrne Memorial Justice Assistance Grant Program Comprehensive Law Enforcement Response to Drugs: Category 2 / Multi-Jurisdictional Drug Prosecution Units ")]), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/c5nr7n3Aqgw",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', [_vm._v("View a webinar describing the FFY13-16 Edward Byrne Memorial Justice Assistance Grant Program Comprehensive Law Enforcement Response to Drugs: Category 3 / Multi-Jurisdictional Large-Scale Drug Trafficking Enforcement:")]), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/O8d8gzCEXdY",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)], 1), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "letter-of-intent"
    }
  }, [_vm._v("Letter of Intent:")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "mandatory-webinars"
    }
  }, [_vm._v("Mandatory webinars")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting:")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head",
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(26)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#additional-requirements"
    }
  }, [_vm._v("Additional Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility-information"
    }
  }, [_vm._v("Eligibility Information")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#available-funds"
    }
  }, [_vm._v("Available Funds")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#period-of-performance"
    }
  }, [_vm._v("Period of Performance")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact Information")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#technical-assistance"
    }
  }, [_vm._v("Required Technical Assistance Session")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#letter-of-intent"
    }
  }, [_vm._v("Letter of Intent")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#mandatory-webinars"
    }
  }, [_vm._v("Mandatory Webinars")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#required-documents"
    }
  }, [_vm._v("Required Documents")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#faqs"
    }
  }, [_vm._v("FAQs")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Application  deadline: May 30, 2017")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/JAG_Drug_NOFO_033017.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n      Read the Notice of Funding Opportunity   "), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" \n      "), _c('br'), _c('br'), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Applicants  may request funding under one or more categories of funding. ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Category 1: Law Enforcement Deflection and  Diversion Programs ")])]), _vm._v(" "), _c('p', [_vm._v("To be  eligible for funding, diversion/deflection programs must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Be  run by a local law enforcement agency, county sheriff’s department, or a  multi-jurisdictional cooperative law enforcement unit for which an Implementing  Agency has been identified. ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("An  Implementing Agency in this context is a government agency which will, on  behalf of the multi-jurisdictional unit, apply for the grant, enter into the  inter-governmental grant agreement with the Authority, accept and account for  grant funds, and meet all Authority reporting and compliance requirements.")])]), _vm._v(" "), _c('li', [_vm._v("Have  developed a plan to make potential clients and referral sources aware of the  services available.")]), _vm._v(" "), _c('li', [_vm._v("Have  a plan to coordinate program activities with community agencies in the service  area, including substance abuse treatment, medical care and supportive service  providers as well as relevant government agencies.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Category 2: Multi-jurisdictional drug  prosecution units ")])]), _vm._v(" "), _c('p', [_vm._v("To be  eligible for funding, drug prosecution programs must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Be  run by a county state’s attorney’s office or a county office of the state’s  attorney’s appellate prosecutor.")]), _vm._v(" "), _c('li', [_vm._v("Have  a written statement demonstrating collaborative involvement with one or more  drug trafficking enforcement unit, as defined in Category 3.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Category 3: Multi-Jurisdictional Large-Scale Drug  Trafficking Enforcement ")])]), _vm._v(" "), _c('p', [_vm._v("To be eligible for  funding, drug trafficking enforcement programs must: "), _c('strong')]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Be  run by a cooperative unit comprised of three or more law enforcement agencies  for which an Implementing Agency has been identified.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("An  Implementing Agency in this context is a government agency which will, on  behalf of the multi-jurisdictional unit, apply for the grant; enter into the  inter-governmental grant agreement with the Authority; accept and account for  grant funds; and meet all Authority reporting and compliance requirements.")])]), _vm._v(" "), _c('li', [_vm._v("Have  a written interagency agreement between all participating agencies defining  activities and responsibilities.")]), _vm._v(" "), _c('li', [_vm._v("Have  a prosecutor statement demonstrating collaborative involvement with the member  agencies toward meeting the unit’s goals and objectives.")]), _vm._v(" "), _c('li', [_vm._v("Have  a plan of intelligence sharing via computerized networking.")]), _vm._v(" "), _c('li', [_vm._v("Have  a plan for forfeiture sharing, including how funds will be used. ")]), _vm._v(" "), _c('li', [_vm._v("Have  a commitment for staffing by all participating agencies.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("All members  of a law enforcement task force supported with these funds who is a task force  commander, agency executive, task force officer, or other task force member of  equivalent rank, will complete required online internet-based task force  training once during the life of the grant award. The training is provided free  of charge online through the U.S. Bureau of Justice Assistance Center for Task Force  Integrity and Leadership ("), _c('a', {
    attrs: {
      "href": "http://www.ctfli.org"
    }
  }, [_c('strong', [_vm._v("www.ctfli.org")])]), _vm._v("). ")]), _vm._v(" "), _c('p', [_vm._v("This  training addresses task force effectiveness as well as other key issues  including privacy and civil liberties/rights, task force performance  measurement, personnel selection, and task force oversight and accountability. ")]), _vm._v(" "), _c('p', [_vm._v("In addition,  the Authority will require the submission of task force personnel rosters that  include training course completion certificates. Go to "), _c('a', {
    attrs: {
      "href": "http://www.ctfli.org"
    }
  }, [_c('strong', [_vm._v("www.ctfli.org")])]), _vm._v(" for more information. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("  Agencies  must be pre-qualified through the Grant Accountability and Transparency Act  (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_c('strong', [_vm._v("www.grants.illinois.gov")])]), _vm._v(", to become eligible to  apply for an award.  Applicants must have  completed the GATA pre-qualification process and received approval of their Internal  Control Questionnaire (ICQ) by the date of application to be considered for  funding.   Applications from agencies that have not  received ICQ approval will not be reviewed."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Eligible applicants are  limited to Illinois municipalities, counties and state agencies. Private and  non-profit entities are not eligible to apply."), _c('br')]), _vm._v(" "), _c('p', [_vm._v("Agencies  may apply for funding in more than one program category."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/JAG_Drug_NOFO_033017.pdf"
    }
  }, [_c('strong', [_vm._v("Click here")])]), _vm._v(" for the JAG Comprehensive  Law Enforcement Response to Drugs Grant Application"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Completed application  materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2017DrugNOFO@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("CJA.2017DrugNOFO@Illinois.gov")])]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., May  30, 2017,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by  mail, fax, or in-person. Incomplete applications will not be reviewed. Late  submissions will not be reviewed."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Grants available through  this funding opportunity are a portion of a Federal Fiscal Year 2013-16 Justice  Assistance Grant award from the U.S. Department of Justice Office of Justice  Programs Bureau of Justice Assistance to the Illinois Criminal Justice  Information Authority. A minimum of $4.2 million dollars will be made available  through this funding opportunity. Minimum and maximum allowable grant  requests vary by program category. "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Funding is available for  the period of "), _c('strong', [_vm._v("October 1, 2017, through September 30, 2018")]), _vm._v(". Based on  program performance and fund availability, the Authority may recommend  allocation of funding to support an additional 24 months. "), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Gregory Stevens"), _c('br'), _vm._v("\n  Program Administrator"), _c('br'), _vm._v("\n  Illinois Criminal Justice Information Authority"), _c('br'), _vm._v("\n  300 West Adams, Suite 200"), _c('br'), _vm._v("\n  Chicago, IL 60606"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:Gregory.Stevens@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("Gregory.Stevens@Illinois.gov")])]), _c('br'), _vm._v("\n  312-793-0890"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "ffy13-16-edward-byrne-memorial-justice-assistance-grant-program-comprehensive-law-enforcement-response-to-drugs-administrative-guidelines-all-funding-categories"
    }
  }, [_c('strong', [_vm._v(" Administrative Guidelines – All Funding Categories")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/JAG drug NOFO All Categories Admin guidelines Power Point.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Download All Funding Categories PowerPoint Presentation "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/Example budget for JAG drug NOFO webinar.xlsx",
      "target": "_blank"
    }
  }, [_vm._v("Download Example Budget")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "ffy13-16-edward-byrne-memorial-justice-assistance-grant-program-comprehensive-law-enforcement-response-to-drugs-category-1-law-enforcement-led-diversion-and-deflections-models"
    }
  }, [_c('strong', [_vm._v("  Category 1 / Law Enforcement – Led Diversion and Deflections Models")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/JAG drug NOFO Category 1 program guidelines Power Point.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Download Categories 1 PowerPoint Presentation  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "ffy13-16-edward-byrne-memorial-justice-assistance-grant-program-comprehensive-law-enforcement-response-to-drugs-category-2-multi-jurisdictional-drug-prosecution-units"
    }
  }, [_c('strong', [_vm._v("  Category 2 / Multi-Jurisdictional Drug Prosecution Units")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/JAG drug NOFO Category 2 program guidelines Power Point.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Download Category 2 PowerPoint Presentation  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "ffy13-16-edward-byrne-memorial-justice-assistance-grant-program-comprehensive-law-enforcement-response-to-drugs-category-3-multi-jurisdictional-large-scale-drug-trafficking-enforcement"
    }
  }, [_c('strong', [_vm._v("  Category 3 / Multi-Jurisdictional Large-Scale Drug Trafficking Enforcement:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/JAG drug NOFO Category 3 program guidelines Power Point.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Download Category 3 PowerPoint Presentation  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Information provided  during these webinar recording will be unofficial and not binding on the state."), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Agencies interested in  submitting an application are asked to submit an online Letter of Intent by "), _c('strong', [_vm._v("11:59  p.m., April 28, 2016")]), _vm._v(". "), _c('br')]), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3470019/JAG-Comprehensive-Law-Enforcement-Response-to-Drugs-Program-Notice-of-Intent",
      "target": "_blank"
    }
  }, [_vm._v("Submit Notice of Intent")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Applicants are required to view the recorded ICJIA funding opportunity webinar regarding administrative guidelines and at least one program category webinar.  Applicants must certify their compliance with this requirement by emailing the certification to CJA.2017DrugNOFO@Illinois.gov no later than:")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("11:59 p.m. on Wednesday, May 24, 2017.")])]), _vm._v(" "), _c('p', [_vm._v("These webinars provide information specific to ICJIA and this funding opportunity.")]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/JAG_Drug_NOFO/webinar-cert.docx",
      "target": "_blank"
    }
  }, [_vm._v("Download webinar certification")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Task")])]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_c('strong', [_vm._v("Date")])])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("NOFO posted")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Friday,    March 31, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Applicant webinar registration deadline")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Thursday,    April 13, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Applicant webinar")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Monday,    April 17, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Letters of Intent due ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Friday,    April 28, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("NOFO question submission deadline")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Wednesday,    May 24, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_c('strong', [_vm._v("Applications due")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_c('strong', [_vm._v("11:59    p.m., Tuesday, May 30, 2017")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Notices of State Award released")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Monday, July 24, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Budget Committee review/approval of    recommended designations")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("September, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v("Target program start date")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', [_vm._v(" October 1, 2017")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Recipients must submit quarterly financial reports,  quarterly progress reports, final financial and progress reports, and, if  applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.  Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('p', [_vm._v("In addition, funded  programs will be required to report performance measures through the U.S.  Department of Justice Bureau of Justice Assistance portal at "), _c('a', {
    attrs: {
      "href": "https://bjapmt.ojp.gov"
    }
  }, [_c('strong', [_vm._v("https://bjapmt.ojp.gov")])]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("The following documents  must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2017DrugNOFO@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("CJA.2017DrugNOFO@Illinois.gov")])]), _vm._v(" by the 11:59 p.m.,  Tuesday, May 30, 2017, deadline for application review. Click the links below to  download copies.")]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "disc"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/2017_JAG_drug_NOFO_Uniform_Application_for_Grant_Assistance.docx"
    }
  }, [_c('strong', [_vm._v("Completed and signed Uniform State Grant Application ("), _c('em', [_vm._v("PDF")]), _vm._v(").")])])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Completed Program Narrative for selected program category ("), _c('em', [_vm._v("Word")]), _vm._v(")")]), _vm._v(": ")]), _vm._v(" "), _c('ul', {
    attrs: {
      "type": "circle"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/DD_program_narrative_033017.docx"
    }
  }, [_c('strong', [_vm._v("Diversion and Deflection Program Narrative")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/Law_Enforcement_Program_Narrative_033017.docx"
    }
  }, [_c('strong', [_vm._v("Law Enforcement Program Narrative")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/Prosecution_program_narrative_033017.docx"
    }
  }, [_c('strong', [_vm._v("Prosecution Program Narrative")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/2017_JAG_drug_NOFO_Blank_Budget.xlsx"
    }
  }, [_c('strong', [_vm._v("Completed Budget/Budget Narrative ("), _c('em', [_vm._v("Excel")]), _vm._v(")")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/Attachment_1_State_Map.pdf"
    }
  }, [_c('strong', [_vm._v("Attachment 1 State Map ("), _c('em', [_vm._v("PDF")]), _vm._v(")")]), _vm._v(".")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/Attachment_2_Map_of_Illinois_Appellate_Court_Districts.gif"
    }
  }, [_c('strong', [_vm._v("Attachment 2 Map of Illinois Appellate Court Districts")]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/2017_JAG_Drug_NOFO_Application_Documents.zip"
    }
  }, [_vm._v("Download ALL Application Documents (zip file)")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "faqs"
    }
  }, [_c('a', {
    staticClass: "btn btn-sm btn-primary btn-grant",
    staticStyle: {
      "text-transform": "uppercase",
      "margin-top": "30px",
      "margin-bottom": "15px",
      "font-family": "'Lato', sans-serif"
    },
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/JAG_Drug_NOFO/JAG_Drug_FAQs.pdf"
    }
  }, [_vm._v("Review frequently asked questions about the NOFO  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])])
}]}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for continuing support for nine current\n              prosecution, public defense and court programs currently supported with ICJIA-administered JAG funds. Grants\n              will be made with Federal Fiscal Year 2014-16 (FFY14-16) Edward Byrne Memorial Justice Assistance Grant (JAG)\n              funds. A total of $600,000 in funding is available through this solicitation for use over a period of 12 months.\n              Awards resulting from this NOFO will range from a minimum of $40,000 to a maximum of $225,000.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("Applicants may request funding for up to 12-months of program activity. Applications must:")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Support for program beyond this bridge funding is contingent on:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Applicants are required to set reasonable, quantifiable benchmarks for program performance by completing the\n              Goals, Objectives and Performance Metrics table for the requested project. As this opportunity may continue\n              support for a range of program types, the objectives and performance measures must be crafted to address the\n              unique activities of each project. Applicants should be cognizant of supplanting restrictions detailed in the\n              NOFO. However, all projects funded must address the common goal defined in the NOFO.")]), _vm._v(" "), _c('p', [_vm._v("Funded programs will be required to submit quarterly progress reports that will at a minimum include these objectives.\n              Applicants may list additional support service objectives for the program.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants are limited to counties and State agencies requesting continuing funding for prosecution,\n              public defense, and courts programs currently supported by ICJIA-administered JAG funds. The eligible programs\n              are:\n            ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/20180227JAGoperations/JAGoperationsNOFO.pdf"
    }
  }, [_vm._v("Download the Notice of Funding Opportunity")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $600,000 in funding is available through this solicitation. Funding minimum and maximum values are\n              based on the population served, according to the following standards:")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Greg Stevens")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "required-technical-assistance-recordings"
    }
  }, [_vm._v("Required Technical Assistance Recordings")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notices-of-intent"
    }
  }, [_vm._v("Notices of Intent")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress\n              reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.\n              Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', [_vm._v("Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly\n              with any Authority employee other than the respondent of this email address. Only written answers to questions\n              shall be binding on the state.\n            ")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., April 16, 2018.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Demonstrate the effectiveness of the current program; and")]), _vm._v(" "), _c('li', [_vm._v("Include the agency’s active participation in a data-driven planning process that objectively assesses jurisdictional\n                or agency needs.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Completion of a planning component.")]), _vm._v(" "), _c('li', [_vm._v("Demonstrated ongoing need for the program.")]), _vm._v(" "), _c('li', [_vm._v("Satisfactory performance.")]), _vm._v(" "), _c('li', [_vm._v("Availability of JAG funds.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,\n              "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA\n              pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of\n              application to be considered for funding. Applications from agencies that have not received ICQ approval will\n              not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Office of the State Appellate Defender Rural Defense Program")]), _vm._v(" "), _c('li', [_vm._v("Office of the State Appellate Prosecutor Systemic Sentencing Appeals Program")]), _vm._v(" "), _c('li', [_vm._v("Office of the Cook County State’s Attorney Human Trafficking Program")]), _vm._v(" "), _c('li', [_vm._v("Office of the Cook County State’s Attorney Community Justice Center Program")]), _vm._v(" "), _c('li', [_vm._v("Office of the Cook County Public Defender DNA Program")]), _vm._v(" "), _c('li', [_vm._v("Office of the Cook County Public Defender Mitigation Program")]), _vm._v(" "), _c('li', [_vm._v("Winnebago County Youth Recovery Court")]), _vm._v(" "), _c('li', [_vm._v("Center of Excellence")]), _vm._v(" "), _c('li', [_vm._v("Coles/Cumberland Sex Offender Supervision program")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to\n              "), _c('a', {
    attrs: {
      "href": "mailto:CJA.JAGNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.JAGNOFO@Illinois.gov")]), _vm._v(" by\n              "), _c('strong', [_vm._v("11:59 p.m., April 16, 2018")]), _vm._v(", to be considered for funding. Proposals will not be accepted by mail,\n              fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Population of Area Served")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Minimum Award")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Maximum Award")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1 - 499,999")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$40,000")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$75,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("500,000 - 1,499,999")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$40,000")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$125,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1,500,000 - 4,999,999")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$40,000")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$175,000")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("5,000,000 +")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$40,000")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$225,000")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Funding is available for the period of\n              "), _c('strong', [_vm._v("July 1, 2018 through June 30, 2019")]), _vm._v(". Based on program performance and fund availability, the Authority\n              may recommend allocation of funding to support an additional 24 months.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Gregory.Stevens@Illinois.gov"
    }
  }, [_vm._v("Gregory.Stevens@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Technical assistance recordings providing additional information regarding this funding opportunity will be available\n              for viewing beginning at\n              "), _c('strong', [_vm._v("1:30 p.m. on February 21, 2018")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/r9pYxP_E0VI"
    }
  }, [_vm._v("Recording 1: JAG Courts NOFO Programmatic Technical Assistance Recording (16:41)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("Recording 2: General Requirements (11:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("Recording 3: GATA Budget (19:03)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Recording 4: Indirect Costs (6:18)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Recording 5: Prior Approvals (6:05)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in submitting an application are asked to submit an online Letter of Intent by\n              "), _c('strong', [_vm._v("11:59 p.m., March 28, 2018")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/4201907/JAG-Operational-Effectiveness-NOFO-Notice-of-Intent"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO Posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("February 28, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical assistance recordings available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 28, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notices of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 28, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 9, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., April 16, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Projected program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2018")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Department of Justice\n              Bureau of Justice Assistance portal at\n              "), _c('a', {
    attrs: {
      "href": "https://bjapmt.ojp.gov"
    }
  }, [_vm._v("https://bjapmt.ojp.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to\n              "), _c('a', {
    attrs: {
      "href": "mailto:CJA.JAGNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.JAGNOFO@Illinois.gov")]), _vm._v(" by the\n              "), _c('strong', [_vm._v("11:59 p.m., April 16, 2018")]), _vm._v(", deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180227JAGoperations/JAGoperationsAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180227JAGoperations/JAGoperationsNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180227JAGoperations/JAGoperationsBUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])]), _vm._v(" "), _c('li', [_vm._v("Agency Negotiated Indirect Cost Rate Agreement, if applicable (PDF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to\n              "), _c('a', {
    attrs: {
      "href": "mailto:CJA.JAGNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.JAGNOFO@Illinois.gov")]), _vm._v(" until\n              "), _c('strong', [_vm._v("11:59 p.m., April 9, 2018")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from applicants\n              and their responses are revised weekly.\n              "), _c('a', {
    attrs: {
      "href": "/static/grants/20180227JAGoperations/JAGoperationsResponseToApplicantQuestion.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(" Trauma Responsive Schools Notice of Funding Opportunity")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is posting this notice regarding grants for Trauma Responsive Schools. Grants will be made with state fiscal year 2019 bullying prevention funds. A total of $398,700 is available through June 30, 2019.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-design"
    }
  }, [_vm._v("Program Design")]), _vm._v(" "), _c('p', [_vm._v("The program design consists of an assessment and planning period to be completed by June 30, 2019. Developed by the National Child Traumatic Stress Network’s Treatment and Services Adaptation Center for Resilience, Hope, and Wellness in Schools and the\n    Center for School Mental Health, the Trauma Responsive Schools Implementation Assessment (TRS-IA) provides a comprehensive assessment that can also be used by schools to document immediate and long-term changes. Grantees will assist schools in completing\n    the assessment and developing an action plan with immediate and longer-term projects. Grantees may select to include additional tools in their assessment process. The action plan is due July 15, 2019 and must be approved by ICJIA by August 1, 2019.\n    Contingent on satisfactory performance, future appropriation, and approval of the action plan, grantees may receive continuation funding for implementation of the action plan resulting from this notice.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("Additional Program Services can include all or some of the following:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("This program design requires at least 5 years’ experience providing training and technical assistance to schools on bullying prevention, social and emotional learning, and/or trauma-aware climate initiatives. ICJIA assessed agencies with the experience\n    and capacity to meet the program design and requirements and has identified the entities below due to their experience and capacity to implement program requirements in a short time frame. The following entities are eligible to apply:")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this notice will not exceed $398,700.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of April 1-June 30, 2019. Based on program performance and fund availability, the Authority may recommend allocation of funding to support an additional 33 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns\n    may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Reshma Desai")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(12)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    attrs: {
      "id": "p-classtext-centerview-the-notice-of-funding-opportunity"
    }
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190115ResponsiveSchools/TraumaResponsiveSchoolsNOFO.pdf"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m. on February 15, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Identify multi-disciplinary school team members (team) for each proposed school.")]), _vm._v(" "), _c('li', [_vm._v("Train each team on the project’s purpose and the assessment tool.")]), _vm._v(" "), _c('li', [_vm._v("Develop a timeline that specifies team role/responsibilities to apply the assessment tool.")]), _vm._v(" "), _c('li', [_vm._v("Conduct the assessment for each proposed school.")]), _vm._v(" "), _c('li', [_vm._v("Using the assessment, develop an action plan for each proposed school that outlines key activities and responsible staff.")]), _vm._v(" "), _c('li', [_vm._v("Submit action plan to ICJIA for approval by July 15, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Informational sessions for students, families, teachers, administrators, school staff and/or additional partners on trauma’s impact on learning and the creation of trauma-sensitive school environments through this grant")]), _vm._v(" "), _c('li', [_vm._v("Data analysis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed\n    the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of period of performance start date, April 1, 2019 be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Center for Childhood Resilience at Ann & Robert H. Lurie Children’s Hospital of Chicago")]), _vm._v(" "), _c('li', [_vm._v("Center for Rural Health at Southern Illinois University")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.TraumaAwareSchool@Illinois.gov"
    }
  }, [_vm._v("CJA.TraumaAwareSchool@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., February 15, 2019")]), _vm._v(" to be considered for funding. Proposals will not be accepted\n    by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("January 15, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("February 15, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 28, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.TraumaAwareSchool@Illinois.gov"
    }
  }, [_vm._v("CJA.TraumaAwareSchool@Illinois.gov")]), _vm._v(" by the 11:59 p.m., February 15, 2019 for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190115ResponsiveSchools/TraumaResponsiveAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190115ResponsiveSchools/TraumaResponsivePROGRAMNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190115ResponsiveSchools/TraumaResponsiveSchoolsBUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.TraumaAwareSchool@Illinois.gov"
    }
  }, [_vm._v("CJA.TraumaAwareSchool@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:CJA.TraumaAwareSchool@Illinois.gov"
    }
  }, [_vm._v("CJA.TraumaAwareSchool@Illinois.gov")])])
}]}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-design"
    }
  }, [_vm._v("Program Design:")]), _vm._v(" "), _c('p', [_vm._v("Proposals for community-based violence prevention initiatives must target youth and young adults, including, but not limited to, those who are identified as being at heightened risk or those who engage in high risk behavior or violence. Proposals must\n    reflect the following mandatory elements:")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("ELIGIBILITY")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "ineligible-agencies"
    }
  }, [_vm._v("Ineligible agencies")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is not open to Cure Violence/CeaseFire (University of Illinois at Chicago) and its sub-grantees for similar activities for the same population. ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligible-agencies-and-gata-compliance"
    }
  }, [_vm._v("Eligible agencies and GATA compliance")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to public and not-for-profit entities providing community-based violence prevention and intervention services in the State of Illinois. ")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "pre-registration"
    }
  }, [_vm._v("Pre- Registration")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "approved-internal-control-questionnaire"
    }
  }, [_vm._v("Approved Internal Control Questionnaire")]), _vm._v(" "), _c('p', [_vm._v("The pre-qualification process also includes a financial and administrative risk assessment using an Internal Controls Questionnaire (ICQ). The ICQ must be approved through the GATA portal by the date of application submission in order for an application to be reviewed.  All applications will be pre-screened for completeness and ICQ submission. Applications from agencies that have not received SFY18 ICQ approval will not be reviewed.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("NOTICE OF INTENT")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application MUST complete an online Notice of Intent form by 11:59 p.m., August 8, 2017. ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The projected period of performance for awards resulting from this opportunity is October 1, 2017, through June 30, 2018. Contingent on future state fiscal year appropriations and satisfactory performance and available funds, ICJIA staff may recommend to its Board a maximum of two 12-month grants for each project.  Funding amounts in future years may be reduced depending on appropriation.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "mandatory-applicant-technical-assistance-video"
    }
  }, [_vm._v("Mandatory Applicant Technical Assistance Video")]), _vm._v(" "), _c('p', [_vm._v("Applicants must view the following mandatory pre-recorded videos.   Applicants must certify viewing these recordings. Information provided during this video will be unofficial and not binding on the State.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE:")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be required to submit to ICJIA quarterly fiscal and data reports.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("APPLICATION MATERIALS:")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required documents")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("UPDATES AND RESPONSES TO APPLICANT QUESTIONS")]), _vm._v(" "), _vm._m(18)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The State Fiscal Year 2018 (SFY18) Illinois State budget includes "), _c('span', [_vm._v("$")]), _vm._v("8,000,000 for Community-Based Violence Prevention and Intervention grants and administration. The Authority anticipates that approximately "), _c('span', [_vm._v("$")]), _vm._v("6,700,000 to $7,200,000 will be available under this Notice of Funding Opportunity. Grant awards resulting from this opportunity are projected to have a performance period of October 1, 2017 through June 30, 2018. Contingent on future state fiscal year appropriations and satisfactory performance, ICJIA staff may recommend to its Board a maximum of an additional two, 12-month grants for each project. Funding amounts in future years may be reduced depending on appropriation. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("Convene or expand an existing community coalition to engage service providers, governmental agencies (local and/or statewide agencies), law enforcement, faith-based, and general community members. The purpose of the Coalition is to ensure that\n            service providers and all potential participants are aware of violence prevention resources available in community; develop collaborative partnerships to ensure that clients’ immediate needs are met; and provide pro-social activities for the\n            community.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Grantee may assign a staff person to facilitate coalition meetings and activities. Meetings and/or activities should occur at least quarterly.")]), _vm._v(" "), _c('li', [_vm._v("If more than one applicant is funded in a community, the funded agencies should collaborate to create or expand an existing coalition.")]), _vm._v(" "), _c('li', [_vm._v("The Coalition should organize at least one community event during the grant period.")])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Educate public about program services through wide distribution and various types of program materials, public presentations and awareness events.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Implementation of at least one of the following direct service categories:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("Street Intervention/Interruption-Active Outreach and Engagement – Programs target at-risk youth and young adults in order to provide crisis intervention and de-escalation of high stress situations. Examples of promising programs include\n                    Richmond Comprehensive Homicide Initiative, CureViolence, Operation Ceasefire, and Safe Streets.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Counseling and Therapy- Developmentally and culturally appropriate therapeutic services provided by a mental health professional. Effective programs incorporate cognitive-behavioral therapy (CBT) and/or include contingency management approaches.\n                    These programs are often individual or family-based, such as Multi-systemic Therapy, Functional Family Therapy, Multidimensional Family Therapy, Aggression Replacement Training, Assisted Outpatient Treatment, and Coping Power Program,\n                    CBT for Trauma in Schools, Good Behavior Game.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Case Management- Supporting youth and their families in identifying and accessing resources. Individuals at risk for involvement in street-level violence can be difficult to engage in services. Case management approaches that actively\n                    engage youth and families (i.e., active reaching out, meeting youth/families in the home, community engagement) are more effective at long-term client retention and developing trust than more passive case management approaches (i.e.,\n                    requiring youth/families to meet in office locations).")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Youth Development - Engaging young people to develop their emotional, physical, social and intellectual selves. Program provides opportunities for youth to practice conflict resolution and prosocial life skills. Promising programs include\n                    the Life Skills Training (LST).")])])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Staffing Requirements- Any staff (or volunteers) that work directly with participants must be able to document they have received trauma-informed training. Any staff that provide counseling or therapy must be a licensed counselor, licensed social\n            worker, or equivalent.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Applicant must budget for one ICJIA-coordinated, full-day meeting in Chicago.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Applicant must comply with all prescribed assessment tools and reporting requirements.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("See the "), _c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(", for program design, staff, and training requirements.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All applicants must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov/portal"
    }
  }, [_vm._v("http://www.grants.illinois.gov/portal")]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications are performed, including a check of Debarred and Suspended status and good standing with the Illinois Secretary of State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Read the "), _c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(". ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applications are due at 11:59 p.m., Friday, August 18, 2017. Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: CJA.StateViolencePrevention@Illinois.gov"
    }
  }, [_vm._v("CJA.StateViolencePrevention@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3706158/Community-Based-Violence-Intervention-and-Prevention-NOFO-Notice-of-Intent"
    }
  }, [_vm._v("NOTICE OF INTENT ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("A total of up to "), _c('span', [_vm._v("$")]), _vm._v("7.2 million is available through this opportunity.  Applicants may request a minimum of "), _c('span', [_vm._v("$")]), _vm._v("100,000 to a maximum of $1,000,000 in funding for use over a nine-month period. Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "mailto: CJA.StateViolencePrevention@Illinois.gov"
    }
  }, [_vm._v("CJA.StateViolencePrevention@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., August 15, 2017. All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud/"
    }
  }, [_vm._v("https://grants.icjia.cloud/")]), _vm._v(". Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the state. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/8tc1Eaik7RI"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Programmatic Guidelines")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/lDFdUttzLhY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Administrative Introduction")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/FTeznPSc9_c"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Application and General Requirements")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/i9XB4EkYpe0"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Budget")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/lDFdUttzLhY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Indirect Costs")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zFh7otQwaJA"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Prior Approval Requirements")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3706762/Community-Based-Violence-Intervention-and-Prevention-NOFO-Technical-Assistance-Webinar-Certification"
    }
  }, [_vm._v("TECHNICAL ASSISTANCE VIDEO CERTIFICATION")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Release of NOFO and open application period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 19, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("August 8, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("August 15, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday, August 18, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("September 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Start Program Performance Period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("October 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: CJA.StateViolencePrevention@Illinois.gov"
    }
  }, [_vm._v("CJA.StateViolencePrevention@Illinois.gov")]), _vm._v(" by 11:59 p.m., August 18, 2017, to be considered for funding.  Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at "), _c('a', {
    attrs: {
      "href": "CJA.StateViolencePrevention@Illinois.gov"
    }
  }, [_vm._v("CJA.StateViolencePrevention@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application for each agency requesting funding. This document will need to be signed and scanned.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word that meets program requirements outlined in Section A. Applicant’s narrative must be submitted in Word and formatted in the posted Program Narrative. Application should be 20 pages maximum, not counting Goals/Objectives/Performance Measures, drafted in Times New Roman 12-point font and double-spaced with 1 inch margins. Please number pages.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative in Excel .")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("United States Internal Revenue Service 501(c)(3)determination letter for nonprofit organizations.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipApplication.docx"
    }
  }, [_vm._v("Uniform Application")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipNarrative.docx"
    }
  }, [_vm._v("Community-based Violence Intervention and Prevention Program Narrative")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipBudget.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Updates to NOFO materials, and questions from applicants and their responses are revised weekly. View them here: "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017ViolenceInterventionAndPrevention/CBvipResponseToApplicantQuestions.pdf"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])
}]}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('center', [_c('h2', {
    attrs: {
      "id": "death-penalty-abolition-fund"
    }
  }, [_vm._v("DEATH PENALTY ABOLITION FUND")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "view-the-notice-of-funding-opportunity"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190129lawEnforcement/DPAtrainingNOFO.pdf"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants funding training of law enforcement personnel. Grants will be made with State Fiscal Year 2019 Death Penalty Abolition (DPA) funds. A total of $4.5 million in funding is available through this solicitation for use over a period of two months. Contingent on future appropriation and satisfactory performance, State Fiscal Year 2020 DPA funds also may be made available through this opportunity.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("Through this funding opportunity, ICJIA is soliciting applications proposing to provide training to law enforcement personnel. Proposals must be received from the agencies that will be delivering all three of the following components of the training program:")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants must meet the following requirements:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $4.5 million in DPA funds are available through this NOFO. Awards totaling a minimum of $10,000 and maximum of $1 million will be made.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of May 1, 2019, to June 30, 2019. Based on program performance and future appropriation, ICJIA may recommend allocation of funding to support an additional 34 months of program activity. If appropriated, SFY20 funding will be available for the period of July 1, 2019, to June 30, 2020.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Greg Stevens")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "required-technical-assistance-recordings"
    }
  }, [_vm._v("Required Technical Assistance Recordings")]), _vm._v(" "), _c('p', [_vm._v("The following technical assistance recordings providing additional information regarding this funding opportunity are available for viewing.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notices-of-intent"
    }
  }, [_vm._v("Notices of Intent")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in applying are asked to submit an online Notice of Intent by 11:59 p.m., Thursday, February 7, 2019.")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', [_vm._v("Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the state.")])], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., March 18, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Planning and provision of training.")]), _vm._v(" "), _c('li', [_vm._v("Training supervision and oversight.")]), _vm._v(" "), _c('li', [_vm._v("Assessment of training effectiveness.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their State Fiscal Year 2019 Internal Control Questionnaire (ICQ) by the date of period of performance start date, May 1, 2019, to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Applicants must have experience providing training to law enforcement personnel.")]), _vm._v(" "), _c('li', [_vm._v("Applicants must be one of these types of agencies and institutions:"), _c('br'), _vm._v("\n        o Governmental Agencies, including state and local law enforcement agencies, and the Illinois Law Enforcement Training and Standards Board."), _c('br'), _vm._v("\n        o Educational Institutions."), _c('br'), _vm._v("\n        o Non-profit Agencies, including the Mobile Training Units.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAtrainingNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAtrainingNOFO@Illinois.gov")]), _vm._v(" by 11:59 p.m., Monday, March 18, 2019, to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Gregory.Stevens@Illinois.gov"
    }
  }, [_vm._v("Gregory.Stevens@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/Q7txdYclQi8"
    }
  }, [_vm._v("Recording 1: DPA Training NOFO Guidelines (12:27)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("Recording 2: General Requirements (11:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("Recording 3: GATA Budget (19:03)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Recording 4: Indirect Costs (6:18)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Recording 5: Prior Approvals (6:05)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_b2XTIkFxFR0807z"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO Posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("January 30, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical assistance recordings available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("January 30, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notices of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 7, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 11, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., March 18, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 18, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Projected program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("May 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAtrainingNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAtrainingNOFO@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., March 18, 2019")]), _vm._v(", deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129lawEnforcement/DPAtrainingAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129lawEnforcement/DPAtrainingNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129lawEnforcement/SFY19DPAtraining.BUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAtrainingNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAtrainingNOFO@Illinois.gov")]), _vm._v(" until "), _c('strong', [_vm._v("11:59 p.m., March 11, 2019")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from applicants and their responses are revised weekly. "), _c('a', {
    attrs: {
      "href": "/static/grants/20190129lawEnforcement/DPAservicesRESPONSEtoAPPLICANTQuestions.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "focus-areas"
    }
  }, [_vm._v("FOCUS AREAS:")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "child-abuse"
    }
  }, [_vm._v("Child Abuse:")]), _vm._v(" "), _c('p', [_vm._v("Crimes committed by a parent, immediate family member, person responsible for the child’s welfare, individual residing in the same home as the child, or a paramour of the child’s parent in violation of Illinois criminal statutes that result in physical or emotional harm to a minor.  Covered in this funding opportunity will be minor victims and adult survivors of child abuse as defined here.")]), _vm._v(" "), _c('p', [_vm._v("Child trafficking and involuntary servitude and bullying will not be addressed with this opportunity.")]), _vm._v(" "), _c('p', [_vm._v("Childhood exposure to violence is not the primary intent of this opportunity, however, services for such secondary victimization are allowable if the need is identified during the provision of child abuse services.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "financial-crime"
    }
  }, [_vm._v("Financial Crime:")]), _vm._v(" "), _c('p', [_vm._v("Identity theft  or the financial exploitation of elders and persons with disabilities.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "impaired-driving"
    }
  }, [_vm._v("Impaired Driving:")]), _vm._v(" "), _c('p', [_vm._v("Impaired driving occurs when a driver operates a motor vehicle while under the influence of alcohol, drugs, or other intoxicating compounds.  This funding opportunity serves victims of motor vehicle accidents caused by impaired drivers and victims of motor vehicle accidents caused by drivers using electronic communication or video devices while driving which result in death or great bodily harm.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("ELIGIBILITY")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "ineligible-agencies"
    }
  }, [_vm._v("Ineligible agencies")]), _vm._v(" "), _c('p', [_vm._v("The following types of agencies are NOT eligible for this funding opportunity:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "eligible-agencies-and-gata-compliance"
    }
  }, [_vm._v("Eligible agencies and GATA compliance")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to Illinois public agencies and non-profits that have completed the GATA pre-qualification process and received approval of their ICQ from a state cognizant agency by the date of application.  In addition, applicants must meet the VOCA eligibility criteria listed on pages 23-25 of the Notice of Funding Opportunity.")]), _vm._v(" "), _c('p', [_vm._v("Please note applicants must Pre-register and obtain an approved Internal Control Questionnaire")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "pre-registration"
    }
  }, [_vm._v("Pre- Registration")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "approved-internal-control-questionnaire"
    }
  }, [_vm._v("Approved Internal Control Questionnaire")]), _vm._v(" "), _c('p', [_vm._v("The pre-qualification process also includes a financial and administrative risk assessment using an Internal Controls Questionnaire (ICQ). The ICQ must be submitted through the GATA portal and approved by a State cognizant agency by the date of application submission in order for an application to be reviewed.  All applications will be pre-screened for completeness and ICQ approval. Applications from agencies that do not have an approved ICQ will not be reviewed.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "color": "#fff !important",
      "text-decoration": "none",
      "margin-top": "10px"
    },
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/UNMETNEEDSNOFOwattachments.pdf"
    }
  }, [_vm._v("Read the Notice of Funding Opportunity  "), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application MUST complete an online Notice of Intent form by 11:59 p.m., July 7, 2017.")]), _vm._v(" "), _c('center', [_c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "color": "#fff !important",
      "text-decoration": "none",
      "margin-top": "30px"
    },
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3570808/VOCA-Child-Abuse-Financial-Crime-and-Impaired-Driving-Notice-of-Intent"
    }
  }, [_vm._v("SUBMIT NOTICE OF INTENT  "), _c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The projected period of performance for awards resulting from this opportunity is October 1, 2017, through September 30, 2018. Contingent on satisfactory performance, ICJIA may support 24 additional months of funding for each project.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "mandatory-applicant-technical-assistance-video"
    }
  }, [_vm._v("Mandatory Applicant Technical Assistance Video")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h4', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE WEBINAR")]), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/ixkVGAki4pI",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "30px",
      "color": "#fff !important",
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3606957/NOFO-VOCA-Child-Abuse-Financial-Crime-and-Impaired-Driving-Technical-Assistance-Webinar-Certification"
    }
  }, [_vm._v("SUBMIT WEBINAR CERTIFICATION  "), _c('i', {
    staticClass: "fa fa-angle-double-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE:")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be required to submit to ICJIA quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("APPLICATION MATERIALS:")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at cja.vocagrantsunit@illinois.gov.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required documents")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "additional-documents"
    }
  }, [_vm._v("Additional Documents")]), _vm._v(" "), _c('p', [_vm._v("The following documents are required to facilitate efficient grant processing but will not be used in determining eligibility.")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "non-profit-agency-required-documents"
    }
  }, [_vm._v("Non-Profit Agency Required Documents")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Responses to Applicant Questions")]), _vm._v(" "), _vm._m(16)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#focus-areas"
    }
  }, [_vm._v("Focus Areas")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The purpose of this funding opportunity is to fund direct services for victims of crime under at least one of the three following focus areas: child abuse (minors and adults survivors of child abuse), financial crime, and impaired driving. Applicants may request a minimum of "), _c('span', [_vm._v("$")]), _vm._v("75,000 to a maximum of "), _c('span', [_vm._v("$")]), _vm._v("500,000 in federal funding for use over a 12-month period. The term of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("See "), _c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/UNMETNEEDSNOFOwattachments.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(", for program design, staff, and training requirements.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Criminal justice entities, such as law enforcement, prosecution and/or court-referred services such as Court Appointed Special Advocates (CASA). Funding for criminal justice-based victim services may be offered in a future funding opportunity.")]), _vm._v(" "), _c('li', [_vm._v("Under the Child Abuse Focus Area, sub-recipients of funding from Child Advocacy Centers of Illinois, the Illinois Coalition of Domestic Violence, and of the Illinois Coalition Against Sexual Assault are not eligible for funding.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All applicants must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("http://www.grants.illinois.gov")]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications are performed, including a check of Debarred and Suspended status and good standing with the Illinois Secretary of State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applications are due at 11:59 p.m., Monday, July 19, 2017. Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applicants may request a minimum of "), _c('span', [_vm._v("$")]), _vm._v("75,000 to a maximum of $500,000 in federal funding for use over a 12-month period. Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "mailto:cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., July 10, 2017. All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud/"
    }
  }, [_vm._v("https://grants.icjia.cloud/")]), _vm._v(". Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to "), _c('br'), _vm._v("\nquestions shall be binding on the state.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applicants must view a mandatory pre-recorded video on the ICJIA website at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".  The webinar will be available for viewing beginning at 1:30 p.m. on June 5, 2017.  The applicant must certify viewing this recording. Information provided during this video will be unofficial and not binding on the State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Release of NOFO and open application period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("June 5, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 7, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 10, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday July 19, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("September 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Award and rejection letters sent")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("By September 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Start Program Performance Period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("October 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(" by 11:59 p.m., July 19, 2017, to be considered for funding.  Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application for each agency requesting funding. This document will need to be signed and scanned.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word that meets program requirements outlined in Section A. Applicant’s narrative must be submitted in Word and formatted in the posted Program Narrative. Application should be 20 pages maximum, drafted in Times New Roman 12-point font and double-spaced with 1 inch margins. Please number pages.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed VOCA SAR form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative in Excel for each funded agency.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Logic Model")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed Eligibility Requirements Certification Form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Self-Certification form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Fiscal Information Sheet-leave award amount and agreement number blank")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed Audit Information Sheet-leave award amount and agreement number blank")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed Debarment certification")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed EEOP certifications")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Civil Rights certifications")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Programmatic Risk Assessment. This Excel document will need to be submitted unsigned electronically with the application. A signed scanned version will be due if application is approved for funding.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Non-supplanting Certification")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mandatory Forms Checklist")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("United States Internal Revenue Service 501(c)(3) determination letter for nonprofit organizations.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Self-Report Statement of Faith Based Organization")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Proof of Good Standing from the Illinois Secretary of State")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/ICJIAUniformApplicationforGrant AssistanceVOCAUnmetNeeds052617.docx"
    }
  }, [_vm._v("Uniform Application")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/UnmetNeedsProposalNarrative.docx"
    }
  }, [_vm._v("Unmet Needs Program Narrative")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/ICJIAVOCAUnmet needsNOFObudgetbudget narrrative template052617.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/VOCASAR.docx"
    }
  }, [_vm._v("VOCA SAR Form")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/EligibilityCertificationFINAL.docx"
    }
  }, [_vm._v("Eligibility Certification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/SelfCertification.docx"
    }
  }, [_vm._v("Self-Certification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/FiscalInformationSheet.docx"
    }
  }, [_vm._v("Fiscal Info Sheet")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/AuditinfoSheet.docx"
    }
  }, [_vm._v("Audit Info Sheet")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/CertificationLobbyingDebarmentallgrants.pdf"
    }
  }, [_vm._v("Certification on Lobbying, Debarment etc")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/EEOPCert.docx"
    }
  }, [_vm._v("EEOP Certificate")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/CivilRightsComplianceCertification.docx"
    }
  }, [_vm._v("Civil Rights Compliance Certificate")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/Non-supplantingCertificationallgrants.docx"
    }
  }, [_vm._v("Non supplanting Certificate")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/MandatoryFormsChecklist.docx"
    }
  }, [_vm._v("Mandatory Forms Checklist")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/FaithBasedOrganizationSelf Report.docx"
    }
  }, [_vm._v("Faith Based Self Report Form")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/LogicModel.docx"
    }
  }, [_vm._v("LogicModel")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/ProgrammaticRiskAssessmentQuestionnaire.xlsx"
    }
  }, [_vm._v("Programmatic Risk Assessment Questionnaire")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "color": "#fff !important",
      "text-decoration": "none !important"
    },
    attrs: {
      "href": "/static/grants/2017UnmetNeeds/UnmetNeedsSubstantiveQuestionsandAnswers615.pdf"
    }
  }, [_vm._v("Download  "), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act Victim\n                            (VOCA) Assistance Formula Grant Program. This program is supported by fines and penalties levied\n                            against criminals convicted of federal crimes and allocated to states by formula by the Office\n                            for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2016, Illinois\n                            received a VOCA award of $87 million.")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are\n                            required to allocate a minimum of 10 percent of funds received for services to each of the following:\n                            victims of sexual assault, domestic violence, child abuse, and underserved victims of violent\n                            crime. VOCA funds may not be used to supplant or replace state and local funds that would otherwise\n                            be available for crime victim services and must be used to develop new projects or expand existing\n                            projects.\n                        ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("The Ad Hoc Victim Services Committee made a priority of strengthening and expansion of core services\n                            for victims of crime. To fulfill this priority, ICJIA made available $17.3 million in VOCA grant\n                            funding for core services and related support costs for victims of domestic violence. These funds\n                            are available to the Illinois Coalition Against Domestic Violence.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Domestic Violence, 806 S. College Street,\n                            Springfield, Illinois, 62704.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("The Notice of Funding Opportunity and application materials were provided to the Illinois Coalition\n                            Against Domestic Violence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/20180205LeadEntityDV/VOCA Lead Entity NOFO - DV - Final  - 5.0.docx"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $17.3 million in FFY16 VOCA funding is available through this solicitation.")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability\n                            of funds.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July 1, 2018, through\n                            September 30, 2019.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to ICJIA monthly fiscal and quarterly data reports.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit:\n                            "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("http://ojp.gov/ovc/about/victimsfund.html")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Last year, ICJIA completed a statewide assessment of victim services in Illinois. The report was\n                            presented to the Ad Hoc Victim Services Committee for consultation and coordination with other\n                            state agencies and victim stakeholder groups. The final report’s recommendations were approved\n                            by the ICJIA Board in January 2017. These recommendations outline a comprehensive plan to address\n                            victims’ needs in Illinois and are reflected in this funding opportunity Please see the following\n                            link to access the report and recommendations:\n                            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at\n                            "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Friday, March 09, 2018.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Wednesday, February 07, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Application deadline")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., Friday, March 09, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("May 25, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Program start date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("July 1, 2018")])])])])])
}]}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "p-classtext-centernotice-of-funding-opportunity-services-for-childrens-advocacy-centers-program"
    }
  }, [_vm._v("\n    Notice of Funding Opportunity Services for Children's Advocacy Centers Program\n")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting applications for grants Services for Children’s Advocacy Centers Program. Grants will be made with FFY17 Victims of Crime Act funds. A total of $7.1 million is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime is a priority. To fulfill this priority, ICJIA made available $7.1 million in VOCA grant funding for core services and related support costs for minor victims of abuse. These funds will be made available to the Children’s Advocacy Centers of Illinois.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Children’s Advocacy Centers of Illinois, 400 S. 9th Street, Springfield, Illinois, 62701.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of Victims of Crime Act FFY17 funds. A minimum of $7.1 million will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of July 1, 2019, through June 30, 2020.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("Technical Assistance Session")]), _vm._v(" "), _c('p', [_vm._v("N/A")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit monthly/quarterly financial reports, monthly/quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Ronnie J. Reichgelt")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    attrs: {
      "id": "p-classtext-centerlink-to-nofo"
    }
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190129CACI/CACI Lead Entity NOFO.docx"
    }
  }, [_vm._v("LINK TO NOFO")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline:")]), _vm._v(" Application materials must be received by "), _c('strong', [_vm._v("11:59 p.m. on Sunday, March 3, 2019")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "https://grants.illinois.gov/portal/"
    }
  }, [_vm._v("https://grants.illinois.gov/portal/")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of period of performance start date, July 1, 2019, to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., on Sunday, March 3, 2019,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 1, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical Assistance Recording available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 25, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications Due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("March 3, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Office of Victims of Crime portal at "), _c('a', {
    attrs: {
      "href": "https://ovcpmt.ojp.gov/"
    }
  }, [_vm._v("https://ovcpmt.ojp.gov/")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019")]), _vm._v(", deadline for application review.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129CACI/CACIapplication.pdf"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129CACI/CACIprogramnarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129CACI/CACIbudget.xls.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" until "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019")]), _vm._v(". Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:NOFOemail@illinois.gov"
    }
  }, [_vm._v("NOFOemail@illinois.gov")])])
}]}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "h2 grant-main-head text-center"
  }, [_vm._v("FFY15 Victims of Crime Act\nFunding Opportunity for Legal Assistance Programs")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("The Illinois Criminal Justice  Information Authority\n  is requesting applications for federal Victims of Crime\n   Act grants to support legal assistance programs.\n    Approximately $6 million is  available for this\n     funding opportunity.")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Application  deadline: April 7, 2017")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/VOCA Legal Assistance NOFO.pdf",
      "target": "_blank"
    }
  }, [_vm._v("\n         Read the Notice of Funding Opportunity   "), _c('i', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" \n         "), _c('br'), _c('br'), _vm._v(".")]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head first"
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("The purpose of this notice is to offer selected  applicants grant funding for comprehensive legal assistance programs for  victims of domestic violence, elder abuse, human trafficking, financial exploitation,  and sexual violence. Applicants should select and describe in detail which  type(s) of legal services will be provided.")]), _vm._v(" "), _c('p', [_vm._v("These services fall into three categories: emergency  legal assistance; victims’ rights enforcement; and civil legal assistance.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Emergency Legal Assistance")])]), _vm._v(" "), _c('ul', [_c('li', [_c('em', [_vm._v("Filing for emergency restraining or  protective orders.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Obtaining emergency custody  orders and visitation rights.")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Victims’ Rights Enforcement")])]), _vm._v(" "), _c('ul', [_c('li', [_c('em', [_vm._v("Assisting victims in asserting their rights as victims, or  otherwise protecting their safety, privacy, and other interests as victims in a  criminal proceeding directly related to the victimization.")])])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Civil Legal Assistance")])]), _vm._v(" "), _c('ul', [_c('li', [_c('em', [_vm._v("Proceedings for protective/restraining orders or campus  administrative protection/stay-away orders.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Family, custody, support, or dependency matters.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Contract, housing, or employment matters.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Immigration assistance.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Intervention with creditors, law enforcement (to obtain  police reports, etc.), and other entities.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Intervention with administrative agencies, schools/colleges,  tribal entities, and other circumstances where legal advice or intervention  would assist in addressing the consequences of a person's victimization.")])]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Filing a motion to vacate or expunge a victim’s conviction  or similar actions based on his/her status of being a victim where permitted  under Illinois law.")])])]), _vm._v(" "), _c('p', [_c('u', [_vm._v("Program funding  may not be used for criminal defense or tort actions.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("This solicitation is open to Illinois public agencies  and non-profits whose primary mission is the provision of legal services. Additional  eligibility requirements are outlined "), _c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/VOCA Legal Assistance NOFO.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("here")])]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_c('u', [_vm._v("Pre-registration:")])])]), _vm._v(" "), _c('p', [_vm._v("All applicants must be pre-qualified  through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("www.grants.illinois.gov")])]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications  are performed, including a check of Debarred and Suspended status and good  standing with the Illinois Secretary of State.")]), _vm._v(" "), _c('p', [_vm._v("The pre-qualification process also  includes a financial and administrative risk assessment using an Internal  Controls Questionnaire (ICQ). "), _c('u', [_vm._v("The ICQ  must be submitted through the GATA portal and approved by a State cognizant  agency by the date of application submission in order for an application to be  reviewed.")]), _vm._v(" All applications will be pre-screened for completeness and ICQ  approval. Applications from agencies that do not have an approved ICQ will not  be reviewed.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Application Materials:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_c('strong', [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/VOCA Legal Assistance NOFO.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Click here")])]), _vm._v(" for Victims of Crime Act Legal  Assistance Program Grant Application")])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Deadline:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Completed  application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.GrantsUnit@Illinois.gov",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("CJA.GrantsUnit@Illinois.gov")])]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., April 7, 2017,")]), _vm._v(" to be considered for funding.  Proposals will not be accepted by mail, fax,  or in person. Incomplete applications will not be reviewed. Late submissions  will not be reviewed.")]), _vm._v(" "), _c('p', [_vm._v("Agencies are encouraged to submit  their applications 72 hours in advance of the deadline to avoid unforeseen  technical difficulties. Technical difficulties should be reported immediately  to ICJIA at "), _c('strong', [_c('a', {
    attrs: {
      "href": "mailto:CJA.GrantsUnit@Illinois.gov",
      "target": "_blank"
    }
  }, [_vm._v("CJA.GrantsUnit@Illinois.gov")])]), _vm._v(".")])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Notice  of Intent:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Agencies interested in submitting an  application asked to complete an online Notice of Intent form by "), _c('strong', [_vm._v("11:59 p.m.,  March 8, 2017")]), _vm._v(". Submission of a Notice of Intent is nonbinding and will be used  for internal planning purposes only.")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "register-now"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3343246/VOCA-Comprehensive-Legal-Assistance-Program-Notice-of-Intent",
      "target": "_blank"
    }
  }, [_vm._v("\n  Submit Notice of Intent   "), _c('i', {
    staticClass: "fa fa-chevron-circle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Available  funds:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("A total of $6 million in FFY15 VOCA funding is  available through this solicitation. Applicants may request a minimum of  $80,000 and up to a maximum of $800,000 for use over a 12-month period. Agreements  that result from this funding opportunity are contingent upon and subject to  the availability of funds."), _c('br')])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Period  of performance:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Awards resulting from  this opportunity will have a period of performance of July 1, 2017, through June  30, 2018.  Contingent on satisfactory  performance, ICJIA may support 24 additional months of funding for each  project.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Mandatory  applicant webinar:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("A pre-application webinar will be  held by ICJIA at "), _c('strong', [_vm._v("1 p.m. on Monday, March 6, 2017")]), _vm._v(". This will be your opportunity  to ask questions about this funding opportunity. Participants must pre-register  here by "), _c('strong', [_vm._v("March 1, 2017")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("REGISTRATION FOR WEBINAR IS NOW CLOSED")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group spacerBottom30",
    attrs: {
      "role": "group",
      "aria-label": "webinars"
    }
  }, [_c('a', {
    staticClass: "btn btn-secondary btn-grant",
    attrs: {
      "href": "http://www.icjia.state.il.us/sites/required-webinar",
      "target": "_blank"
    }
  }, [_vm._v("\n  View webinar   "), _c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-secondary btn-grant",
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/march_6_2017_webinar_slides.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Webinar Materials\n   "), _c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Applicants who are unable attend March  6th webinar may watch the webinar online at a later date and will be  required to produce online certification that it was viewed. Information  provided during this webinar will be unofficial and not binding on the State.")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Questions:")]), _vm._v(" "), _c('div', {
    staticClass: "grant-section-context"
  }, [_c('p', [_vm._v("Questions regarding application rules, requirements,  and materials may be submitted via email to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.GrantsUnit@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("CJA.GrantsUnit@Illinois.gov")])]), _vm._v(".  The deadline for questions is "), _c('strong', [_vm._v("5 p.m. on March 24, 2017")]), _vm._v(". Responses will be sent  via email within five business days. All substantive questions and responses  will be posted on the ICJIA NOFO website at "), _c('strong', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/sites/nofo-voca-legal-assist",
      "target": "_blank"
    }
  }, [_vm._v("www.icjia.state.il.us/sites/nofo-voca-legal-assist")])]), _vm._v(". Due to the  competitive nature of this solicitation, applicants may not discuss this  opportunity directly or indirectly with any Authority employee other than the  respondent of this email address. Only written answers to questions shall be  binding on the state.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Timeline:")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "486",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("Task")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "432",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("Date")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Release    of NOFO and open application      ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("February    8, 2017 ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Mandatory    webinar registration deadline")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("March 1, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("Mandatory webinar")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("1 p.m., March 6, 2017")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Notice    of Intent deadline ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("March 8, 2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Last    date for submission of questions ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("5    p.m., March 24, 2017 ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("Application deadline")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("11:59    p.m., Friday, April 7 2016")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Budget Committee review")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("May 25,    2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Notices of State Award released")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("June    2017")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "486"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("Start Program    Performance Period")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "432"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("July 1, 2017")])])])])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Reporting: ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be  required to submit to the Authority quarterly fiscal and data reports.")]), _vm._v(" "), _c('h2', {
    staticClass: "h3 grant-section-head"
  }, [_vm._v("Required Documents:")]), _vm._v(" "), _c('p', {
    staticClass: "style4"
  }, [_vm._v("Download these documents individually or scroll down to download all documents into a Zip file.")]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('th', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("Document")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("PDF")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("Word")])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style1"
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Completed and    signed "), _c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Uniform Application for State Grant Assistance.docx"
    }
  }, [_c('strong', [_vm._v("Uniform State Grant Application")])]), _vm._v(" for each agency requesting funding. "), _c('u', [_vm._v("Please sign and scan.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Completed    "), _c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Proposal Narrative Legal Assistance 2.7 FINAL.docx"
    }
  }, [_c('strong', [_vm._v("Program Narrative")])]), _vm._v(" in Word that meets program requirements outlined in Section A. Applicant’s narrative must be    submitted in Word and formatted in the posted Program Narrative. Application    should be 30 pages maximum, drafted in Times New Roman 12-point font and    double-spaced with 1 inch margins. Please number pages. ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("One completed "), _c('strong', [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/GATA Budget Template.xlsx"
    }
  }, [_vm._v("Budget/Budget Narrative in Excel")])]), _vm._v(" for each funded agency.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "1035",
      "colspan": "4",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2",
    attrs: {
      "align": "left"
    }
  }, [_c('br'), _c('strong', [_vm._v("The following documents are required to facilitate efficient grant processing but will not be used in determining eligibility:")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Eligibility Requirements Certification Form.pdf"
    }
  }, [_c('strong', [_vm._v("Completed    Eligibility Requirements Certification Form")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/VOCA SAR.docx"
    }
  }, [_c('strong', [_vm._v("Completed VOCA    SAR form")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Self Certification.docx"
    }
  }, [_c('strong', [_vm._v("Completed    Self-Certification form")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Fiscal Information Sheet.docx"
    }
  }, [_c('strong', [_vm._v("Completed Fiscal Information Sheet")])]), _vm._v(" - leave award amount and agreement number blank")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Audit info Sheet.docx"
    }
  }, [_c('strong', [_vm._v("Completed and    signed Audit Information Sheet")])]), _vm._v(" - leave award amount and agreement number blank")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Certification Lobbying, Debarment all grants.pdf"
    }
  }, [_c('strong', [_vm._v("Completed and    signed Debarment certification")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/EEOP Cert.docx"
    }
  }, [_c('strong', [_vm._v("Completed and    signed EEOP certifications")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Civil Rights Compliance Certification.docx"
    }
  }, [_c('strong', [_vm._v("Completed Civil    Rights certifications")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Programmatic Risk Assessment Questionnaire.xlsx"
    }
  }, [_c('strong', [_vm._v("Programmatic    Risk Assessment")]), _vm._v(".")]), _vm._v(" This excel    document will need to be submitted unsigned electronically with the    application. A signed scanned version will be due if application is approved    for funding.   ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Non-supplanting Certification all grants.docx"
    }
  }, [_c('strong', [_vm._v("Non-supplanting    Certification")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Mandatory Forms Checklist.pdf"
    }
  }, [_c('strong', [_vm._v("Mandatory Forms    Checklist")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "1035",
      "colspan": "4",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_c('strong', [_vm._v("Non-Profit Agency    Required Documents")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("United States    Internal Revenue Service 501(c)(3) determination letter for nonprofit    organizations. ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Self-Report    Statement of Faith Based Organization")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "732",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("Proof of Good    Standing from the Illinois Secretary of State")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "style2"
  }, [_vm._v("X")])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "89",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "125",
      "valign": "top"
    }
  }, [_c('p', [_c('span', {
    staticClass: "style2"
  })])])])])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn-group spacerBottom30",
    attrs: {
      "role": "group",
      "aria-label": "documents"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/VOCA Legal Assistance NOFO Application Documents.zip"
    }
  }, [_vm._v("Application Documents (zip file)   "), _c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "/static/grants/VOCA/nofo_legal_assist/Legal_Assistance_NOFO_Major_Questions_and_Answers.pdf"
    }
  }, [_vm._v("RESPONSES TO APPLICANT QUESTIONS   "), _c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])])])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "law-enforcement-prosecution-and-county-casa-victim-assistance-program"
    }
  }, [_vm._v("Law Enforcement, Prosecution, and County-CASA Victim Assistance Program")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals to fund direct services for victims of crime through municipal police departments, county sheriff departments, county state’s attorney’s offices, and county CASA programs.  Grants will be made with Federal Fiscal Year 2016 (FFY16) Victims of Crime Act (VOCA) funds. A total of $6.0 million in funding is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "matching-funds"
    }
  }, [_vm._v("Matching funds:")]), _vm._v(" "), _c('p', [_vm._v("A 20 percent cash or in-kind match requirement will be imposed on grant funds under this program. Match funds must be spent in support of the program’s goals and objectives. ")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("ELIGIBILITY")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligible-agencies"
    }
  }, [_vm._v("Eligible agencies")]), _vm._v(" "), _c('p', [_vm._v("Applicants must apply for funding to support either a Law Enforcement/Prosecution-Based Victim Assistance Program or a Court Appointed Special Advocacy (CASA) Program. Programs within eligible agencies will be allowed to apply for funding for staffing, staff training, supervision of direct services, and office equipment to create or expand existing victim service programs. ")]), _vm._v(" "), _c('p', [_vm._v("All activities supported with this award must fall outside of the normal scope of law enforcement and prosecution activities. Grant funds may not be used to facilitate participation of witness-victims in criminal justice proceedings. Victim eligibility for services cannot be contingent upon participation in the criminal justice process. Services also must be made available after a victim’s involvement with the criminal justice system has ended through either the applicant agency or referral to a victim service provider.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "gata-compliance"
    }
  }, [_vm._v("GATA compliance")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "approved-internal-control-questionnaire"
    }
  }, [_vm._v("Approved Internal Control Questionnaire")]), _vm._v(" "), _c('p', [_vm._v("The pre-qualification process also includes a financial and administrative risk assessment using an Internal Controls Questionnaire (ICQ). The ICQ must be approved through the GATA portal by the date of application submission in order for an application to be reviewed.  All applications will be pre-screened for completeness and ICQ approval. Applications from agencies that have not received SFY18 ICQ approval will not be reviewed.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("NOTICE OF INTENT")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application MUST complete an online Notice of Intent form by 11:59 p.m., October 2, 2017. ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The projected period of performance for awards resulting from this opportunity is January 1, 2018, through December 31, 2018. Contingent on satisfactory performance and available funds, ICJIA staff may recommend to its Board a maximum of two 12-month grants for each project.  ")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "mandatory-applicant-technical-assistance-video"
    }
  }, [_vm._v("Mandatory Applicant Technical Assistance Video")]), _vm._v(" "), _c('p', [_vm._v("Applicants must view the following mandatory pre-recorded videos. Applicants must certify viewing these recordings. Information provided during this video will be unofficial and not binding on the State.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE:")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be required to submit to ICJIA quarterly fiscal and data reports.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("APPLICATION MATERIALS:")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required documents")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("UPDATES AND RESPONSES TO APPLICANT QUESTIONS")]), _vm._v(" "), _c('p', [_vm._v("Updates to NOFO materials, and questions from applicants and their responses are revised weekly.")]), _vm._m(16)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applicants may request a minimum of $40,000 and a maximum of $1,500,000 to be spent over a 12-month period. The terms of the grant agreement will commence upon its effective date. Depending on program performance and fund availability, ICJIA may approve funding to support an additional 24 months. "), _c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(", for program design, staff, and training requirements.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Read the complete "), _c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('br'), _vm._v("\n for all eligibility requirements. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All applicants must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov/portal"
    }
  }, [_vm._v("http://www.grants.illinois.gov/portal")]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications are performed, including a check of Debarred and Suspended status and good standing with the Illinois Secretary of State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Read the "), _c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(". ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applications are due at 11:59 p.m., October 15, 2017. Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3787821/VOCA-LAW-ENFORCEMENT-PROSCETUTION-AND-COUNTY-CASA-VICTIM-ASSISTANCE-PROGRAM-NOFO-Notice-of-Intent"
    }
  }, [_vm._v("NOTICE OF INTENT ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., October 12, 2017. All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud/"
    }
  }, [_vm._v("https://grants.icjia.cloud/")]), _vm._v(". Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the state. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/hqI_f4pmd9Y"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Programmatic Guidelines")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: General Requirements")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/wqIrwI5U0eY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: VOCA Match")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Budget")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Indirect Costs")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Prior Approval Requirements")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3787827/VOCA-LAW-ENFORCEMENT-PROSCETUTION-AND-COUNTY-CASA-VICTIM-ASSISTANCE-PROGRAM-NOFO-Technical-Assistance-Viewing-Certification"
    }
  }, [_vm._v("TECHNICAL ASSISTANCE VIDEO CERTIFICATION")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Release of NOFO and open application period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("August 30, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Technical Assistance videos available")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("September 14, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("October 2, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("October 12, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., October 15, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("November, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Projected Start Program Performance Period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("January 1, 2018")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Department of Justice Bureau of Justice Assistance portal at "), _c('a', {
    attrs: {
      "href": "https://bjapmt.ojp.gov"
    }
  }, [_vm._v("https://bjapmt.ojp.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(" by 11:59 p.m., October 15, 2017, to be considered for funding.  Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application. This document must be signed and scanned.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word that meets program requirements. Application narratives must be submitted in Word and formatted in the posted Program Narrative template. Applications should be a maximum of 35 pages, not counting Goals/Objectives/Performance Measures. Narratives must be drafted in Times New Roman 12-point font and double-spaced with 1 inch margins. Please number pages.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative in Excel .")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Non-profit agencies only: United States Internal Revenue Service 501(c)(3)determination letter for nonprofit organizations.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsApplication.docx"
    }
  }, [_vm._v("Uniform Application")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsNarrative.doc"
    }
  }, [_vm._v("VOCA Law Enforcement, Prosecution, CASA Program Narrative")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsBudget.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("View them here: "), _c('a', {
    attrs: {
      "href": "/static/grants/20170824VOCAcourts/VOCAcourtsResponseToApplicantQuestions.docx"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])
}]}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\nGrant Information\n\n\n\t")])])
}]}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    staticClass: "text-center",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "footer-text"
  }, [_vm._v("© " + _vm._s(_vm.getFullYear()) + "\n            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v("\n            |  \n          "), _c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                "), _c('a', {
    attrs: {
      "href": "https://github.com/ICJIA/icjia-gata"
    }
  }, [_vm._v("View on GitHub")])])])])
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority (ICJIA) administers the federal Residential Substance Abuse Treatment for State Prisoners Program (RSAT) in Illinois. RSAT assists state and local governments in the development and implementation of\n    substance use disorder treatment programs in state and local correctional and detention facilities. Funds also are available to create and maintain community-based aftercare services for individuals after release from incarceration. A total of approximately\n    $700,000 from FFY18 funds shall be made available for state and local government agencies, $75,000 of which must be reserved for local government agencies for corrections-based or jail-based substance use disorder treatment or aftercare programs that\n    meet the criteria detailed in the notice of funding opportunity. Awards range from $75,000 to $150,000.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("PROGRAM REQUIREMENTS")]), _vm._v(" "), _c('p', [_vm._v("This grant will fund programs in the following categories which are defined below.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("If possible, RSAT participation should be limited to inmates with six to 12 months remaining in their confinement so they can be released from prison instead of returning to the general prison population after completing the program.")]), _vm._v(" "), _c('p', [_vm._v("Program design must be based on effective, scientific practices.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("If possible, jail-based programs should separate the treatment population from the general correctional population and program design should be based on effective, scientific practices.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("Substance use disorder treatment, established or implemented with assistance provided under RSAT, must provide aftercare services.")]), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("In addition:")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("Effective correctional and aftercare programming is most effective if they are structured, cognitive-behavioral, and skills-based. Approaches such as Alcoholics Anonymous or faith/spiritual-based services do not meet the standard for correctional or treatment\n    programs.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("ELIGIBILITY INFORMATION")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("APPLICATION MATERIALS")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("DEADLINE")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("AVAILABLE FUNDS")]), _vm._v(" "), _c('p', [_vm._v("A minimum of approximately $700,000 from Federal Fiscal Year 2018 funds shall be made available to local government agencies for corrections-based or jail-based substance use disorder treatment or aftercare programs that meet the criteria detailed above.\n    Of those funds, $75,000 must be reserved for local government agencies.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "performance-period"
    }
  }, [_vm._v("PERFORMANCE PERIOD")]), _vm._v(" "), _c('p', [_vm._v("Grant awards resulting from this opportunity are projected to have a period of performance of March 1, 2019, through April 30, 2020. Contingent on satisfactory performance, ICJIA staff may recommend to the ICJIA Board a maximum of 24 additional months\n    of funding for each project")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("CONTACT INFORMATION:")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("TECHNICAL ASSISTANCE SESSION")]), _vm._v(" "), _c('p', [_vm._v("We strongly recommend that applicants view the pre-recorded technical assistance session.\n   Information provided during this webinar will be unofficial and not binding\n    on the State.")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("REPORTING")]), _vm._v(" "), _c('p', [_vm._v("Grantees must submit quarterly financial and progress reports and final financial and progress reports. Federal reporting requirements state that funding agencies must report all mandatory information to the federal agency (U.S. Department of Justice)\n    no later than 30 days after the end of the designated quarter. To do so, ICJIA will require all programs funded to report electronically at minimum on a quarterly basis and no later than 15 days after the end of each reporting period. Mandatory fiscal\n    and progress reports will be distributed to each grantee for submission. Failure to comply with mandatory reporting requirements will cause immediate suspension of funding of this grant, any other grant that applicant has with ICJIA, and possible\n    termination of the grant. If applicable, an annual audit report in accordance with the 2 CFR Part 200 Uniform Requirements must be submitted. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("REQUIRED DOCUMENTS")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("QUESTIONS")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "40px",
      "font-weight": "bold"
    }
  }, [_vm._v("References")]), _vm._v(" "), _c('hr', {
    staticClass: "footnotes-sep"
  }), _vm._v(" "), _vm._m(26)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Read this page and "), _c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATZipFile2018.zip"
    }
  }, [_c('strong', [_vm._v("click here")])]), _vm._v(" for application materials, funding eligibility, and other information.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: Monday, December 31, 2018, 11:59 pm.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Corrections-based substance use disorder treatment")]), _vm._v(" "), _c('li', [_vm._v("Jail-based substance use disorder treatment")]), _vm._v(" "), _c('li', [_vm._v("Aftercare services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Corrections-based substance use disorder treatment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Engage participants for a period between six and 12 months.")]), _vm._v(" "), _c('li', [_vm._v("Provide residential treatment facilities set apart from the general correctional population. This can be a completely separate facility or dedicated housing unit in a facility exclusively for RSAT participants.")]), _vm._v(" "), _c('li', [_vm._v("Focus on the inmate’s substance use diagnosis and addiction-related needs.")]), _vm._v(" "), _c('li', [_vm._v("Develop the inmate’s cognitive, behavioral, social, vocational, and other skills to solve the substance use and related problems.")]), _vm._v(" "), _c('li', [_vm._v("Require urinalysis and/or other proven reliable forms of drug and alcohol testing for program participants, including both periodic and random testing, and for former participants while they remain in the custody of the state or local government.")]), _vm._v(" "), _c('li', [_vm._v("Prepare participants for successful community reintegration, including post-release referral to appropriate evidence-based aftercare treatment and service providers that support the use of medication-assisted treatment.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Jail-based substance use disorder treatment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Engage participants for at least three months.")]), _vm._v(" "), _c('li', [_vm._v("Focus on the inmate’s substance use diagnosis and addiction-related needs.")]), _vm._v(" "), _c('li', [_vm._v("Develop the inmate’s cognitive, behavioral, social, vocational, and other skills to solve the substance use and related problems with emphasis on the provision of cognitive-behavioral therapy.")]), _vm._v(" "), _c('li', [_vm._v("Require urinalysis and/or other proven reliable forms of drug and alcohol testing for program participants, including both periodic and random testing, and for former participants while they remain in the custody of the state or local government.")]), _vm._v(" "), _c('li', [_vm._v("Prepare participants for successful community reintegration, including post-release referral to appropriate evidence-based aftercare treatment and service providers that support the use of medication-assisted treatment.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Aftercare Services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Involve coordination between the correctional treatment program, post-release supervision officer, and other social service and rehabilitation programs and services.")]), _vm._v(" "), _c('li', [_vm._v("Work in conjunction with state and local authorities and organizations involved in substance use disorder treatment to assist in the placement of program participants into community substance use disorder treatment programs or services on release.")]), _vm._v(" "), _c('li', [_vm._v("Provide reentering individuals with comprehensive care coordination prior to and upon release from the facility. This includes a comprehensive reentry plan for aftercare services, other needs, and resources. It is most successfully accomplished when\n        institution staff initiates linkages with aftercare agencies and services outside of the institution, including social services and/or treatment services, parole, and case management."), _c('sup', {
    staticClass: "footnote-ref"
  }, [_c('a', {
    attrs: {
      "href": "#fn1",
      "id": "fnref1"
    }
  }, [_vm._v("[1]")])]), _vm._v("        Continuity between prison and community can reduce re-offense rates."), _c('sup', {
    staticClass: "footnote-ref"
  }, [_c('a', {
    attrs: {
      "href": "#fn2",
      "id": "fnref2"
    }
  }, [_vm._v("[2]")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("To qualify as an aftercare program, the head of the substance use disorder treatment program must work in conjunction with state and local authorities and organizations involved in substance use disorder treatment to assist in the placement of program\n        participants into community substance use disorder treatment programs or services on release.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Further, programs "), _c('strong', [_vm._v("must")]), _vm._v(" incorporate "), _c('strong', [_c('em', [_vm._v("at least two forms of medication for maintenance therapy")])]), _vm._v(" and "), _c('strong', [_c('em', [_vm._v("at least one")])]), _vm._v(" of the evidence-based therapies listed below. This does not include medication\n    used for medical detoxification or medical withdrawal or medications only provided to pregnant women. The reason for requiring at least two forms of medication is because no single treatment is appropriate for everyone.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Evidence-based therapies:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Contingency Management (CM), including voucher- or prize-based contingency management")]), _vm._v(" "), _c('li', [_vm._v("Moral Reconation Therapy (MRT)")]), _vm._v(" "), _c('li', [_vm._v("Motivational Enhancement Therapy (MET)")]), _vm._v(" "), _c('li', [_vm._v("Motivational Interviewing (MI)")]), _vm._v(" "), _c('li', [_vm._v("Thinking for a Change (T4C)")]), _vm._v(" "), _c('li', [_vm._v("Dialectical Behavioral Therapy (DBT)")]), _vm._v(" "), _c('li', [_vm._v("Reasoning and Rehabilitation (R&R)")]), _vm._v(" "), _c('li', [_vm._v("Cognitive-Behavioral Interventions—Substance Use Disorders (CBI-SA)")]), _vm._v(" "), _c('li', [_vm._v("Relapse Prevention (RP)")]), _vm._v(" "), _c('li', [_vm._v("Mind-Body Bridging Substance Abuse Program (MBBSAP)-Substance Use Disorders")]), _vm._v(" "), _c('li', [_vm._v("Family therapies, including:")]), _vm._v(" "), _c('li', [_vm._v("Functional Family Therapy(FFT)")]), _vm._v(" "), _c('li', [_vm._v("Multidimensional Family Therapy (MDFT)")]), _vm._v(" "), _c('li', [_vm._v("Multisystemic Therapy (MST)")]), _vm._v(" "), _c('li', [_vm._v("Family Behavior Therapy (FBT)")]), _vm._v(" "), _c('li', [_vm._v("Brief Strategic Family Therapy (BSFT)")]), _vm._v(" "), _c('li', [_vm._v("Therapeutic Community(TC)")]), _vm._v(" "), _c('li', [_vm._v("Matrix Model")]), _vm._v(" "), _c('li', [_vm._v("Trauma-informed substance use disorder treatment, including:")]), _vm._v(" "), _c('li', [_vm._v("Trauma-Focused Cognitive-Behavioral Therapy (TF-CBT)")]), _vm._v(" "), _c('li', [_vm._v("Seeking Safety")]), _vm._v(" "), _c('li', [_vm._v("Trauma Affect Regulation: Guide for Education and Treatment (TARGET)")]), _vm._v(" "), _c('li', [_vm._v("Trauma Recovery and Empowerment Model (TREM)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Aftercare only services:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Assertive Community Treatment (ACT)")]), _vm._v(" "), _c('li', [_vm._v("Intensive outpatient program (IOP)")]), _vm._v(" "), _c('li', [_vm._v("Outpatient program (OP)")]), _vm._v(" "), _c('li', [_vm._v("Individual counseling")]), _vm._v(" "), _c('li', [_vm._v("Group counseling")]), _vm._v(" "), _c('li', [_vm._v("Case management")]), _vm._v(" "), _c('li', [_vm._v("Medication maintenance")]), _vm._v(" "), _c('li', [_vm._v("Vocation/Education programs and services")]), _vm._v(" "), _c('li', [_vm._v("Transitional housing or housing with supportive services")]), _vm._v(" "), _c('li', [_vm._v("Recovery support services")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. During pre-qualification, Dun and Bradstreet\n    verifications are performed, including a check of Debarred and Suspended status and good standing with the Secretary of State. Applicants must have completed the GATA pre-qualification process by the date of application.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATZipFile2018.zip"
    }
  }, [_c('strong', [_vm._v("Click here")])]), _vm._v(" for the RSAT application package.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018rsatNOFO@illinois.gov"
    }
  }, [_vm._v("CJA.2018rsatNOFO@illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., Monday, December 31, 2018")]), _vm._v(", to be considered for funding. Proposals will not be accepted\n    by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Shataun Hailey Program Administrator Illinois Criminal Justice Information Authority 300 West Adams, Suite 200 Chicago, IL 60606\n    "), _c('a', {
    attrs: {
      "href": "mailto:Shataun.Hailey@illinois.gov"
    }
  }, [_vm._v("Shataun.Hailey@illinois.gov")]), _vm._v(" 312-814-8100\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("View the technical assistance recording here: "), _c('a', {
    attrs: {
      "href": "https://youtu.be/P35tqxI4wzI"
    }
  }, [_vm._v("https://youtu.be/P35tqxI4wzI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_c('strong', [_vm._v("Task")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Date")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("November 2, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("November 30, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("December 31, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("January 31, 2019")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018rsatNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.2018rsatNOFO@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., Monday, December 31, 2018")]), _vm._v(", deadline for application review. Click the links below to download\n    copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATNOFO2018.docx"
    }
  }, [_vm._v("NOFO document")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/UniformGrantApplication.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATProgramNarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATBudget2018.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20181102rsatmat/RSATZipFile2018.zip"
    }
  }, [_vm._v("DOWNLOAD")]), _vm._v(" ZIP FILE OF ALL REQUIRED DOCUMENTS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018rsatNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.2018rsatNOFO@Illinois.gov")]), _vm._v(" until 11:59 p.m. November 30, 2018. Questions and responses will be posted at\n    "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footnotes"
  }, [_c('ol', {
    staticClass: "footnotes-list"
  }, [_c('li', {
    staticClass: "footnote-item",
    attrs: {
      "id": "fn1"
    }
  }, [_c('p', [_vm._v("SAMHSA Treatment Improvement Protocol (TIP) 30: Continuity of Offender Treatment for Substance Use Disorders from Institution to Community. "), _c('a', {
    attrs: {
      "href": "https://bit.ly/2I2OaPJ"
    }
  }, [_vm._v("https://bit.ly/2I2OaPJ")]), _vm._v(" "), _c('a', {
    staticClass: "footnote-backref",
    attrs: {
      "href": "#fnref1"
    }
  }, [_vm._v("↩︎")])])]), _vm._v(" "), _c('li', {
    staticClass: "footnote-item",
    attrs: {
      "id": "fn2"
    }
  }, [_c('p', [_vm._v("Serin, R. & Crime and Justice Institute. (2005). Evidence-based practices: Principles for enhancing correctional results in prisons. Washington, DC: U.S. Department of Justice, National Institute of Corrections. "), _c('a', {
    staticClass: "footnote-backref",
    attrs: {
      "href": "#fnref2"
    }
  }, [_vm._v("↩︎")])])])])])
}]}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "sorna-electronic-transmission-and-livescan-grants"
    }
  }, [_vm._v("SORNA Electronic Transmission and Livescan Grants")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for SORNA Electronic Transmission and Livescan grants. Grants will be made with SORNA Federal Fiscal Year 2016 or 2017 funds. A total of $463,307 in funding is available through\n    this solicitation for use over a period of six months.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("This funding opportunity seeks to support the acquisition of computer scanning, storage, and transmission equipment to facilitate electronic exchange of sex offender documents and Livescan palm prints between local law enforcement agencies and the Illinois\n    State Police (ISP). If selected for grant funding, applicant agencies will be expected to competitively procure approved equipment and install the equipment no later than June 30, 2018. Funded agencies must be capable of electronic transmission of\n    sex offender documentation and/or Livescan palm prints by the end of the agreement period on July 31, 2018.")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will responsible for procuring necessary software, but these costs may not be included in the application budget or charged to the agreement.")]), _vm._v(" "), _c('p', [_vm._v("ISP SORNU is also eligible to apply for computer equipment to facilitate the receipt and transmission of electronic submissions and Livescan palm prints.")]), _vm._v(" "), _c('p', [_vm._v("No staff costs may be budgeted.")]), _vm._v(" "), _c('p', [_vm._v("Funded projects must comply with all ICJIA procurement standards and may use the funded equipment solely for the purpose of collecting and storing sex offender registration documentation, and the electronic transmission of those documents between reporting\n    agencies and ISP SORNU. Use of Livescan stations with palm print functionality may be used to transmit prints for all offenders and is not limited to sex offenders.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants:")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants are limited to:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline:")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds:")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of a Federal Fiscal Year 2016 and 2017 SORNA funds. An estimated $463,307 will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance:")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of February 1, 2018 to July 31, 2018. No continuing funding is available through this opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-technical-assistance-session"
    }
  }, [_vm._v("Required Technical Assistance Session:")]), _vm._v(" "), _c('p', [_vm._v("Technical assistance recordings providing additional information regarding this funding opportunity will be available for viewing beginning at 1:30 p.m. on November 6, 2017.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent:")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("Application Materials")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#download-application-documents"
    }
  }, [_vm._v("Download Application Documents")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20171102SORNA/sornaNOFO.pdf"
    }
  }, [_vm._v("DOWNLOAD "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("REVISED")]), _vm._v(" NOTICE OF FUNDING OPPORTUNITY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: December 21, 2017")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("PLEASE NOTE:")]), _vm._v(" The revised NOFO clarifies that all governmental entities that are required to submit sex offender registration information to the Illinois State Police (ISP) are eligible to apply for this funding. ISP is also eligible to apply.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,"), _c('a', {
    attrs: {
      "href": "www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA\n    pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of application to be considered for funding. Applications from agencies that have not received approval of its State Fiscal Year 2018 ICQ (SFY18)\n    approval will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("Municipalities.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Counties.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("State agencies.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.SORNA@Illinois.gov"
    }
  }, [_vm._v("CJA.SORNA@Illinois.gov")]), _vm._v(" by 11:59 p.m., December 21, 2017, to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications\n    will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: General Requirements")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Budget")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Indirect Costs")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Prior Approval Requirements")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in submitting an application are asked to submit an online Letter of Intent by 11:59 p.m., December 14, 2017.\n    "), _c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3960686/Sex-Offender-Registration-and-Notification-Act-NOFO-Notice-of-Intent"
    }
  }, [_vm._v("Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.SORNA@Illinois.gov"
    }
  }, [_vm._v("CJA.SORNA@Illinois.gov")]), _vm._v(" by 11:59 p.m., December 21, 2017, to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications\n    will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at "), _c('a', {
    attrs: {
      "href": "mailto:CJA.SORNA@Illinois.gov"
    }
  }, [_vm._v("CJA.SORNA@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application. "), _c('strong', [_vm._v("This document will need to be signed and scanned.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word using the posted SORNA Program Narrative template.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Budget/Budget Narrative in Excel.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171102SORNA/sornaAPPLICATION.docx"
    }
  }, [_vm._v("Uniform Application")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171102SORNA/sornaNARRATIVE.docx"
    }
  }, [_vm._v("SORNA Program Narrative")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171102SORNA/sornaBUDGET.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "CJA.SORNA@Illinois.gov"
    }
  }, [_vm._v("CJA.SORNA@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., December 18, 2017. All substantive questions and responses will be posted at \n    "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/"
    }
  }, [_vm._v("http://www.icjia.state.il.us/")]), _vm._v(". Due to the competitive nature of this solicitation,\n    applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the state.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Updates to NOFO materials, and questions from applicants and their responses are revised weekly."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/20171102SORNA/sornaResponseToApplicantQuestions.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for SFY19 Adult Redeploy Illinois\n            implementation grants. A total of $700,000 in SFY19 Adult Redeploy Illinois funding is available through this\n            solicitation for use over a 9-month period.\n          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("ARI SFY18 funded jurisdictions with a completed local plan may apply for implementation funds. Preference will\n            be given to jurisdictions that received a planning grant in SFY18.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("ARI sites must utilize validated assessment instruments to guide supervision and programming decisions.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("ARI funds must be used to invest in local programs, services, and protocols that have been demonstrated by research\n            to reduce recidivism.\n          ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Every ARI site must collect and report performance measurement data quarterly as a condition of funding. The\n            Crime Reduction Act specifically requires the following to be measured: recidivism, rate of revocations, employment\n            rates, education achievement, successful completion of substance abuse treatment programs, and payment of victim\n            restitution.\n          ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("In exchange for funds, jurisdictions must agree to reduce by 25 percent the number of offenders committed to\n            IDOC from a defined target population or else face a penalty. The reduction goal is based on the jurisdictions’\n            average number of commitments over the past three years according to IDOC data. Once granted funds, sites are\n            required to collect data and regularly report on progress. Jurisdictions having difficulty meeting their reduction\n            goals are provided technical assistance. They can propose a corrective action plan to meet an adjusted target\n            or, as a penalty, prepare to reimburse a portion of the grant at the discretion of the ARI Oversight Board.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("If the proposed program model for ARI implementation is a problem-solving court (PSC), the jurisdiction must\n            either be certified or in the process of being certified through the Administrative Office of the Illinois\n            Courts. ARI funds can be used to support initial staffing, training, and administrative support throughout\n            the certification process; however, no funds can be used to provide services until the PSC is certified and\n            able to enroll participants.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $700,000 dollars will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of October 1, 2018, to June 30, 2019. Based on program performance and fund\n            availability, the ARI Oversight Board may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "letter-of-intent"
    }
  }, [_vm._v("Letter of Intent")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress\n            reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.\n            Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Adriana Perez")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(18)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: August 6, 2018")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Assessment of Risk, Assets, and Needs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Evidence-based Practices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Performance Measurement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Reduction Goal & Reimbursement Provision")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Problem-Solving Court Certification")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,\n            "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA\n            pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of\n            application to be considered for funding. Applications from agencies that have not received ICQ approval will\n            not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Eligible applicants are limited to agencies operating SFY18 Adult Redeploy Illinois-funded programs.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to\n            "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARISFY19NOFO1@illinois.gov"
    }
  }, [_vm._v("CJA.ARISFY19NOFO1@illinois.gov")]), _vm._v(" by\n            "), _c('strong', [_vm._v("11:59 p.m., August 6, 2018,")]), _vm._v(" for funding consideration. Proposals will not be accepted by mail, fax,\n            or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in applying are asked to submit an online Letter of Intent by\n            "), _c('strong', [_vm._v("11:59 p.m., July 20, 2018.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_0ArbswMoHPT6MCx"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("7/05/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("7/20/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("7/26/18")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("August 6, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Adult Redeploy Illinois Oversight Board approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("8/20/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("10/01/18")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to\n            "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARISFY19NOFO1@illinois.gov"
    }
  }, [_vm._v("CJA.ARISFY19NOFO1@illinois.gov")]), _vm._v(" by the\n            "), _c('strong', [_vm._v("11:59 p.m., August 6, 2018,")]), _vm._v(" deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180705ARIimplementation/SFY19ImplementationGrantNOFO.PDF"
    }
  }, [_vm._v("Download NOFO Instructions (PDF)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180705ARIimplementation/SFY19ImplementationGrantAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180705ARIimplementation/SFY19ImplementationGrantNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180705ARIimplementation/SFY19ImplementationGrantBUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20180705ARIimplementation/SFY19ImplementationGrant.zip"
    }
  }, [_vm._v("DOWNLOAD ZIP FILE OF ALL REQUIRED APPLICATION DOCUMENTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this funding opportunity may be submitted to\n            "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARISFY19NOFO1@illinois.gov"
    }
  }, [_vm._v("CJA.ARISFY19NOFO1@illinois.gov")]), _vm._v(" until 11:59 p.m., July 26, 2018.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions and responses will be posted at\n            "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud/grants/20180705ariimplementation"
    }
  }, [_vm._v("https://grants.icjia.cloud/grants/20180705ariimplementation")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:CJA.ARISFY19NOFO1@illinois.gov"
    }
  }, [_vm._v("CJA.ARISFY19NOFO1@illinois.gov")])])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsfeed"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [_c('ul', {
    attrs: {
      "id": "newsfeed"
    }
  }, _vm._l((_vm.newsItems), function(item) {
    return _c('li', [_c('div', {
      staticClass: "item-news"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), _c('div', {
      staticClass: "item-date"
    }, [_vm._v("Posted: " + _vm._s(_vm._f("moment")(item.created)))]), _vm._v(" "), _c('div', {
      staticClass: "item-description",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news btn btn-secondary btn-sm btn-readmore",
      attrs: {
        "to": item.path
      }
    }, [_vm._v("Read more >>\n                  ")])], 1)])])
  }))])])])])])
},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view', {
    staticClass: "view"
  })], 1), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "50px",
      "background": "red",
      "color": "#fff"
    }
  }, [_c('h1', [_vm._v("This website is no longer updated."), _c('br'), _c('br'), _vm._v("Please go to to the new ICJIA GATA website:"), _c('br'), _c('br'), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")])])])
}]}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "adult-redeploy-illinois-sfy18-planning-and-implementation-grants"
    }
  }, [_vm._v("Adult Redeploy Illinois – SFY18 Planning and Implementation Grants")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for Adult Redeploy Illinois – State Fiscal Year 2018 (SFY18) Planning and Implementation Grants. Grants will be made with SFY18 ARI funds. A total of $500,000 in funding for Planning\n    and Implementation Grants is available through this solicitation for use over a period of 6 months.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-deadline-october-30-2017"
    }
  }, [_vm._v("Application deadline: October 30, 2017")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program requirements:")]), _vm._v(" "), _c('p', [_vm._v("Two categories of funding are available through this solicitation, for either the development or implementation of an ARI local plan. Awards resulting from this opportunity will have a projected period of performance of January 1, 2018, to June 30, 2018.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Category 1: Planning Grant")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Funds may not be used for capital expenditures, renovations or remodeling, or any food and beverage purchases. In addition, ARI funds shall not be used to supplant existing federal, state, county, or locally funded programs.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "category-2-implementation-grants"
    }
  }, [_vm._v("Category 2: Implementation Grants")]), _vm._v(" "), _c('p', [_vm._v("Only jurisdictions with a completed local plan (using the standard plan template) may apply for implementation funds. Preference will be given to those jurisdictions whose local plans have received prior ARIOB approval. To reflect broad commitment, letters of support from all key and principal stakeholders in the justice system are strongly encouraged.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("Each applicant should identify a multi-disciplinary steering committee representing the criminal justice spectrum (e.g., judiciary, prosecution, defense, probation) and the community (e.g., treatment providers, social services, business), to guide implementation.\n    Please list titles, not proper names, of all partners.")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("ARI sites must utilize validated assessment instruments to guide supervision and programming decisions.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("Per the Crime Reduction Act, ARI funds must be used to invest in local programs, services and protocols that have been a promising practice by research to reduce recidivism. Examples of the evidence-based and promising practices are in Appendix B.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("Every ARI site must collect and report performance measurement data quarterly as a condition of funding. The Crime Reduction Act specifically requires the following to be measured: recidivism, rate of revocations, employment rates, education achievement,\n    successful completion of substance abuse treatment programs, and payment of victim restitution. ARI and ICJIA have defined additional performance measures to track these and other indicators of impact. The list of mandatory data elements to be collected\n    are included in Appendix C.")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', [_vm._v("In exchange for the funds, jurisdictions must agree to reduce by 25 percent the number of offenders committed to IDOC from a defined target population or else face a penalty. The reduction goal is based on the jurisdictions’ average number of commitments\n    over the past three years according to IDOC data. Once granted funds, sites are required to collect data and regularly report on progress. Jurisdictions having difficulty meeting their reduction goals are provided technical assistance. They can propose\n    a corrective action plan to meet an adjusted target or, as a penalty, prepare to reimburse a portion of the grant at the discretion of the ARIOB Reimbursement is capped at $2,500 for each person short of the goal.")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("If the proposed program model for ARI implementation is a problem-solving court (PSC), the jurisdiction must either be certified or in the process of being certified through the Administrative Office of the Illinois Courts. ARI funds can be used to support\n    initial staffing, training and administrative support throughout the certification process; however, no funds can be used to provide services until such time as the PSC is certified and able to enroll participants.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("Only county units of government are eligible to apply for funds under this notice. A county may submit on behalf of a group of counties or a judicial circuit. Private agencies and not-for-profit organizations are not eligible to apply.")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline:")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds:")]), _vm._v(" "), _c('p', [_vm._v("$500,000 will be made available through this funding opportunity for up to 10 planning and/or implementation grants. Grants will be made with SFY18 ARI funds.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance:")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of January 1, 2018 to June 30, 2018.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information:")]), _vm._v(" "), _c('p', [_vm._v("Adriana Perez")]), _vm._v(" "), _c('p', [_vm._v("Program Administrator")]), _vm._v(" "), _c('p', [_vm._v("Adult Redeploy Illinois")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h2', [_vm._v("Required Technical Recordings: ")]), _vm._v(" "), _c('p', [_vm._v("Applicants must view the following mandatory pre-recorded videos.")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', [_vm._v("Information provided during these recording is unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent:")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application are asked to submit a Notice of Intent by 11:59 p.m., October 16, 2017.")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., July 27, 2017. All substantive questions and responses will be posted on this Authority web page. Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly\n    or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit monthly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may\n    be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents:")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', [_vm._v("Updates to NOFO materials, and questions from applicants and their responses are revised weekly. View them here:")]), _vm._v(" "), _vm._m(24)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#download-application-documents"
    }
  }, [_vm._v("Download Application Documents")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ARIsfy18plNOFO.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Program Category")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Minimum")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Maximum")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Category 1: Planning Grant")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("$30,000")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Category 2: Implementation Grant")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("None")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Multi-disciplinary Planning Committee")]), _vm._v(" Each applicant should identify a multi-disciplinary planning committee representing the criminal justice spectrum (e.g., judiciary, prosecution, defense, probation) and the community (e.g., treatment providers,\n    social services, business) to guide planning. Please list titles, not proper names, of all partners.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Planning Activities")]), _vm._v(" Ω Funds are to be used solely for the purpose of developing a local plan to implement ARI. Uses of planning grant funds may include, but are not limited to:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Employing an outside facilitator or strategic planning consultant.")]), _vm._v(" "), _c('li', [_vm._v("Conducting an outside or in-house data analysis.")]), _vm._v(" "), _c('li', [_vm._v("Providing stakeholder training.")]), _vm._v(" "), _c('li', [_vm._v("Conducting site visits to observe successful diversion programs.")]), _vm._v(" "), _c('li', [_vm._v("Community resource mapping.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Local Plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("At the end of the planning grant period, funded jurisdictions must complete and submit a local ARI implementation plan using the standard plan template (available "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/redeploy/standard-plan.cfm"
    }
  }, [_vm._v("at the ARI website")]), _vm._v(").\n    Note that funded jurisdictions are under no obligation to implement the plan.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Multi-disciplinary Steering Committee")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Assessment of Risk, Assets and Needs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Evidence-based Practices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Performance Measurement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Reduction Goal & Reimbursement Provision")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Problem-Solving Court Certification (if applicable)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed\n    the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of application to be considered for funding. Applications from agencies that have not received ICQ approval will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARI.SFY18PIGrant@Illinois.gov"
    }
  }, [_vm._v("CJA.ARI.SFY18PIGrant@Illinois.gov")]), _vm._v(" by 11:59 p.m., October 30, 2017, to be considered for funding. Proposals will not be accepted by mail, fax, or\n    in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Adriana.Perez@Illinois.gov"
    }
  }, [_vm._v("Adriana.Perez@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/K4WNlE9CU14"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Programmatic Guidelines: Category 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/8q15u7grJlw"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Programmatic Guidelines: Category 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: General Requirements")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/FTeznPSc9_c"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: VOCA Match")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Budget")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Indirect Costs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("VIEW MANDATORY TECHNICAL ASSISTANCE VIDEO: Prior Approval Requirements")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3814146/Adult-Redeploy-Illinois-SFY18-Planning-and-Implementation-Grants-Notice-of-Intent"
    }
  }, [_vm._v("NOTICE OF INTENT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Release of NOFO")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("September 13, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Technical Assistance Recordings Available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("September 22, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("October 16, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("October 26, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Application deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("October 30, 2017, 11:59 p.m.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Site selection and monitoring review")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("November 6, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oversight Board approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("November 13, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Start Program Start Date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("January 1, 2018")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARI.SFY18PIGrant@Illinois.gov"
    }
  }, [_vm._v("CJA.ARI.SFY18PIGrant@Illinois.gov")]), _vm._v(" by the 11:59 p.m., October 30, 2017, deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word. Narrative must be submitted in Word and formatted in the posted Program Narrative. Application should be 20 pages maximum, drafted in Times New Roman 12-point font and double-spaced with 1 inch margins.\n                Please number pages.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("X")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ARIsfy18plAPPLICATION1.docx"
    }
  }, [_vm._v("Uniform Application")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ARIsfy18plNARRATIVEcat1.docx"
    }
  }, [_vm._v("Program Narrative: Category 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ARIsfy18plNARRATIVEcat2.docx"
    }
  }, [_vm._v("Program Narrative: Category 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ARIsfy18BUDGET.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "CJA.ARI.SFY18PIGrant@Illinois.gov"
    }
  }, [_vm._v("CJA.ARI.SFY18PIGrant@Illinois.gov")]), _vm._v(" until 11:59 p.m. October 26, 2017.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20170913ARISFY18/ariResponseToApplicantQuestions.pdf"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newsfeed"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {}, [(_vm.grants.length > 0) ? _c('div', [_c('ul', {
    attrs: {
      "id": "grantFeed"
    }
  }, _vm._l((_vm.grants), function(grant) {
    return _c('li', [_c('div', {
      staticClass: "grant-news"
    }, [_c('router-link', {
      staticClass: "grant-title",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v(_vm._s(grant.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "grant-date"
    }, [(_vm.isItNew(grant.posted)) ? _c('span', [_c('span', {
      staticClass: "new"
    }, [_vm._v("NEW!")]), _vm._v(" | ")]) : _vm._e(), _vm._v("\n                  Posted: " + _vm._s(_vm._f("moment")(grant.posted)) + " |\n\n                  "), _vm._v(" "), _c('span', {
      staticClass: "grant-deadline"
    }, [_vm._v("Deadline: " + _vm._s(_vm._f("moment")(grant.expired)))])]), _vm._v(" "), _c('div', {
      staticClass: "grant-description",
      domProps: {
        "innerHTML": _vm._s(grant.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grant-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news read-more-news btn btn-secondary btn-sm\n                  btn-readmore",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v("Read more >>\n                  ")])], 1)], 1)])
  }))]) : _c('div', {
    staticClass: "text-center"
  }, [_c('h2', {
    staticClass: "h4 text-muted"
  }, [_vm._v("There are no current grant opportunities.")])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card contents"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h3', {
    staticClass: "contents-header"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=C6-qCnIsNjs"
    }
  }, [_vm._v("Program Goals, Objectives and Performance Indicators")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=rop6xoEA_NQ"
    }
  }, [_vm._v("The Value of Logic Models (Part 1)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=1bGkwPgwmcw"
    }
  }, [_vm._v("Major Components of a Logic Model (Part 2)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=6O5YP5d2iTs"
    }
  }, [_vm._v("How Logic Models Support Implementation (Part 3)")]), _vm._v("  »")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=iHsWphZtbzU"
    }
  }, [_vm._v("Amendments to Grant Agreements")]), _vm._v("  »")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('ul', [_c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=YjkFmPid5DI"
    }
  }, [_vm._v("Budget Categories Needing Prior Approval")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=nQb8pK5e3Mo"
    }
  }, [_vm._v("Budget Category: Travel Costs")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=zXIopZ4KeEI"
    }
  }, [_vm._v("Budget Category: Subcontractors")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=4stkASoNY5w"
    }
  }, [_vm._v("Budget Category: Indirect Costs")]), _vm._v("  »\n          ")])]), _vm._v(" "), _c('li', [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=x6cqf0075Fg"
    }
  }, [_vm._v("Faith-Based Program Self Reporting Form")]), _vm._v("  »\n          ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "program-goals"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Program Goals, Objectives and Performance Indicators")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing Goals, Objectives, and Performance\n  Indicators to assist in the process of grant and program development.")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "C6-qCnIsNjs",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "logic-models"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Logic Models")]), _vm._v(" "), _c('p', [_vm._v("View this Logic Model webinar series to assist in the process of program planning and development.")]), _vm._v(" "), _c('div', {
    staticClass: "card-deck text-center",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "rop6xoEA_NQ",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("The Value of Logic Models (Part 1)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "1bGkwPgwmcw",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Major Components of a Logic Model (Part 2)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "15rem"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "6O5YP5d2iTs",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("How Logic Models Support Implementation (Part 3)")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "amendments"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Amendments to Grant Agreements")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on the process of amending an existing Authority grant agreement.\n")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "iHsWphZtbzU",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "prior-approval"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Categories Needing Prior Approval")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing items that require Prior Approvals and/or Additional Justifications (even if they are detailed in the agreement narrative and budget).\n ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "YjkFmPid5DI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "travel-costs"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Travel Costs")]), _vm._v(" "), _c('p', [_vm._v("View a webinar describing Travel Costs and State Travel Guidelines.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "nQb8pK5e3Mo",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "subcontractors"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Subcontractors")]), _vm._v(" "), _c('p', [_vm._v("This webinar describes the Subcontract Approval process and\n     required Consultant/Contractor/Vendor documentation.\n\n   ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "zXIopZ4KeEI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "indirect-costs"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Budget Category: Indirect Costs")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on Indirect Costs.\n\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "4stkASoNY5w",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "self-reporting"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("Faith-Based Program Self Reporting Form")]), _vm._v(" "), _c('p', [_vm._v("View a webinar on how to complete the Authority's Faith-Based Program Self Reporting Form.\n\n     ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "x6cqf0075Fg",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added April 2017")])])])])])])])
}]}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50",
    attrs: {
      "id": "notice-of-funding-opportunity-federal-fiscal-year-victim-of-crime-act-2015-lead-entity-services-for-victims-of-sexual-assault-program"
    }
  }, [_vm._v("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR VICTIMS OF SEXUAL ASSAULT PROGRAM")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated to states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2015, Illinois received a VOCA award of $77.5 million. ")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are required to allocate a minimum of 10 percent of funds received for services to each of the following: victims of sexual assault, domestic violence, child abuse, and underserved victims of violent crime. VOCA funds may not be used to supplant or replace state and local funds that would otherwise be available for crime victim services and must be used to develop new projects or expand existing projects.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("ICJIA recently completed a statewide assessment of victim services in Illinois. The report was presented to the Ad Hoc Victim Services Committee for consultation and coordination with other state agencies and victim stakeholder groups. The final report’s recommendations were approved by ICJIA Board in January 2017. These recommendations outline a comprehensive plan to address victims’ needs in Illinois and are reflected in this funding opportunity where appropriate. ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was a priority.  To fulfill this priority, ICJIA has made available $16.3 million in VOCA grant funding for core services and related support costs for victims of sexual assault.  These funds will be made available to the Illinois Coalition Against Sexual Assault. ")]), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Application deadline: May 22, 2017")])]), _c('p'), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/static/grants/voca-sa/FINAL VOCA Lead Entity NOFO - SA 04 27 17.pdf"
    }
  }, [_vm._v("READ THE NOTICE OF FUNDING OPPORTUNITY  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "first",
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Sexual Assault, 100 N. 16th Street, Springfield, Illinois, 62703. ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("Notice of Funding Opportunity and application materials were provided to the Illinois Coalition Against Sexual Assault.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _c('p', [_vm._v("Application is due at 11:59 p.m., Monday, May 22, 2017. ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $16,300,000 in federal VOCA FFY15 funding is available through this solicitation.  ")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July 1, 2017 through September 30, 2018.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to the Authority quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-instructions"
    }
  }, [_vm._v("Application instructions:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact information")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Responses will be sent via email within five business days. The deadline for submitting questions is 5 p.m., Monday, May 15, 2017. ")]), _vm._v(" "), _vm._m(6)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#available-funds"
    }
  }, [_vm._v("Available Funds")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#period-of-performance"
    }
  }, [_vm._v("Period of Performance")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-instructions"
    }
  }, [_vm._v("Application Instructions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#contact-information"
    }
  }, [_vm._v("Contact Information")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit: "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("http://ojp.gov/ovc/about/victimsfund.html")]), _vm._v(".   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Please see the following link to access the report and recommendations: "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Monday, May 1, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday, May 22, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thursday May 25, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Monday, May 22, 2017. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("http://www.icjia.state.il.us")]), _vm._v(".")])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-info text-center",
    staticStyle: {
      "margin-bottom": "65px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "fa fa-info-circle fa-2x",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v("\n    "), _c('span', {
    staticClass: "my-text"
  }, [_c('strong', [_vm._v("The following forms are samples and not for use.")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header first"
  }, [_vm._v("GATA Uniform Grant Agreement Template")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("\nView an example of a basic ICJIA grant agreement.\n An actual grant agreement also will have program- and grantee-specific information.\n ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Agreement_Template/GATA_UNIFORM_GRANT_AGREEMENT_040517.pdf"
    }
  }, [_vm._v("\n  GATA Uniform Grant Agreement »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("ICJIA Uniform Budget Template")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View examples of the ICJIA Uniform Budget Template documents.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Budget_Instructions_(General).pdf"
    }
  }, [_vm._v("Budget Instructions (General).pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Budget_Instructions_(ICJIA).pdf"
    }
  }, [_vm._v("Budget Instructions (ICJIA).pdf»")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_A_ICJIA_Funds.pdf"
    }
  }, [_vm._v("Section A ICJIA Funds »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_A_Indirect_Cost_Info.pdf"
    }
  }, [_vm._v("Section A Indirect Cost Info")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_B_Match_Funds.pdf"
    }
  }, [_vm._v("Section B Match Funds »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Applicant_Certification.pdf"
    }
  }, [_vm._v("Applicant Certification »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_FFATA_Form.pdf"
    }
  }, [_vm._v("FFATA Form »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C1_Personnel.pdf"
    }
  }, [_vm._v("Section C1 Personnel »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C2_Fringe_Benefits.pdf"
    }
  }, [_vm._v("Section C2 Fringe Benefits »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C3_Travel.pdf"
    }
  }, [_vm._v("Section C3 Travel »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C4_Equipment.pdf"
    }
  }, [_vm._v("Section C4 Equipment.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C5_Supplies.pdf"
    }
  }, [_vm._v("Section C5 Supplies.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C6_Contractual.pdf"
    }
  }, [_vm._v("Section C6 Contractual.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C7_Indirect_Costs.pdf"
    }
  }, [_vm._v("Section C7 Indirect Costs.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Section_C_Budget_Summary.pdf"
    }
  }, [_vm._v("Section C Budget Summary.pdf »")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Budget_Template/ICJIA_Uniform_Budget_Template_032817_Sample_Agency_Approval.pdf"
    }
  }, [_vm._v("Agency Approval.pdf »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("ICJIA Fiscal Reports")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View a Monthly or a Quarterly Fiscal Report in the required reporting format. Reporting deadlines vary by grant.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Fiscal_Reporting/Grantee_Fiscal_Report_1-4_Quarter_with_Close_Out_with_Cents_4_2017_SAMPLE.pdf"
    }
  }, [_vm._v("Grantee Fiscal Report 1-4 Quarter with Close Out with Cent 04-2017 »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("Risk Assessment Form")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View an example of a programmatic Risk Assessment. The Risk Assessment Form may include additional questions specific to a grant program.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Risk_Assessment_Form/Programmatic_Risk_Assessment_Questionnaire_030817.pdf"
    }
  }, [_vm._v("Programmatic Risk Assessment Questionnaire 03-08-2017.pdf »")])])]), _vm._v(" "), _c('div', {
    staticClass: "document-header"
  }, [_vm._v("Uniform Application")]), _vm._v(" "), _c('div', {
    staticClass: "document-text"
  }, [_vm._v("View the ICJIA Uniform Application for Grant Assistance.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/documents/Uniform_Application/ICJIA_Uniform_Application_for_Grant_Assistance_110216.pdf"
    }
  }, [_vm._v("Uniform Application for Grant Assistance 11-02-2016 »")])])])])])])
}]}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "h3 section-title",
    staticStyle: {
      "text-transform": "uppercase",
      "padding-left": "15px",
      "padding-right": "15px"
    }
  }, [_vm._v(_vm._s(_vm.header))])])]), _vm._v(" "), (_vm.expired) ? _c('div', [_c('check-expiration', {
    attrs: {
      "expired": _vm.expired
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority seeks to fund a Statewide Domestic Violence Hotline Service\n            program. The grant will be made with Federal Fiscal Year 2016 (FFY16) Victim of Crime Act (VOCA) funds. A total\n            of $455,000 in funding is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program requirements")]), _vm._v(" "), _c('p', [_vm._v("The Statewide Domestic Violence Hotline Services program will fund advocates positions(s) to provide direct service\n            to victims through a statewide hotline. The City of Chicago Department of Family and Support Services may contract\n            with an external victim service provider to staff hotline services, but is required to submit at the time of\n            application a proposed contract between the agency and the victim service provider detailing advocate services\n            and costs.")]), _vm._v(" "), _c('p', [_vm._v("The funded programs will be required to submit quarterly progress reports.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the City of Chicago Department of Family and Support Services.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $455,000 in funding is available through this solicitation. Funding minimum and maximum values are\n            based on the population served, according to the following standards:")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of September 1, 2018 through August 31, 2019. Based on program performance\n            and fund availability, the Authority may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Ronnie Reichgelt")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress\n            reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.\n            Future awards and fund drawdowns may be withheld if reports are delinquent.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "45px"
    },
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_c('a', {
    staticStyle: {
      "font-weight": "900"
    },
    attrs: {
      "href": "/static/grants/20180608VOCAHotline/VOCADVhotlineNOFO.pdf"
    }
  }, [_vm._v("Download Notice of Funding Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., July 8, 2018.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The applicant must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,\n            "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA\n            pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of\n            application to be considered for funding. Applications from agencies that have not received ICQ approval will\n            not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to\n            "), _c('a', {
    attrs: {
      "href": "mailto:CJA.VOCANOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.VOCANOFO@Illinois.gov")]), _vm._v(" by 11:59 p.m., July 8, 2018, to be considered for funding. Proposals will not\n            be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will\n            not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("June 8, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., July 8, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designation")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("August 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Projected program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("September 1, 2018")])])])])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 spacerTop30"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://ilga.gov/legislation/ilcs/ilcs3.asp?ActID=3559&ChapterID=7"
    }
  }, [_vm._v("The\n        Grant Accountability and Transparency Act (GATA) of 2014")]), _vm._v(", 30 ILCS 708/1 et seq.,\n        increased accountability and transparency in the use of grant funds\n         and reduced the administrative burden on state agencies\n         and grantees through adoption of federal grant guidelines and regulations.")]), _vm._v(" "), _c('p', [_vm._v("Pursuant to the Act, the Grant Accountability and\nTransparency Unit (GATU) was established within the Governor's Office of Management and Budget; GATU is charged with implementation of the Act in coordination with state grant-making agencies and nonprofit organizations in Illinois. GATA requires grants administered by state agencies to be awarded in a competitive bidding process. In addition, all applicants must undergo a registration and pre-award screening process.\nThis competitive grant award process is initiated with a Notice of Funding Opportunity (NOFO).")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h3 fp-subhead first"
  }, [_vm._v("ICJIA Grant Award Process")]), _vm._v(" "), _c('p', [_vm._v("A Notice of Funding Opportunity (NOFO) requires applicants to\nconcisely address a specified scope of work, provide a\nprogram budget detailing personnel and equipment needs,\nand qualify their experience to implement the program's scope of services.\nApplications are competitively reviewed and scored.")]), _vm._v(" "), _c('p', [_vm._v("All applicants must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Register on the "), _c('a', {
    attrs: {
      "href": "https://www.illinois.gov/sites/GATA/Grantee/Pages/default.aspx"
    }
  }, [_vm._v("State of Illinois Grant Accountability and Transparency Act (GATA) web portal")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Pass the pre-qualification verification of the following: "), _c('ul', [_c('li', [_vm._v("valid DUNS number, current SAM.gov account;")]), _c('li', [_vm._v(" not be on the Federal Excluded Parties List;")]), _c('li', [_vm._v(" be in Good Standing with the Illinois Secretary of State, as applicable;")]), _c('li', [_vm._v(" not be on the Illinois Stop Payment list and not on the Dept. of Healthcare and Family Services Provider Sanctions list.")])])]), _vm._v(" "), _c('li', [_vm._v("Complete the Internal Control Questionnaire (ICQ).")])]), _vm._v(" "), _c('p', [_vm._v("\nOnce a grant award is given to an applicant\nthey must submit to ICJIA a grant packet that includes an ICJIA approved:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fully executed agreement")]), _vm._v(" "), _c('li', [_vm._v("Program narrative")]), _vm._v(" "), _c('li', [_vm._v("Program budget")]), _vm._v(" "), _c('li', [_vm._v("Sets of certification documents")]), _vm._v(" "), _c('li', [_vm._v("Programmatic Risk Assessment (PRA)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h3 fp-subhead"
  }, [_vm._v("Helpful Hints")]), _vm._v(" "), _c('p', [_vm._v("\nA well-developed grant application includes:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Data and evidence that support the program scope and suggested outputs.")]), _vm._v(" "), _c('li', [_vm._v("Program scope that is aligned with national, regional or local initiatives.")]), _vm._v(" "), _c('li', [_vm._v("Strong and established partnerships with community groups, other not-for-profits,\nand local governments, detailed in the program scope and in letters of support.")]), _vm._v(" "), _c('li', [_vm._v("Complete and concise responses in every section of the application.")])]), _vm._v(" "), _c('p', [_vm._v("Also consider:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Complete the ICQ section of the GATA pre-registration within 3 weeks prior to the submittal of your NOFO application.")]), _vm._v(" "), _c('li', [_vm._v("Submit your Letter of Intent and any questions to the agency that generated the NOFO as soon as possible.")]), _vm._v(" "), _c('li', [_vm._v("Attending the NOFO conference call and review all posted webinars.")])])])])])])])
}]}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants supporting a\n            comprehensive\n            community-law enforcement response to drugs. Grants will be made with State Fiscal Year 2019\n            Community-Law\n            Enforcement Partnership Deflection\n            & Substance Use Disorder Treatment ACT funds. A total of $500,000 in funding is available through\n            this\n            solicitation for use over a six-month period. Grant requests are limited to a minimum of $20,000, and\n            maximum of\n            $80,000.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("PROGRAM REQUIREMENTS")]), _vm._v(" "), _c('p', [_vm._v("Applicants may request funding under one or more categories.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "view-the-notice-of-funding-opportunity"
    }
  }, [_vm._v("VIEW THE NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("ELIGIBILITY INFORMATION")]), _vm._v(" "), _c('p', [_vm._v("An Implementing Agency must apply for funds on behalf of a law enforcement agency or other entity as\n            described\n            below. To be eligible for funding, deflection programs must be run by a municipal law enforcement agency,\n            county\n            sheriff’s office of this State,\n            the Department of State Police, or other law enforcement agency whose officers, by statute, are granted\n            and\n            authorized by Public Act 100-1025 to exercise powers like those conferred upon any peace officer employed\n            by a law\n            enforcement agency of this\n            State. Private and not-for-profit entities are not eligible to apply.")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("The law enforcement agency, licensed treatment providers, and community members or organizations shall:")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', [_vm._v("Applicants will also be required to submit a financial and administrative risk assessment utilizing an\n            Internal\n            Controls Questionnaire (ICQ) for SFY19 and obtain approval from their cognizant agencies before execution\n            of the\n            grant agreement. Delay in\n            obtaining SFY19 ICQ approval will result in a delay in grant execution.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("DEADLINE")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("AVAILABLE FUNDS")]), _vm._v(" "), _c('p', [_vm._v("Grants through this funding opportunity will be made with State Fiscal Year 2019 Community-Law\n            Enforcement\n            Partnership Deflection & Substance Use Disorder Treatment Act Funds awarded to the Illinois Criminal\n            Justice\n            Information Authority. Award range:\n            $20,000-$80,000.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "performance-period"
    }
  }, [_vm._v("PERFORMANCE PERIOD")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("CONTACT INFORMATION:")]), _vm._v(" "), _c('p', [_vm._v("Lajuana Murphy")]), _vm._v(" "), _c('p', [_vm._v("Criminal Justice Specialist II")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', [_vm._v("312-793-8550")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-technical-assistance-session"
    }
  }, [_vm._v("REQUIRED TECHNICAL ASSISTANCE SESSION")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "letter-of-intent"
    }
  }, [_vm._v("LETTER OF INTENT")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("REPORTING")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and\n            progress\n            reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform\n            Requirements. Future\n            awards and fund drawdowns\n            may be withheld if reports are delinquent.")]), _vm._v(" "), _c('p', [_vm._v("To receive funding per Public Act 100-1025, Section 15(d)(2) the grantee is required to submit program\n            data\n            established by the Illinois Criminal Justice Information Authority. The data collection will be\n            web-based, with\n            grantees receiving a data form\n            link to submit program data on a quarterly basis.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("REQUIRED DOCUMENTS")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("QUESTIONS")]), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('p', [_vm._v("Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly\n            or\n            indirectly with any ICJIA employee other than the respondent of this email address.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Read this page and "), _c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/CLEPNOFO.pdf"
    }
  }, [_vm._v("CLICK HERE")]), _vm._v(" for full CLEP\n              NOFO.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application Deadline: October 25, 2018 at 11:59pm.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_c('strong', [_vm._v("Model 1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Post-Overdose Response.")]), _vm._v(" This model features a response initiated by a law enforcement\n            officer after\n            emergency administration of medication to reverse overdose. The post-overdose response may be\n            multi-disciplinary and\n            may include the distribution\n            of naloxone, in-person contact, relationship building, and access to treatment. Example: Quick Response\n            Team.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_c('strong', [_vm._v("Model 2")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Self-Referral Response.")]), _vm._v(" This response is initiated by an individual by going to a\n            police station or\n            otherwise contacting a police officer or law enforcement agency and acknowledging their own substance\n            misuse and need\n            for treatment. The\n            response offers individuals assistance in obtaining substance use disorder treatment. Examples: Safe\n            Passage, A Way\n            Out.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_c('strong', [_vm._v("Model 3")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Active Outreach Response.")]), _vm._v(" This response is initiated by a police officer through\n            proactive\n            identification of persons likely to misuse substances or have a substance use disorder. Law enforcement\n            intentionally\n            seeks out and identifies\n            individuals who may need help, and a warm handoff is made to a service provider who engages them in\n            treatment.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_c('strong', [_vm._v("Model 4")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Community Engagement Response.")]), _vm._v(" This response is initiated by a police officer or law\n            enforcement\n            agency in response to a notification from a community member when no criminal charges are present.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_c('strong', [_vm._v("Model 5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Officer Intervention Response.")]), _vm._v(" These are commonly referred to as pre-arrest diversion\n            programs. The\n            response occurs when criminal charges are present but held in abeyance or citations issued with\n            requirement of\n            treatment.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/CLEPNOFO.pdf"
    }
  }, [_vm._v("Download the Community-Law Enforcement Partnership\n              for Deflection and Substance Use Disorder Treatment\n              Act\n              NOFO(PDF).")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("An Implementing Agency in this context is a law enforcement agency which will apply for the grant,\n              enter into the\n              inter-governmental grant agreement with the Authority, accept and account for grant funds, and meet all\n              Authority\n              reporting and compliance\n              requirements.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Establish a local deflection program plan to make potential clients and referral sources aware of the\n              services\n              available.")]), _vm._v(" "), _c('li', [_vm._v("Have a plan to coordinate program activities with community agencies in the service area, including\n              substance\n              abuse treatment, medical care and supportive service providers, behavioral health providers, as well as\n              relevant\n              government agencies.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the "), _c('a', {
    attrs: {
      "href": "www.grants.illinois.gov"
    }
  }, [_vm._v("Grant Accountability and\n              Transparency\n              Act (GATA) Grantee Portal")]), _vm._v(" to become eligible to apply for an award. During pre-qualification, Dun\n            and\n            Bradstreet verifications are performed,\n            including a check of Debarred and Suspended status and good standing with the Secretary of State.\n            Applicants must\n            have completed the GATA pre-qualification process by the date of application.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('strong', [_c('a', {
    attrs: {
      "href": "mailto:CJA.CLEDPNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.CLEDPNOFO@Illinois.gov")])]), _vm._v("\n            by "), _c('strong', [_vm._v("11:59 p.m., October 25, 2018")]), _vm._v(", to be considered for funding. Proposals will not be\n            accepted\n            by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be\n            reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Funding is available for the period of "), _c('strong', [_vm._v("January 1, 2019")]), _vm._v(", through "), _c('strong', [_vm._v("June 30, 2019")]), _vm._v(".\n            Based on program performance and fund availability, ICJIA may recommend allocation of funding to support\n            programming\n            for an additional 12\n            months.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Lajuana.Murphy@illinois.gov"
    }
  }, [_vm._v("Lajuana.Murphy@illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Pre-application webinars will be available for viewing beginning at "), _c('strong', [_vm._v("3:00 p.m. Monday, September\n              14, 2018")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://youtu.be/JmGxHR7Favc"
    }
  }, [_vm._v("CLEP Technical Assistance Webinar")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://youtu.be/FfhgYuQmblU"
    }
  }, [_vm._v("General Requirements")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("GATA Budget")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Prior Approvals")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Indirect Costs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applicant agencies are asked to submit a Letter of Intent to Apply by "), _c('strong', [_vm._v("5:00 p.m. on Friday,\n              September 28,\n              2018")]), _vm._v(". Failure to submit a Letter of Intent will not disqualify an applicant.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Letters of Intent are submitted by completing this "), _c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_3DvYtX9YdscwB2B"
    }
  }, [_vm._v("form")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_c('strong', [_vm._v("Task")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Date")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Wednesday, September 12, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Letters of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Friday, September 28, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Thursday, October 18, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., Thursday, October 25, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Monday, December 31, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Tuesday, January 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.CLEDPNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.CLEDPNOFO@Illinois.gov")]), _vm._v("\n            by the "), _c('strong', [_vm._v("11:59 p.m., Friday, September 21, 2018")]), _vm._v(", deadline for application review. Click\n            the links\n            below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Letters of Intent are submitted by completing the online template "), _c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_3DvYtX9YdscwB2B"
    }
  }, [_vm._v("HERE")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Download "), _c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/CLEPNOFO.pdf"
    }
  }, [_vm._v("Full Community-Law Enforcement Partnership\n              for Deflection Programs\n              Notice of Funding\n              Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/UniformApplicationforGrantAssistance.docx"
    }
  }, [_vm._v("Completed and signed\n                Uniform State Grant\n                Application (Word).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/CLEPProgramNarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/UniformBudgetTemplate.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative\n                (Excel).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("See also appendices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/AppendixI.pdf"
    }
  }, [_vm._v("Appendix I: Public Act 100-1025, previously SB\n                3023, Required Data Reporting\n                (PDF).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/AppendixII.pdf"
    }
  }, [_vm._v("Appendix II: Planning Activities (PDF).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/AppendixIII.pdf"
    }
  }, [_vm._v("Appendix III: State Map (PDF).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/AppendixIV.pdf"
    }
  }, [_vm._v("Appendix IV: Public Act 100-1025, previously SB\n                3023 (PDF).")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Download zip file of all required application documents and materials "), _c('a', {
    attrs: {
      "href": "/static/grants/20180911clep/CLEPNOFOFOLDER.zip"
    }
  }, [_vm._v("HERE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.CLEDPNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.CLEDPNOFO@Illinois.gov")]), _vm._v("\n            until "), _c('strong', [_vm._v("11:59 p.m., October 18, 2018")]), _vm._v(". . Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from\n            applicants and\n            their responses are revised weekly. "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/pdf/CLEP_NOFO_082018/CLEP_NOFO_Response_to_Application_Questions.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page",
    attrs: {
      "id": "section-0"
    }
  }, [_c('page-header', {
    attrs: {
      "header": "Grant Accountability and Transparency at ICJIA",
      "breadcrumb": false
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "section-1"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "padding-left": "1px"
    }
  }, [_c('div', {
    staticClass: "hero-heading"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "h4 section-title"
  }, [_c('router-link', {
    attrs: {
      "to": "/grants"
    }
  }, [_vm._v("\n                      Current Grant Opportunities\n                    ")])], 1)])]), _vm._v(" "), _c('grantfeed', {
    attrs: {
      "showExpired": "false",
      "sortBy": "created",
      "sortDirection": "desc"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "0px",
      "margin-right": "35px",
      "margin-bottom": "30px"
    }
  }, [_c('router-link', {
    staticClass: "read-more",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "to": "/grants"
    }
  }, [_vm._v("\n          Grant Archive »")])], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "margin-left": "50px",
      "margin-right": "50px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 spacerTop30"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://ilga.gov/legislation/ilcs/ilcs3.asp?ActID=3559&ChapterID=7"
    }
  }, [_vm._v("The\n                  Grant Accountability and Transparency Act (GATA) of 2014")]), _vm._v(", 30 ILCS 708/1 et seq.,\n                  increased accountability and transparency in the use of grant funds\n                   and reduced the administrative burden on state agencies\n                   and grantees through adoption of federal grant guidelines and regulations.")]), _vm._v(" "), _c('p', [_vm._v("Pursuant to the Act, the Grant Accountability and\n          Transparency Unit (GATU) was established within the Governor's Office of Management and Budget; GATU is charged with implementation of the Act in coordination with state grant-making agencies and nonprofit organizations in Illinois. GATA requires grants administered by state agencies to be awarded in a competitive bidding process. In addition, all applicants must undergo a registration and pre-award screening process.\n          This competitive grant award process is initiated with a Notice of Funding Opportunity (NOFO).")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h3 fp-subhead first"
  }, [_vm._v("ICJIA Grant Award Process")]), _vm._v(" "), _c('p', [_vm._v("A Notice of Funding Opportunity (NOFO) requires applicants to\n          concisely address a specified scope of work, provide a\n          program budget detailing personnel and equipment needs,\n          and qualify their experience to implement the program's scope of services.\n          Applications are competitively reviewed and scored.")]), _vm._v(" "), _c('p', [_vm._v("All applicants must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Register on the "), _c('a', {
    attrs: {
      "href": "https://www.illinois.gov/sites/GATA/Grantee/Pages/default.aspx"
    }
  }, [_vm._v("State of Illinois Grant Accountability and Transparency Act (GATA) web portal")]), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("Pass the pre-qualification verification of the following: "), _c('ul', [_c('li', [_vm._v("valid DUNS number, current SAM.gov account;")]), _c('li', [_vm._v(" not be on the Federal Excluded Parties List;")]), _c('li', [_vm._v(" be in Good Standing with the Illinois Secretary of State, as applicable;")]), _c('li', [_vm._v(" not be on the Illinois Stop Payment list and not on the Dept. of Healthcare and Family Services Provider Sanctions list.")])])]), _vm._v(" "), _c('li', [_vm._v("Complete the Internal Control Questionnaire (ICQ).")])]), _vm._v(" "), _c('p', [_vm._v("\n          Once a grant award is given to an applicant\n          they must submit to ICJIA a grant packet that includes an ICJIA approved:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Fully executed agreement")]), _vm._v(" "), _c('li', [_vm._v("Program narrative")]), _vm._v(" "), _c('li', [_vm._v("Program budget")]), _vm._v(" "), _c('li', [_vm._v("Sets of certification documents")]), _vm._v(" "), _c('li', [_vm._v("Programmatic Risk Assessment (PRA)")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "h3 fp-subhead"
  }, [_vm._v("Helpful Hints")]), _vm._v(" "), _c('p', [_vm._v("\n          A well-developed grant application includes:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Data and evidence that support the program scope and suggested outputs.")]), _vm._v(" "), _c('li', [_vm._v("Program scope that is aligned with national, regional or local initiatives.")]), _vm._v(" "), _c('li', [_vm._v("Strong and established partnerships with community groups, other not-for-profits,\n          and local governments, detailed in the program scope and in letters of support.")]), _vm._v(" "), _c('li', [_vm._v("Complete and concise responses in every section of the application.")])]), _vm._v(" "), _c('p', [_vm._v("Also consider:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Complete the ICQ section of the GATA pre-registration within 3 weeks prior to the submittal of your NOFO application.")]), _vm._v(" "), _c('li', [_vm._v("Submit your Letter of Intent and any questions to the agency that generated the NOFO as soon as possible.")]), _vm._v(" "), _c('li', [_vm._v("Attending the NOFO conference call and review all posted webinars.")])])])])])])])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "community-violence-defined"
    }
  }, [_vm._v("COMMUNITY VIOLENCE DEFINED:")]), _vm._v(" "), _c('p', [_vm._v("For purposes of this solicitation, Community Violence includes adult victims of violent crime  and minor victims who directly experience or witness violent crime in the home, school, work or neighborhood.  ")]), _vm._v(" "), _vm._m(2), _vm._m(3), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("ELIGIBILITY")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "ineligible-agencies"
    }
  }, [_vm._v("Ineligible agencies")]), _vm._v(" "), _c('p', [_vm._v("The following types of agencies are NOT eligible for this funding opportunity:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "eligible-agencies-and-gata-compliance"
    }
  }, [_vm._v("Eligible agencies and GATA compliance")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to Illinois public agencies and non-profits that have completed the GATA pre-qualification process and received approval of their ICQ from a state cognizant agency by the date of application.  In addition, applicants must meet the VOCA eligibility criteria listed on pages 23-25 of the Notice of Funding Opportunity.")]), _vm._v(" "), _c('p', [_vm._v("Please note applicants must Pre-register and obtain an approved Internal Control Questionnaire")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "pre-registration"
    }
  }, [_vm._v("Pre- Registration")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "approved-internal-control-questionnaire"
    }
  }, [_vm._v("Approved Internal Control Questionnaire")]), _vm._v(" "), _c('p', [_vm._v("The pre-qualification process also includes a financial and administrative risk assessment using an Internal Controls Questionnaire (ICQ). The ICQ must be submitted through the GATA portal and approved by a State cognizant agency by the date of application submission in order for an application to be reviewed.  All applications will be pre-screened for completeness and ICQ approval. Applications from agencies that have not received approval of their SFY18 ICQ will not be reviewed.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("NOTICE OF INTENT")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application MUST complete an online Notice of Intent form by 11:59 p.m., July 28, 2017. ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The projected period of performance for awards resulting from this opportunity is November 1, 2017, through October 31, 2018. Contingent on satisfactory performance, ICJIA may support 24 additional months of funding for each project. ")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "mandatory-applicant-technical-assistance-video"
    }
  }, [_vm._v("Mandatory Applicant Technical Assistance Video")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/k5bqS0ac1XA",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('a', {
    staticClass: "btn btn-secondary fix",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3615136/VOCA-Community-Violence-Program-Mandatory-Technical-Assistance-Video-Certification"
    }
  }, [_vm._v("SUBMIT VIDEO CERTIFICATION  »")])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE:")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be required to submit to ICJIA quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("APPLICATION MATERIALS:")]), _vm._v(" "), _c('p', [_vm._v("Completed application materials must be emailed to cja.vocagrantsunit@illinois.gov by 11:59 p.m., August 10, 2017, to be considered for funding.  Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")]), _vm._v(" "), _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at cja.vocagrantsunit@illinois.gov.")]), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required documents")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "additional-documents"
    }
  }, [_vm._v("Additional Documents")]), _vm._v(" "), _c('p', [_vm._v("The following documents are required to facilitate efficient grant processing but will not be used in determining eligibility.")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h5', {
    attrs: {
      "id": "non-profit-agency-required-documents"
    }
  }, [_vm._v("Non-Profit Agency Required Documents")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download application documents")]), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "responses-to-applicant-questions"
    }
  }, [_vm._v("Responses to Applicant Questions")]), _vm._v("\n\nQuestions from applicants and their responses are updated weekly. View them here:\n"), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/VOCACommunityViolenceResponsesToApplicantQuestions.pdf"
    }
  }, [_vm._v("Responses to Applicant Questions")])], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#responses-to-applicant-questions"
    }
  }, [_vm._v("Responses to applicant questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The purpose of this grant opportunity is to fund direct services for victims of community violence. Applicants may request a minimum of "), _c('span', [_vm._v("$")]), _vm._v("75,000 to a maximum of $1,000,000 in federal funding for use over a 12-month period. The term of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, domestic and sexual violence are included under this focus area with the following parameters: "), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Domestic and sexual violence should not be the primary focus of victimization under this funding. Agencies who wish to primarily serve victims of these crimes, should apply for funding through the Illinois Coalition Against Domestic Violence and/or the Illinois Coalition Against Sexual Assault.  ")]), _vm._v(" "), _c('li', [_vm._v("Domestic and sexual violence victimization may emerge when serving community violence victims. Therefore applicants must develop a written agreement and working relationship with experienced domestic and sexual violence agencies so that clients have easy access to staff appropriately trained in domestic and sexual violence victim services. Applications must include a signed letter of agreement in which both parties agree to provide domestic and sexual violence consultation and/or training when needed, and referral process where appropriate. ")]), _vm._v(" "), _c('li', [_vm._v("The applicant agency will refer clients to a specialized victim service agency in cases where it is appropriate. For example, referral to a specialized victim service agency must take place if child sexual abuse emerges in the course of service delivery and agency staff do not have the clinical skills to address it. ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("See the "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/VOCAComunityViolenceFinalNOFO062017.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(", for program design, staff, and training requirements.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Criminal justice entities, such as law enforcement, prosecution and/or court-referred services such as Court Appointed Special Advocates (CASA). Funding for criminal justice-based victim services may be offered in a future funding opportunity.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All applicants must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("http://www.grants.illinois.gov")]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications are performed, including a check of Debarred and Suspended status and good standing with the Illinois Secretary of State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Read the "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/VOCAComunityViolenceFinalNOFO062017.pdf"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(". ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applications are due at 11:59 p.m., Thursday, August 10, 2017. Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto: cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-secondary fix",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3615391/VOCA-Community-Violence-NOFO-Notice-of-Intent"
    }
  }, [_vm._v("SUBMIT NOTICE OF INTENT  »")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("A total of "), _c('span', [_vm._v("$")]), _vm._v("11 million is available through this opportunity.  Applicants may request a minimum of "), _c('span', [_vm._v("$")]), _vm._v("75,000 to a maximum of $1,000,000 in federal funding for use over a 12-month period. Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The deadline for submitting questions is 11:59 p.m., August 3, 2017. All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "https://gata.icjia.cloud/"
    }
  }, [_vm._v("https://gata.icjia.cloud/")]), _vm._v(". Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to  "), _c('br'), _vm._v("\nquestions shall be binding on the state. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applicants must view a mandatory pre-recorded video on the ICJIA website at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud/"
    }
  }, [_vm._v("https://grants.icjia.cloud/")]), _vm._v(".  The webinar will be available for viewing beginning at 1:30 p.m. on June 26, 2017.  The applicant must certify viewing this recording. Information provided during this video will be unofficial and not binding on the State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Release of NOFO and open application period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("June 26, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("August 3, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday, August 10, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("September 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Award and rejection letters sent")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("By September 28, 2017")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Start Program Performance Period")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("November 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application for each agency requesting funding. This document will need to be signed and scanned.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word that meets program requirements outlined in Section A. Applicant’s narrative must be submitted in Word and formatted in the posted Program Narrative. Application should be 20 pages maximum, drafted in Times New Roman 12-point font and double-spaced with 1 inch margins. Please number pages.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed VOCA SAR form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative in Excel for each funded agency.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Logic Model")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Signed letter of agreement")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed Eligibility Requirements Certification Form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Self-Certification form")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Fiscal Information Sheet-leave award amount and agreement number blank")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed Audit Information Sheet-leave award amount and agreement number blank")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed Debarment certification")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed and signed EEOP certifications")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Civil Rights certifications")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Programmatic Risk Assessment. This Excel document will need to be submitted unsigned electronically with the application. A signed scanned version will be due if application is approved for funding.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Non-supplanting Certification")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Mandatory Forms Checklist")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("United States Internal Revenue Service 501(c)(3) determination letter for nonprofit organizations.")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Self-Report Statement of Faith Based Organization")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Proof of Good Standing from the Illinois Secretary of State")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/icjiaUniformApplicationVOCACommunityViolence.docx"
    }
  }, [_vm._v("Uniform Application")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/CommunityViolenceProgramNarrative.docx"
    }
  }, [_vm._v("Community Violence Program Narrative")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/ICJIAvocaCommunityViolenceBudgetandBudgetNarrrative.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/VOCASAR.docx"
    }
  }, [_vm._v("VOCA SAR Form")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/LogicModel.docx"
    }
  }, [_vm._v("LogicModel")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/EligibilityCertificationFINAL.docx"
    }
  }, [_vm._v("Eligibility Requirements Certification")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/SelfCertification.docx"
    }
  }, [_vm._v("Self-Certification")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/FiscalInformationSheet.docx"
    }
  }, [_vm._v("Fiscal Info Sheet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/AuditInfoSheet.docx"
    }
  }, [_vm._v("Audit Info Sheet")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/CertificationLobbyingDebarmentallgrants.pdf"
    }
  }, [_vm._v("Certification on Lobbying, Debarment etc")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/EEOPCert.docx"
    }
  }, [_vm._v("EEOP Certification")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/CivilRightsComplianceCertification.docx"
    }
  }, [_vm._v("Civil Rights Compliance Certification")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/ProgrammaticRiskAssessmentQuestionnaire.xlsx"
    }
  }, [_vm._v("Programmatic Risk Assessment Questionnaire")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/Non-supplantingCertificationallgrants.docx"
    }
  }, [_vm._v("Non supplanting Certification")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/MandatoryFormsChecklist.docx"
    }
  }, [_vm._v("Mandatory Forms Checklist")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/FaithBasedOrganizationSelfReport.docx"
    }
  }, [_vm._v("Faith Based Self Report Form")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/Attachment1.pdf"
    }
  }, [_vm._v("Attachment 1 Trauma Informed Services")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/Attachment2.pdf"
    }
  }, [_vm._v("Attachment 2 Evidence Informed Trauma Focused Therapies")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/Attachment3.docx"
    }
  }, [_vm._v("Attachment 3 Budget Instructions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/2017CommunityViolence/Attachment4.pdf"
    }
  }, [_vm._v("Attachment 4 State Map")])])
}]}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('newsfeed')], 1)])], 1)])
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smoothScroll"
  })
},staticRenderFns: []}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "background": "#ccc",
      "height": "50px",
      "padding-top": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "right",
      "margin-right": "30px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v("\n   / \n  "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('center', [_c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity-services-for-victims-of-sexual-assault-program"
    }
  }, [_vm._v("Notice of Funding Opportunity Services for Victims of Sexual Assault Program")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "link-to-nofo"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICASA/ICASA Lead Entity NOFO.docx"
    }
  }, [_vm._v("LINK TO NOFO")])])]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants for the Services for Victims of Sexual Assault Program. Grants will be made with Victims of Crime Act FFY17 funds. A total of $18,300,000 in funding is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was a priority. To fulfill this priority, ICJIA has made available VOCA grant funding for core services and related support costs for victims of sexual assault. These funds will be made available to the Illinois Coalition Against Sexual Assault.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Sexual Assault, 100 N. 16th Street, Springfield, Illinois, 62703.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of Victims of Crime Act FFY17 funds. A minimum of $18,300,000 dollars will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of July 1, 2019, through June 30, 2020.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("Technical Assistance Session")]), _vm._v(" "), _c('p', [_vm._v("N/A")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit monthly/quarterly financial reports, monthly/quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Ronnie J. Reichgelt")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(9)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline:")]), _vm._v(" Application materials must be received by "), _c('strong', [_vm._v("11:59 p.m. on Sunday, March 3, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "https://grants.illinois.gov/portal/"
    }
  }, [_vm._v("https://grants.illinois.gov/portal/")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of period of performance start date, July 1, 2019 to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOaddress@Illinois.gov"
    }
  }, [_vm._v("NOFOaddress@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 1, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical Assistance Recording available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 25, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("March 3, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Office of Victims of Crime portal at "), _c('a', {
    attrs: {
      "href": "https://ovcpmt.ojp.gov/"
    }
  }, [_vm._v("https://ovcpmt.ojp.gov/")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019,")]), _vm._v(" deadline for application review.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICASA/ICASAapplication.pdf"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICASA/ICASAprogramnarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICASA/ICASAbudget.xls.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" until "), _c('strong', [_vm._v("11:59 p.m. on March 3, 2019.")]), _vm._v(" Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:NOFOemail@illinois.gov"
    }
  }, [_vm._v("NOFOemail@illinois.gov")])])
}]}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('span', {
    staticClass: "control-panel"
  }, [_vm._v("Display: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterType),
      expression: "filterType"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    attrs: {
      "id": "filterType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeFilter($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "current"
    }
  }, [_vm._v("CURRENT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "expired"
    }
  }, [_vm._v("EXPIRED")])]), _vm._v(" "), _c('span', {
    staticClass: "control-panel control-panel-spacer"
  }, [_vm._v("Sort by: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sort),
      expression: "sort"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sort = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSortBy($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "title"
    }
  }, [_vm._v("TITLE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "posted"
    }
  }, [_vm._v("POST DATE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "expired"
    }
  }, [_vm._v("EXPIRATION DATE")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.direction),
      expression: "direction"
    }],
    staticStyle: {
      "font-size": "13px",
      "font-weight": "900"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.direction = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSortDirection($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("ASC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("DESC")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-center"
  }, [_c('h4', [_vm._v(_vm._s(_vm.warning))])]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "grantFeed"
    }
  }, _vm._l((_vm.grants), function(grant) {
    return _c('li', [_c('div', {
      staticClass: "grant-news"
    }, [_c('router-link', {
      staticClass: "grant-title",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v(_vm._s(grant.title) + "\n                     ")]), _vm._v(" "), _c('div', {
      staticClass: "grant-date"
    }, [(_vm.isItNew(grant.posted)) ? _c('span', [_c('span', {
      staticClass: "new"
    }, [_vm._v("NEW!")]), _vm._v(" | ")]) : _vm._e(), _vm._v("Posted: " + _vm._s(_vm._f("moment")(grant.posted)) + " |\n\n                       "), (_vm.checkExpire(grant.expired)) ? _c('span', {
      staticStyle: {
        "color": "red",
        "font-weight": "900"
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(grant.expired)) + " (EXPIRED)")]) : _c('span', {
      staticClass: "grant-deadline"
    }, [_vm._v("Deadline: " + _vm._s(_vm._f("moment")(grant.expired)))])]), _vm._v(" "), _c('div', {
      staticClass: "grant-description",
      domProps: {
        "innerHTML": _vm._s(grant.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grant-readmore"
    }, [_c('router-link', {
      staticClass: "read-more-news btn btn-secondary btn-sm\n                       btn-readmore",
      attrs: {
        "to": grant.path
      }
    }, [_vm._v("Read more >>\n                       ")])], 1)], 1)])
  }))])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act (VOCA)\n                            Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied\n                            against criminals convicted of federal crimes and allocated to states by formula by the Office\n                            for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2016, Illinois\n                            received a VOCA award of $87 million.")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are\n                            required to allocate a minimum of 10 percent of funds received for services to each of the following:\n                            victims of sexual assault, domestic violence, child abuse, and underserved victims of violent\n                            crime. VOCA funds may not be used to supplant or replace state and local funds that would otherwise\n                            be available for crime victim services and must be used to develop new projects or expand existing\n                            projects.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("The Ad Hoc Victim Services Committee made a priority of strengthening and expansion of core services\n                            for victims of crime. To fulfill this priority, ICJIA made available $7.1 million in VOCA grant\n                            funding for core services and related support costs for minor victims of abuse services. These\n                            funds will be made available to the Children’s Advocacy Centers of Illinois (CACI).")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Children’s Advocacy Centers of Illinois, 400 S. 9th Street, Springfield,\n                            Illinois, 62701.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("This Notice of Funding Opportunity and application materials were provided to the Children’s Advocacy\n                            Centers of Illinois.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/grants/20180205LeadEntityCAC/VOCA Lead Entity NOFO - CACI - Final -5.0.docx"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $7.1 million in FFY16 VOCA funding is available through this solicitation.")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability\n                            of funds.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July 1, 2018, through\n                            September 30, 2019.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to ICJIA monthly fiscal and quarterly data reports.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit:\n                            "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("http://ojp.gov/ovc/about/victimsfund.html")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Last year, ICJIA completed a statewide assessment of victim services in Illinois. The report was\n                            presented to the Ad Hoc Victim Services Committee for consultation and coordination with other\n                            state agencies and victim stakeholder groups. The final report’s recommendations were approved\n                            by the ICJIA Board in January 2017. These recommendations outline a comprehensive plan to address\n                            victims’ needs in Illinois and are reflected in this funding opportunity Please see the following\n                            link to access the report and recommendations:\n                            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at\n                            "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Friday, March 09, 2018.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Wednesday, February 07, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Application deadline")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., Friday, March 09, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("May 25, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Program start date")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("July 1, 2018")])])])])])
}]}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    attrs: {
      "id": "notice-of-funding-opportunity-federal-fiscal-year-victimof-crime-act-2015-lead-entity-services-for-childrens-advocacy-centers-program"
    }
  }, [_vm._v("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR CHILDREN’S ADVOCACY CENTERS PROGRAM")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated to states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2015, Illinois received a VOCA award of $77.5 million.")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are required to allocate a minimum of 10 percent of funds received for services to each of the following: victims of sexual assault, domestic violence, child abuse, and underserved victims of violent crime. VOCA funds may not be used to supplant or replace state and local funds that would otherwise be available for crime victim services and must be used to develop new projects or expand existing projects.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee the strengthening and expansion of core services for victims of crime was a priority.  To fulfill this priority, ICJIA has made available $7.1 million in VOCA grant funding for core services and related support costs for minor victims of abuse services.  These funds will be made available to the Children’s Advocacy Centers of Illinois (CACI).")]), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Application deadline: May 22, 2017")])]), _c('p'), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/static/grants/voca-caci/FINAL VOCA Lead Entity NOFO - CACI 04 27 17.pdf"
    }
  }, [_vm._v("READ THE NOTICE OF FUNDING OPPORTUNITY "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _c('p'), _vm._v(" "), _c('h3', {
    staticClass: "first sidebarLink",
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Children’s Advocacy Centers of Illinois, 400 S. 9th Street, Springfield, Illinois, 62701.")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("Notice of Funding Opportunity and application materials were provided to the Children’s Advocacy Centers of Illinois.")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _c('p', [_vm._v("Application is due at 11:59 p.m., Monday, May 22, 2017.")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $7,100,000 in federal VOCA FFY15 funding is available through this solicitation.  ")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July1, 2017 through September 30, 2018.  ")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to the Authority quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "application-instructions"
    }
  }, [_vm._v("Application instructions:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', {
    staticClass: "sidebarLink",
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact information")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Responses will be sent via email within five business days. The deadline for submitting questions is 5 p.m., Monday, May 15, 2017.")]), _vm._v(" "), _vm._m(6)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#available-funds"
    }
  }, [_vm._v("Available Funds")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#period-of-performance"
    }
  }, [_vm._v("Period of Performance")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-instructions"
    }
  }, [_vm._v("Application Instructions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#contact-information"
    }
  }, [_vm._v("Contact Information")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit: "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("Office for Victims of Crime")]), _vm._v(".   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("ICJIA recently completed a statewide assessment of victim services in Illinois. The report was presented to the Ad Hoc Victim Services Committee for consultation and coordination with other state agencies and victim stakeholder groups. The final report’s recommendations were approved by ICJIA Board in January 2017. These recommendations outline a comprehensive plan to address victims’ needs in Illinois and are reflected in this funding opportunity where appropriate. Please see the following link to access the report and recommendations: "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("Ad Hoc Victim Services Committee Research Report")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Monday, May 1, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday, May 22, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thursday May 25, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Monday, May 22, 2017.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("www.icjia.state.il.us")]), _vm._v(". ")])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    attrs: {
      "id": "notice-of-funding-opportunity-federal-fiscal-year-victimof-crime-act-2015-lead-entity-services-for-victims-of-domestic-violence-program"
    }
  }, [_vm._v("FEDERAL FISCAL YEAR VICTIM OF CRIME ACT 2015 LEAD ENTITY SERVICES FOR VICTIMS OF DOMESTIC VIOLENCE PROGRAM")]), _vm._v(" "), _c('p', [_vm._v("ICJIA is the state agency charged with the administration of the Illinois’ Victims of Crime Act Victim Assistance Formula Grant Program. This program is supported by fines and penalties levied against criminals convicted of federal crimes and allocated to states by formula by the Office for Victims of Crime of the U.S. Department of Justice. In federal fiscal year 2015, Illinois received a VOCA award of $77.5 million. ")]), _vm._v(" "), _c('p', [_vm._v("VOCA grants must support the provision of direct services to victims of violent crime. States are required to allocate a minimum of 10 percent of funds received for services to each of the following: victims of sexual assault, domestic violence, child abuse, and underserved victims of violent crime. VOCA funds may not be used to supplant or replace state and local funds that would otherwise be available for crime victim services and must be used to develop new projects or expand existing projects.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was identified as a priority.  To fulfill this priority, ICJIA has made available $17.3 million in VOCA grant funding for core services and related support costs for victims of domestic violence.  These funds will be made available to the Illinois Coalition Against Domestic Violence. ")]), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Application deadline: May 22, 2017")])]), _c('p'), _vm._v(" "), _c('p'), _c('center', [_c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "/static/grants/voca-dv/FINAL VOCA Lead Entity NOFO - DV    04 27 17.pdf"
    }
  }, [_vm._v("READ THE NOTICE OF FUNDING OPPORTUNITY "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _c('p'), _vm._v(" "), _c('h3', {
    staticClass: "first",
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Domestic Violence, 806 S. College Street, Springfield, Illinois, 62704.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _c('p', [_vm._v("Notice of Funding Opportunity and application materials were provided to the Illinois Coalition Against Domestic Violence.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _c('p', [_vm._v("Application is due at 11:59 p.m., Monday, May 22, 2017. ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $17,300,000 in federal VOCA FFY15 funding is available through this solicitation.  ")]), _vm._v(" "), _c('p', [_vm._v("Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of performance")]), _vm._v(" "), _c('p', [_vm._v("The award resulting from this opportunity will have a period of performance of July1, 2017 through September 30, 2018.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The funded agency will be required to submit to the Authority quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-instructions"
    }
  }, [_vm._v("Application instructions:")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact information")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Responses will be sent via email within five business days. The deadline for submitting questions is 5 p.m., Monday, May 15, 2017. ")]), _vm._v(" "), _vm._m(6)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#available-funds"
    }
  }, [_vm._v("Available Funds")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#period-of-performance"
    }
  }, [_vm._v("Period of Performance")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-instructions"
    }
  }, [_vm._v("Application Instructions")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#contact-information"
    }
  }, [_vm._v("Contact Information")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("For more information on the VOCA Program please visit: "), _c('a', {
    attrs: {
      "href": "http://ojp.gov/ovc/about/victimsfund.html"
    }
  }, [_vm._v("Office for Victims of Crime")]), _vm._v(".   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("ICJIA recently completed a statewide assessment of victim services in Illinois. The report was presented to the Ad Hoc Victim Services Committee for consultation and coordination with other state agencies and victim stakeholder groups. The final report’s recommendations were approved by ICJIA Board in January 2017. These recommendations outline a comprehensive plan to address victims’ needs in Illinois and are reflected in this funding opportunity where appropriate. Please see the following link to access the report and recommendations: "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/articles/ad-hoc-victim-services-committee-research-report"
    }
  }, [_vm._v("Ad Hoc Victim Services Committee Research Report")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Monday, May 1, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Application deadline")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("11:59 p.m., Monday, May 22, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Authority Budget Committee meeting")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Thursday May 25, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("July 1, 2017")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Application materials must be submitted to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(" by 11:59 p.m., Monday, May 22, 2017. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email to Ronnie Reichgelt at "), _c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted on the Authority website at "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("http://www.icjia.state.il.us")]), _vm._v(".")])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting applications for grants for the Services for Underserved Areas and Victim Groups Program. Grants will be made with FFY18 Violence Against Women Act funds. A total of $1.4 million is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, enhancing victim safety and providing access to services for underserved communities is a priority. To fulfill this priority, ICJIA has made available VAWA grant funding for victims of domestic violence and sexual assault in underserved communities and victim groups.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open not for profit corporations that administer state-wide community-based domestic violence programs, which provide advocacy, technical assistance, training, public information about domestic violence issues, in-person counseling, information and referral, community education, professional training, institutional advocacy and provide services to victims of domestic violence in underserved communities.")]), _vm._v(" "), _c('p', [_vm._v("It is also open for not for profit corporations that administer state-wide sexual assault crisis centers, which provide comprehensive sexual assault services: 24-hour hotline, 24-hour criminal justice and medical advocacy services, in-person counseling, information and referral, community education, professional training, institutional advocacy, and provide services to victims in underserved communities or victim groups. In addition, applicants must administer state and federal funds to its members, set standards for services and monitor each center to ensure program and fiscal accountability.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of FFY18 Violence Against Women Act funds. A minimum of $14.1 million will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of July 1, 2019, through June 30, 2020.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("Technical Assistance Session")]), _vm._v(" "), _c('p', [_vm._v("N/A")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit monthly/quarterly financial reports, monthly/quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(9)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190329vawa/VAWANOFO.pdf"
    }
  }, [_vm._v("Link to NOFO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline:")]), _vm._v(" Application materials must be received by "), _c('strong', [_vm._v("11:59 p.m. on Tuesday, April 30, 2019")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "https://grants.illinois.gov/portal/"
    }
  }, [_vm._v("https://grants.illinois.gov/portal/")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of period of performance start date, July 1, 2019 to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:2019VAWANOFO@Illinois.gov"
    }
  }, [_vm._v("2019VAWANOFO@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., Tuesday, April 30, 2019,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 1, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical Assistance Recording available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 15, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("April 30, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Office of Victims of Crime portal at "), _c('a', {
    attrs: {
      "href": "https://OVCPMT.usdoj.gov"
    }
  }, [_vm._v("https://OVCPMT.usdoj.gov")]), _vm._v(" .")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:2019VAWANOFO@Illinois.gov"
    }
  }, [_vm._v("2019VAWANOFO@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., Tuesday, April 30, 2019,")]), _vm._v(" deadline for application review.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:2019VAWANOFO@Illinois.gov"
    }
  }, [_vm._v("2019VAWANOFO@Illinois.gov")]), _vm._v(" until 11:59 p.m. on April 15, 2019. Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Shataun Hailey"), _c('br'), _vm._v("\n    Illinois Criminal Justice Information Authority"), _c('br'), _vm._v("\n    300 West Adams, Suite 200"), _c('br'), _vm._v("\n    Chicago, IL 60606"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:2019VAWANOFO@Illinois.gov"
    }
  }, [_vm._v("2019VAWANOFO@Illinois.gov")])])
}]}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants for services to families of homicide victims. Grants will be made with State Fiscal Year 2019 (SFY19) Death Penalty Abolition (DPA) funds. A total of $300,000 in funding\n    is available through this solicitation for use over a period of three months. Contingent on future appropriation and satisfactory performance $1,700,000 in SFY20 DPA funds may also be available through this opportunity.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("Through this funding opportunity, ICJIA is soliciting applications proposing the provision of comprehensive services for families of victims of homicide or murder. Applicants may propose to provide a comprehensive program that provides crisis intervention,\n    case management and counseling, or may propose to provide one or more components that meet the needs of the identified target population and complements existing services. Proposals that do not request funding for all three program components must\n    detail how the applicant will assure that the new program will coordinate services with the existing program components.")]), _vm._v(" "), _c('p', [_vm._v("Applicants proposing to provide all three program components must provide letters(s) documenting the support and cooperation of the local law enforcement, county or municipal agency which will notify the applicant of the homicide.")]), _vm._v(" "), _c('p', [_vm._v("Applicants proposing to provide fewer than three program components must provide letters documenting coordination with the agencies providing the other program components.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants are limited to non-profit entities.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this opportunity are a portion of a SFY19 DPA funds. A maximum of $300,000 will be made available through this funding opportunity.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("SFY19 funding is available for the period of April 1, 2019, to June 30, 2019. Based on program performance and future appropriation, ICJIA may recommend allocation of funding to support an additional 33 months of program activity. If appropriated, SFY20\n    funding will be available for the period of July 1, 2019, to June 30, 2020.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Greg Stevens")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "required-technical-assistance-recordings"
    }
  }, [_vm._v("Required Technical Assistance Recordings")]), _vm._v(" "), _c('p', [_vm._v("Technical assistance recordings providing additional information regarding this funding opportunity will be available for viewing beginning at 1:30 p.m. on Friday, January 11, 2019.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notices-of-intent"
    }
  }, [_vm._v("Notices of Intent")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in applying are asked to submit an online Notice of Intent by 11:59 p.m., Friday, January 18, 2019.")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns\n    may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', [_vm._v("Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than the respondent of this email address. Only written answers to questions shall be binding on the\n    state.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "id": "view-the-notice-of-funding-opportunity"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190111DPAservicesNOFO/DPAservicesNOFO.pdf"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., February 12, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed\n    the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of application to be considered for funding. Applications from agencies that have not received ICQ approval will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAservicesNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAservicesNOFO@Illinois.gov")]), _vm._v(" by 11:59 p.m., Tuesday, February 12, 2019, to be considered for funding. Proposals will not be accepted by mail,\n    fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Gregory.Stevens@Illinois.gov"
    }
  }, [_vm._v("Gregory.Stevens@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/MDd0hpd0808"
    }
  }, [_vm._v("Recording 1: DPA Services NOFO Guidelines (12:47)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("Recording 2: General Requirements (11:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("Recording 3: GATA Budget (19:03)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Recording 4: Indirect Costs (6:18)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Recording 5: Prior Approvals (6:05)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_b2XTIkFxFR0807z"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO Posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("January 11, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical assistance recordings available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("January 11, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notices of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("January 18, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 6, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., February 12, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 28, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Projected program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("April 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAservicesNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAservicesNOFO@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., February 12, 2019")]), _vm._v(", deadline for application review. Click the links below to download\n    copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190111DPAservicesNOFO/DPAservicesAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190111DPAservicesNOFO/DPAservicesNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190111DPAservicesNOFO/SFY19DPAservices.BUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.DPAservicesNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.DPAservicesNOFO@Illinois.gov")]), _vm._v(" until "), _c('strong', [_vm._v("11:59 p.m., February 6, 2019")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from applicants and their responses are revised weekly. "), _c('a', {
    attrs: {
      "href": "/static/grants/20190111DPAservicesNOFO/DPAservicesRESPONSEtoAPPLICANTQuestions.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("\n            The Authority administers a variety of federal and state grant programs.\n            "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/grants/overview#tab_grant-programs"
    }
  }, [_vm._v("View programs")]), _vm._v(" to see if your organization\n            meets the eligibility requirements of an Authority-administered program. Then\n            "), _c('router-link', {
    attrs: {
      "to": "/grants"
    }
  }, [_vm._v("visit grant opportunities")]), _vm._v(" to see if we are accepting grant applications for the program.")], 1)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("When you see a grant opportunity listed on the\n          "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Authority's GATA website")]), _vm._v(", check to make sure your agency meets the program's specific criteria for\n          grant funding. If your agency is eligible for funding, read the instructions for information on how to submit an\n          application.")], 1)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question first"
  }, [_c('p', [_vm._v("\n            I have a program and am in need of grant funding. What programs do you administer?\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("What are the funding cycles?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Federal programs are funded from October 1 to September 30. State programs are funded from July 1 to June 30.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("How do I find out about grant opportunities?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Find out about Authority grant opportunities, news, and research by checking the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("ICJIA website")]), _vm._v(",\n            "), _c('a', {
    attrs: {
      "href": "https://visitor.r20.constantcontact.com/manage/optin?v=001MqUcqqvjwLCJXlLMSWbTe3zHHmEQgFeBuHvBcJWTbwgrxFbDSGx4HSUPpI6DJWMUPgbljtLxffqIcGFTgCnr-auak88ybvRxpoJlTMGPtZs%3D"
    }
  }, [_vm._v("subscribing to the CJ Dispatch")]), _vm._v(",\n            and following us on "), _c('a', {
    attrs: {
      "href": "https://www.facebook.com/ICJIA/"
    }
  }, [_vm._v("Facebook")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://twitter.com/icjia_illinois?lang=en"
    }
  }, [_vm._v("Twitter")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("How do I apply for a grant?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-question"
  }, [_c('p', [_vm._v("We tried to apply for a grant but had problems with the application process. What should we do?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-response"
  }, [_c('p', [_vm._v("Please use the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/contact"
    }
  }, [_vm._v("Authority\n  contact information")]), _vm._v(" on the request for applications for technical assistance at any point in the process.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card well",
    attrs: {
      "id": "gata-procedueral-webinar"
    }
  }, [_c('h2', {
    staticClass: "h4"
  }, [_vm._v("GATA General Procedural Common FAQs webinar")]), _vm._v(" "), _c('p', [_vm._v("This webinar answers frequently asked questions about the grant review process. Topics include rules and regulations,\n          common errors on applications, certifications, and budgetary issues.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "16rem",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('span', {
    staticClass: "card-img-top youtube",
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "id": "g18hgiS3RYI",
      "alt": "Card image cap"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Added May 2017")])])])])
}]}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('center', [_c('h2', {
    attrs: {
      "id": "notice-of-funding-opportunity-services-for-victims-of-domestic-violence-program"
    }
  }, [_vm._v("Notice of Funding Opportunity Services for Victims of Domestic Violence Program")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "link-to-nofo"
    }
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICADV/ICADV Lead Entity NOFO.docx"
    }
  }, [_vm._v("LINK TO NOFO")])])]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting applications for grants for the Services for Victims of Domestic Violence Program. Grants will be made with FFY17 Victims of Crime Act funds. A total of $21.3 million is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("As part of the recommendations established by the Victim Services Ad Hoc Committee, the strengthening and expansion of core services for victims of crime was identified as a priority. To fulfill this priority, ICJIA has made available VOCA grant funding for core services and related support costs for victims of domestic violence. These funds will be made available to the Illinois Coalition Against Domestic Violence.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the Illinois Coalition Against Domestic Violence, 806 S. College Street, Springfield, Illinois, 62704.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of FFY17 Victims of Crime Act funds. A minimum of $21.3 million will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of July 1, 2019, through June 30, 2020.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("Technical Assistance Session")]), _vm._v(" "), _c('p', [_vm._v("N/A")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit monthly/quarterly financial reports, monthly/quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Ronnie J. Reichgelt")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(9)], 1)])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline:")]), _vm._v(" Application materials must be received by "), _c('strong', [_vm._v("11:59 p.m. on Sunday, March 3, 2019.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "https://grants.illinois.gov/portal/"
    }
  }, [_vm._v("https://grants.illinois.gov/portal/")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of period of performance start date, July 1, 2019 to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 1, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical Assistance Recording available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("February 25, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("March 3, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Office of Victims of Crime portal at "), _c('a', {
    attrs: {
      "href": "https://ovcpmt.ojp.gov/"
    }
  }, [_vm._v("https://ovcpmt.ojp.gov/")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., Sunday, March 3, 2019,")]), _vm._v(" deadline for application review.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICADV/ICADVapplication.pdf"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICADV/ICADVprogramnarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190129ICADV/ICADVbudget.xls.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:NOFOemail@Illinois.gov"
    }
  }, [_vm._v("NOFOemail@Illinois.gov")]), _vm._v(" until "), _c('strong', [_vm._v("11:59 p.m. on March 3, 2019.")]), _vm._v(" Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:NOFOemail@illinois.gov"
    }
  }, [_vm._v("NOFOemail@illinois.gov")])])
}]}

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "News & Announcements"
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    staticClass: "h4 grant-main-head text-center"
  }, [_vm._v("\n            IMPORTANT ANNOUNCEMENT TO ALL STATE AGENCIES AND GRANTEE ORGANIZATIONS\n\n          ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_vm._v("Announcing the public release of the Catalog of State Financial Assistance (CSFA) and the Grantee Compliance Enforcement System")]), _vm._v(" "), _c('h2', {
    staticClass: "h5 news-section-head first"
  }, [_vm._v("Catalog of State Financial Assistance")]), _vm._v(" "), _c('p', [_vm._v("The CSFA is required by GATA and provides a single, authoritative, statewide, comprehensive source of financial assistance program information. State agencies have populated the CSFA with federal, federal pass-through and state awards received.  The CSFA also records grantee awards under each CSFA number.\n")]), _vm._v(" "), _c('p', [_vm._v("The public can search the CSFA for agencies with active grant programs,\n  currently funded grants, current funding opportunities,\n  and registered grantees.  Use the CSFA tab of this website or the\n  following link to access the public-facing CSFA:\n  "), _c('a', {
    attrs: {
      "href": "https://www.illinois.gov/sites/GATA/Grants/SitePages/CSFA.aspx"
    }
  }, [_vm._v("https://www.illinois.gov/sites/GATA/Grants/SitePages/CSFA.aspx.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h5 news-section-head"
  }, [_vm._v("Grantee Compliance Enforcement System")]), _vm._v(" "), _c('p', [_vm._v("\nIllinois is utilizing a federal framework for the Grantee Compliance Enforcement System to drive grantee compliance with grant requirements.  This system promotes cross-agency information sharing to improve risk assessment processes and enhance fiscal management transparency.\n")]), _vm._v(" "), _c('p', [_vm._v("\nGATA requires the maintenance of a list of individuals and entities temporarily or permanently ineligible to receive grant funds.\nThis list called the Illinois Stop Payment List\n(initially introduced in December 2015),\nis a component of the Grantee Compliance Enforcement System.\nThe Grantee Compliance Enforcement System was implemented January 1, 2017.\n\n")]), _vm._v(" "), _c('h2', {
    staticClass: "h5 news-section-head"
  }, [_vm._v("Indirect Cost Rate Negotiation for Illinois Grantees")]), _vm._v(" "), _c('p', [_vm._v("The Governor’s Office of Management and Budget has contracted with Crowe Horwath to negotiate Indirect Cost Rate Agreements with Illinois Grantees.  The Grant Accountability and Transparency Unit received permission from the Federal Government to centralize the negotiation of the indirect cost rate to allow a grantee to negotiate one rate with the State of Illinois.  The centrally approved rate will be accepted by all state grant making agencies, instead of requiring a grantee to negotiate separate rates with each state grant making agency when grantees receive grants with multiple agencies.  Grantees who have completed the grantee registration, pre-qualification and fiscal and administrative risk assessment will receive an invitation from Crowe Horwath to submit an indirect cost rate proposal for purposes of negotiating a rate.\n")]), _vm._v(" "), _c('p', [_vm._v("For full information and links about these items, please see: "), _c('a', {
    attrs: {
      "href": "https://www.illinois.gov/sites/GATA/Pages/default.aspx"
    }
  }, [_vm._v("https://www.illinois.gov/sites/GATA/Pages/default.aspx")])])])])])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants funding local Illinois Family Violence Coordinating Council (IFVCC). Grants will be made with IFVCC state fiscal year 2020 funds. A total of $435,000 in funding is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _c('p', [_vm._v("IFVCC requirements include:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to public and not-for profit entities in Illinois. Advocacy agencies are not eligible to apply due to judicial ethic rules.")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants include but are not limited to:")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Grants available through this funding opportunity are a portion of state fiscal year 2020 funds. A minimum of $435,000 dollars will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of July 1, 2019, to June 30, 2020. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "technical-assistance-session"
    }
  }, [_vm._v("Technical Assistance Session")]), _vm._v(" "), _c('p', [_vm._v("Technical assistance recordings providing additional information regarding this funding opportunity will be available for viewing beginning at 5:00 p.m. on March 13, 2019.")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(19)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/IFVCCNOFO.pdf"
    }
  }, [_vm._v("Link to NOFO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., April 5, 2019")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('p', [_vm._v("Coordinate efforts to improve the systems response to family violence (including but not limited to domestic violence, child abuse, teen dating violence, and abuse against older adults and persons with disabilities).")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("This is done through the coordinating and convening of committees and workgroups.\n                "), _c('ul', [_c('li', [_vm._v("Councils are required to have a steering committee that meets no less than three times per year.")]), _vm._v(" "), _c('li', [_vm._v("Councils are encouraged to have at least two additional sub-committees and/or workgroups that meet quarterly at a minimum.")]), _vm._v(" "), _c('li', [_vm._v("Council membership should include a diverse representation from disciplines not limited to those listed in Exhibit G in the program narrative.")])])])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Improve the knowledge of criminal justice professionals on family violence related topics.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("This is done through providing trainings to criminal justice and social service professionals and the collection of pre/post tests and evaluations. These trainings include:\n                "), _c('ul', [_c('li', [_vm._v("Arrest Protocol trainings.")]), _vm._v(" "), _c('li', [_vm._v("Arrest Promising Practice Mini-Toolkit trainings.")]), _vm._v(" "), _c('li', [_vm._v("Non-arrest trainings that can be on topics related to family violence of interest based on the council’s specific geographic region’s needs.")])])])]), _vm._v(" "), _c('p', [_vm._v("Note: Councils are required to provide at least one of each type of the above trainings during the grant period.")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Increase community awareness and knowledge of family violence issues (including but not limited to domestic violence, child abuse, teen dating violence, and abuse against older adults and persons with disabilities).")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("This is done through:\n                "), _c('ul', [_c('li', [_vm._v("Community awareness events.")]), _vm._v(" "), _c('li', [_vm._v("Information and resource sharing and outreach to both community members and agencies/organizations in the circuit.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "https://grants.illinois.gov/portal/"
    }
  }, [_vm._v("https://grants.illinois.gov/portal/")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the period of performance start date of July 01, 2019 to be considered for funding.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Government agencies, including local and county government.")]), _vm._v(" "), _c('li', [_vm._v("Educational institutions and regional offices of education.")]), _vm._v(" "), _c('li', [_vm._v("Non- profit agencies, excluding advocacy agencies.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.IFVCC.NOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.IFVCC.NOFO@Illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., April 5, 2019,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/ELS7bETLUW0"
    }
  }, [_vm._v("Recording 1: IFVCC NOFO Guidelines (11:07)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("Recording 2: General Requirements (11:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("Recording 3: GATA Budget (19:03)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Recording 4: Indirect Costs (6:18)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Recording 5: Prior Approvals (6:05)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in applying are asked to submit an online Notice of Intent by "), _c('strong', [_vm._v("11:59 p.m., March 20, 2019")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_5vgq9ojdTws2NgN"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 6, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Technical Assistance Recording available")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 13, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 20, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("March 29, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., April 5, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("June 27, 2019")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("July 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.IFVCC.NOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.IFVCC.NOFO@Illinois.gov")]), _vm._v(" by the 11:59 p.m., April 5, 2019, deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/IFVCCApplication.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/IFVCCNarrative.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/IFVCCBudget.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/NOFODocuments_IFVCC.zip"
    }
  }, [_vm._v("DOWNLOAD ZIP FILE OF ALL REQUIRED APPLICATION DOCUMENTS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from applicants and their responses are revised weekly. \n  "), _c('a', {
    attrs: {
      "href": "/static/grants/20190306ifvcc/IFVCCRESPONSEtoAPPLICANTQuestions.pdf"
    }
  }, [_vm._v("View them here")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Lacey Pollock"), _c('br'), _vm._v("\n    Illinois Criminal Justice Information Authority"), _c('br'), _vm._v("\n    607 East Adams, Suite 906"), _c('br'), _vm._v("\n    Springfield, IL 62701"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:CJA.IFVCC.NOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.IFVCC.NOFO@Illinois.gov")])])
}]}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#all-categories"
    }
  }, [_vm._v("All Categories")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#application-materials"
    }
  }, [_vm._v("Application Materials")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#available-funds"
    }
  }, [_vm._v("Available Funds")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#period-of-performance"
    }
  }, [_vm._v("Period of Performance")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#contact-information"
    }
  }, [_vm._v("Contact Information")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#required-technical-assistance-section"
    }
  }, [_vm._v("Required Technical Assistance Session")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-intent"
    }
  }, [_vm._v("Notice of Intent")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#required-documents"
    }
  }, [_vm._v("Required Documents")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting"
    }
  }, [_c('h1', {
    staticClass: "h2 grant-main-head text-center"
  }, [_vm._v("FFY14-17 Residential Substance Abuse Treatment Program Residential Substance Abuse Treatment and Aftercare")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for grants supporting residential substance abuse treatment and aftercare services. Grants will be made with federal fiscal year 2014-17 (FFY14-17) Residential Substance Abuse Treatment (RSAT) funds. Approximately $315,000 in funding is available in three program categories for use over a period of 12 months.  ")]), _vm._v(" "), _c('h2', {
    staticClass: "h5 text-center",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    },
    attrs: {
      "id": "application-deadline-1159-pm-june-13-2017"
    }
  }, [_vm._v("Application deadline: 11:59 p.m. June 13, 2017")]), _vm._v(" "), _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "30px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_NOFO_041217.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Read the Notice of Funding Opportunity  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program requirements:")]), _vm._v("\n\n\nRSAT funds may be used to implement three types of programs: corrections-based, jail-based, and aftercare. Applications involving partnerships with community-based substance abuse treatment programs are encouraged. Agencies may apply for funding in more than one program category.\n"), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "468",
      "valign": "top"
    }
  }, [_vm._v("\nProgram Category")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "468",
      "valign": "top"
    }
  }, [_vm._v("\nCorrections-based substance abuse treatment")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "468",
      "valign": "top"
    }
  }, [_vm._v("\nJail-based substance abuse treatment")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "width": "468",
      "valign": "top"
    }
  }, [_vm._v("\nAftercare")])])])])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "all-categories"
    }
  }, [_vm._v("All categories")]), _vm._v(" "), _c('p', [_vm._v("Individuals who participate in a substance abuse treatment program established or implemented with funding from this program must be provided aftercare services. Aftercare services must involve coordination between the correctional treatment program and other social service and rehabilitation programs, such as education and job training, parole supervision, halfway houses, self-help, and peer group programs.")]), _vm._v(" "), _c('p', [_vm._v("To qualify as an aftercare program, the substance abuse treatment program must work in conjunction with state and local authorities and organizations involved in substance abuse treatment to assist in the placement of program participants into community substance abuse treatment facilities post-release.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Corrections-based substance abuse treatment")])]), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Engage participants for a period of between 6 and 12 months.")]), _vm._v(" "), _c('li', [_vm._v("Provide residential treatment facilities set apart—in a completely separate facility or dedicated housing unit exclusively for use by RSAT participants—from the general correctional population.")]), _vm._v(" "), _c('li', [_vm._v("Focus on the inmate’s substance use diagnosis and addiction-related needs.")]), _vm._v(" "), _c('li', [_vm._v("Develop the inmate’s cognitive, behavioral, social, vocational, and other skills to solve the substance use and related problems.")]), _vm._v(" "), _c('li', [_vm._v("Require urinalysis and/or other proven reliable forms of drug and alcohol testing for program participants, including both periodic and random testing, and for former participants while they remain in the custody of the state or local government.")]), _vm._v(" "), _c('li', [_vm._v("Prepare participants for successful community reintegration, including post-release referral to appropriate evidence-based aftercare treatment and service providers that support the use of medication-assisted treatment.")])]), _vm._v(" "), _c('p', [_vm._v("If possible, RSAT participation should be limited to inmates with 6 to 12 months remaining in their confinement.")]), _vm._v(" "), _c('p', [_vm._v("If possible, program design should be based on effective, scientific practices.")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Jail-based substance abuse treatment")])]), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Engage participants for at least three months.")]), _vm._v(" "), _c('li', [_vm._v("Focus on the inmate’s substance use diagnosis and addiction-related needs.")]), _vm._v(" "), _c('li', [_vm._v("Develop the inmate’s cognitive, behavioral, social, vocational, and other skills to solve the substance use and related problems with emphasis on the provision of cognitive behavioral therapy.")]), _vm._v(" "), _c('li', [_vm._v("Require urinalysis and/or other proven reliable forms of drug and alcohol testing for program participants, including both periodic and random testing, and for former participants while they remain in the custody of the state or local government.")]), _vm._v(" "), _c('li', [_vm._v("Prepare participants for successful community reintegration, including post-release referral to appropriate evidence-based aftercare treatment and service providers that support the use of medication-assisted treatment.")]), _vm._v(" "), _c('li', [_vm._v("If possible, jail-based programs should separate the treatment population from the general correctional population and program design should be based on effective, scientific practices.")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Aftercare")])]), _vm._v(" "), _c('p', [_vm._v("Programs must:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Involve coordination between the correctional treatment program and other social service and rehabilitation programs, such as education and job training, parole supervision, halfway houses, self-help, and peer group programs.")]), _vm._v(" "), _c('li', [_vm._v("Work in conjunction with state and local authorities and organizations involved in substance abuse treatment to assist in the placement of program participants into community substance abuse treatment facilities on release.")])]), _vm._v(" "), _c('p', [_vm._v("In addition:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("If federal or matching funds are used for the purpose of providing treatment to offenders after release, the time period of treatment may not exceed one year after release.")]), _vm._v(" "), _c('li', [_vm._v("To qualify as an aftercare program, the head of the substance abuse treatment program must work in conjunction with state and local authorities and organizations involved in substance abuse treatment to assist in the placement of program participants into community substance abuse treatment facilities post-release.")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligibility-requirements"
    }
  }, [_vm._v("Eligibility Requirements:")]), _vm._v(" "), _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_c('strong', [_vm._v("www.grants.illinois.gov")])]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of application to be considered for funding.")]), _vm._v(" "), _c('p', [_vm._v("Applications from agencies that have not received ICQ approval will not be reviewed.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants:")]), _vm._v(" "), _c('p', [_vm._v("Eligible applicants are limited to Illinois counties and state agencies. Private and non-profit entities are not eligible to apply.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-materials"
    }
  }, [_vm._v("Application Materials:")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_NOFO_041217.pdf"
    }
  }, [_c('strong', [_vm._v("Click here")])]), _vm._v(" for the 2017 Residential Substance Abuse Treatment Grant Application.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline:")]), _vm._v(" "), _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2017rsatNOFO@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("CJA.2017rsatNOFO@Illinois.gov")])]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., June 13, 2017,")]), _vm._v(" to be considered for funding. Proposals will not be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds:")]), _vm._v(" "), _c('p', [_vm._v("Grants will be made with federal fiscal year 2014-17 (FFY14-17) Residential Substance Abuse Treatment (RSAT) Program awards received by ICJIA from the U.S. Department of Justice Office of Justice Programs Bureau of Justice Assistance. Approximately wake up has $315,000 in RSAT funds is available through this funding opportunity. Approximately $65,000 of this amount must be awarded to local government agencies.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance:")]), _vm._v(" "), _c('p', [_vm._v("Grant awards resulting from this opportunity are projected to have a performance period of October 1, 2017, through September 30, 2018. Contingent on satisfactory performance, ICJIA staff may recommend to its Board a maximum of 24 additional months of funding for each project.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information:")]), _vm._v(" "), _c('p', [_vm._v("Gregory Stevens "), _c('br'), _vm._v("\nProgram Administrator "), _c('br'), _vm._v("\nIllinois Criminal Justice Information Authority "), _c('br'), _vm._v("\n300 West Adams, Suite 200 "), _c('br'), _vm._v("\nChicago, IL 60606 "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:Gregory.Stevens@illinois.gov"
    }
  }, [_c('strong', [_vm._v("Gregory.Stevens@illinois.gov")])]), _vm._v(" "), _c('br'), _vm._v("\n312-793-0890  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "required-technical-assistance-section"
    }
  }, [_vm._v("Required Technical Assistance Session:")]), _vm._v(" "), _c('p', [_vm._v("View the required pre-application webinar offering technical assistance below:")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/zezwGlJYxeQ",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3527267/Required-RSAT-Residential-Substance-Abuse-Treatment-and-Aftercare-Program-Pre-application-Webinar-Certification",
      "target": "_blank"
    }
  }, [_vm._v("Submit Certification for Viewing Required Webinar")])]), _vm._v(" "), _c('p', [_vm._v("Information provided during this webinar recording will be unofficial and not binding on the state.")]), _vm._v(" "), _c('h3', {
    staticClass: "sticky-sidebar-entry",
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent:")]), _vm._v(" "), _c('p', [_vm._v("Agencies interested in submitting an application are asked to submit an online Notice of Intent by "), _c('strong', [_vm._v("11:59 p.m., May 12, 2017")]), _vm._v(".  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3498794/Residential-Substance-Abuse-Treatment-Program-Residential-Substance-Abuse-Treatment-and-Aftercare-Notice-of-Intent",
      "target": "_blank"
    }
  }, [_vm._v("Submit Notice of Intent")])]), _vm._v(" "), _c('h3', {
    staticClass: "sticky-sidebar-entry",
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nTask")]), _vm._v(" "), _c('th', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nDate\n")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nNOFO posted\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nFriday, April 14, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nApplicant webinar registration deadline\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nThursday, April 27, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nApplicant webinar\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nMonday, May 1, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nLetters of Intent due date\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nFriday, May 12, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nNOFO question submission deadline\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nWednesday, June 7, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nApplications due\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n11:59 p.m., Tuesday, June 13, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nNotices of State Award released\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nMonday, August 1, 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nBudget Committee review/approval of recommended designations\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nSeptember 2017\n")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\nProjected program start date\n")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n October 1, 2017\n")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "sticky-sidebar-entry",
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting:")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Department of Justice Bureau of Justice Assistance portal at "), _c('a', {
    attrs: {
      "href": "https://bjapmt.ojp.gov"
    }
  }, [_c('strong', [_vm._v("https://bjapmt.ojp.gov")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sticky-sidebar-entry",
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents:")]), _vm._v(" "), _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2017rsatNOFO@Illinois.gov"
    }
  }, [_c('strong', [_vm._v("CJA.2017rsatNOFO@Illinois.gov")])]), _vm._v(" by 11:59 p.m., Tuesday, "), _c('strong', [_vm._v("June 13, 2017")]), _vm._v(", for application review. Click the links below to download copies.")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_NOFO_Uniform_Application_for_Grant_Assistance_041217.docx"
    }
  }, [_c('strong', [_vm._v("Completed and signed Uniform State Grant Application ("), _c('em', [_vm._v("Word")]), _vm._v(").")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_program_narrative_CE_040617.docx"
    }
  }, [_vm._v("Completed Program Narrative for selected program category (Word).")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_NOFO_Blank_Budget_032817.xlsx"
    }
  }, [_c('strong', [_vm._v("Completed Budget/Budget Narrative ("), _c('em', [_vm._v("Excel")]), _vm._v(").")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-grant",
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/RSAT_NOFO/RSAT_NOFO_041217_application_documents.zip",
      "target": "_blank"
    }
  }, [_vm._v("Download ALL Application Documents (zip file)  "), _c('i', {
    staticClass: "fa fa-file-pdf-o"
  })])])])])])])
}]}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is requesting proposals for SFY19 Adult Redeploy Illinois planning grants. A total of $200,000 in SFY19 Adult Redeploy Illinois funding is available through this solicitation for use over a six-month\n    period.")]), _vm._v(" "), _c('p', [_vm._v("County applicants may request a planning grant to convene stakeholders, analyze data, and conduct other activities in the design of a local ARI program to divert probation-eligible offenders from prison to community-based supervision and services. As\n    part of the planning grant process, applicants will be expected to gather and analyze relevant criminal justice system data, including, but not limited to, current services offered, services needed, strategies for service delivery, potential eligible\n    populations, local governance issues, data collection and analysis capabilities, and estimated costs of alternatives to incarceration. The process culminates in the development and submission of a local ARI implementation plan.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program Requirements")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("Each applicant should identify a multi-disciplinary team (MDT) to oversee and execute the planning process, representing the criminal justice spectrum (e.g., judiciary, prosecution, defense, probation) and the community (e.g., treatment providers, social\n    services, business) to guide planning. Please list titles, not proper names, of all partners.")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("ARI funds must be used to invest in local programs, services, and protocols that have been demonstrated by research to reduce recidivism.")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Funds are to be used solely for developing a local plan to implement ARI to expand alternatives to incarceration. Uses of planning grant funds may include, but are not limited to:")]), _vm._v(" "), _c('p', [_vm._v("• Employing an outside facilitator or strategic planning consultant.")]), _vm._v(" "), _c('p', [_vm._v("• Conducting an outside or in-house data analysis.")]), _vm._v(" "), _c('p', [_vm._v("• Providing stakeholder training.")]), _vm._v(" "), _c('p', [_vm._v("• Conducting site visits to observe successful diversion programs.")]), _vm._v(" "), _c('p', [_vm._v("• Community resource mapping.")]), _vm._v(" "), _c('p', [_vm._v("Funds may not be used for capital expenditures, renovations or remodeling, or any food and beverage purchases. In addition, ARI funds shall not be used to supplant existing federal, state, county, or locally funded programs.")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("Only county units of government are eligible to apply for funds under this notice. A county may submit on behalf of a group of counties or a judicial circuit. Private agencies or not-for-profit organizations are not eligible to apply. Applicants for funding\n    must be a county unit of government in good standing with the State of Illinois.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $200,000 dollars will be made available through this funding opportunity.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of January 1, 2019, to June 30, 2019. Based on program performance and fund availability, the ARI Oversight Board may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "letter-of-intent"
    }
  }, [_vm._v("Letter of Intent")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements. Future awards and fund drawdowns\n    may be withheld if reports are delinquent.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("Required Documents")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("Questions")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Adriana Perez")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(15)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: October 26, 2018")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Planning Multi-Disciplinary Team")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Evidence-based Practices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Planning Activities")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('em', [_vm._v("Local Plan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("At the end of the planning period of performance, funded jurisdictions must complete and submit a local ARI implementation plan using the standard plan template (available at "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/redeploy/standard-plan.cfm"
    }
  }, [_vm._v("http://www.icjia.state.il.us/redeploy/standard-plan.cfm")]), _vm._v(").\n    Jurisdictions are under no obligation to implement the plan; however, a letter stating why the plan will not be implemented, or a detailed explanation with supporting evidence as to why a plan was not developed, must be submitted by the end of the\n    performance period in conjunction with periodic progress reports, on or before July 15, 2019.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(" , to become eligible to apply for an award. Applicants must have completed\n    the GATA pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of application to be considered for funding. Applications from agencies that have not received ICQ approval will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.ARI.SFY19NOFO2@illinois.gov "
    }
  }, [_vm._v("CJA.ARI.SFY19NOFO2@illinois.gov ")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., October 26, 2018,")]), _vm._v(" for funding consideration. Proposals will not be accepted by mail,\n    fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in applying are asked to submit an online Letter of Intent by "), _c('strong', [_vm._v("11:59 p.m., October 12, 2018.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://icjia.az1.qualtrics.com/jfe/form/SV_1EQaPVJ60UsJZ1H"
    }
  }, [_vm._v("Complete Notice of Intent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("9/26/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Notice of Intent due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("10/12/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("10/18/18")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("October 26, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Adult Redeploy Illinois Oversight Board approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("11/19/18")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("01/01/19")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "CJA.ARI.SFY19NOFO2@illinois.gov "
    }
  }, [_vm._v("CJA.ARI.SFY19NOFO2@illinois.gov ")]), _vm._v(" by the "), _c('strong', [_vm._v("11:59 p.m., October 26, 2018,")]), _vm._v(" deadline for application review. Click the links below to download copies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180927ARIPlanning/SFY19PlanningGrantINSTRUCTIONS.docx"
    }
  }, [_vm._v("Download NOFO Instructions (PDF)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180927ARIPlanning/SFY19PlanningGrantAPPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State Grant Application (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180927ARIPlanning/SFY19PlanningGrantNARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180927ARIPlanning/SFY19PlanningGrantBUDGET.xls.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this funding opportunity may be submitted to "), _c('a', {
    attrs: {
      "href": "CJA.ARI.SFY19NOFO2@illinois.gov "
    }
  }, [_vm._v("CJA.ARI.SFY19NOFO2@illinois.gov ")]), _vm._v(" until 11:59 p.m., October 18, 2018. Questions and responses will be posted at "), _c('a', {
    attrs: {
      "href": "https://grants.icjia.cloud"
    }
  }, [_vm._v("https://grants.icjia.cloud")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:CJA.ARI.SFY19NOFO2@illinois.gov  "
    }
  }, [_vm._v("CJA.ARI.SFY19NOFO2@illinois.gov ")])])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.checkExpire(_vm.expired)) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    staticStyle: {
      "margin-bottom": "60px"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "900"
    }
  }, [_vm._v("\n        THIS FUNDING OPPORTUNITY HAS EXPIRED\n      ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("The purpose of this funding opportunity is to serve hard-to-reach victims of crime through Illinois Level 1 Adult or Pediatric Trauma Centers. Applicants may request a maximum of $1.1 million in federal funding for use over a 15-month period. The term\n    of the grant agreement will commence upon its effective date. Based on program performance and fund availability, ICJIA may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('p', [_vm._v("For the purposes of this funding opportunity, the following definitions will apply:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to Illinois public agencies and non-profits that have completed the GATA pre-qualification process and received approval of their ICQ from a state cognizant agency by the date of application.")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pre-registration"
    }
  }, [_vm._v("Pre-Registration")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "approved-internal-control-questionnaire"
    }
  }, [_vm._v("Approved Internal Control Questionnaire")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "notice-of-intent"
    }
  }, [_vm._v("Notice of Intent")]), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("Applicants may request a maximum of $1.1 million in federal funding for use over a 15-month period. Agreements that result from this funding opportunity are contingent upon and subject to the availability of funds.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("The projected period of performance for awards resulting from this opportunity is April 1, 2018, through June 30, 2019. Contingent on satisfactory performance, ICJIA may support 24 additional months of funding for each project.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "technical-assistance-recordings"
    }
  }, [_vm._v("Technical Assistance Recordings")]), _vm._v(" "), _c('p', [_vm._v("Applicants must view six recordings at the links provided below. The recordings will be available for viewing beginning at 1:30 p.m. on November 1, 2017. Information provided during these recordings will be unofficial and not binding on the state.")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline:")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("Funded agencies will be required to submit to ICJIA quarterly fiscal and data reports.")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "application-submission-instructions"
    }
  }, [_vm._v("Application Submission Instructions")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "download-application-documents"
    }
  }, [_vm._v("Download Application Documents")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicants’ Questions")]), _vm._v(" "), _vm._m(27)])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#download-application-documents"
    }
  }, [_vm._v("Download Application Documents")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#updates-and-responses-to-applicant-questions"
    }
  }, [_vm._v("Updates and Responses to Applicant Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Trauma Recovery Center (TRC) Model")]), _vm._v(": A comprehensive service delivery model providing coordinated clinical and case management services for adult and/or minors victims of violent crime and their families who typically do not access services\n    due to individual and cultural barriers to help seeking.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Historically underserved or marginalized victims")]), _vm._v(": Historically underserved or marginalized victims may not seek services for a variety of reasons, including stigma, stereotypes, and social norms that deter help seeking; a lack of knowledge\n    on service availability, methods of access, and eligibility; concerns or past experiences with provider insensitivity to disabilities or cultural beliefs; and a lack of positive experience with the criminal justice system, including law enforcement,\n    which is a frequent access point to victim services. Historically underserved or marginalized victims who may benefit from the low-barrier services that the TRC aims to provide may include individual who are homeless, individuals who are chronically\n    mentally ill, immigrants and refugees, individuals who are disabled, people with severe trauma-related symptoms, and individuals of diverse ethnicities/origins.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Direct services")]), _vm._v(": Efforts that respond to the emotional, psychological and physical needs of crime victims; assist victims to stabilize their lives after victimization; assist victims to understand and participate in the criminal justice\n    system; or provide victims of crime with a measure of safety.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("See Notice of Funding Opportunity for program design, staff, and training requirements.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Eligible applicants include "), _c('strong', [_vm._v("public or non-profit Illinois hospitals with a Level 1 Adult or Pediatric Trauma Center designation by the Illinois Department of Public Health")]), _vm._v(". In addition, applicants must meet the VOCA eligibility criteria\n    listed on pages 20-21 of the Notice of Funding Opportunity.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Please note: applicants must pre-register and obtain an approved Internal Control Questionnaire.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All applicants must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal, "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(". During pre-qualification, Dun and Bradstreet verifications are performed,\n    including a check of Debarred and Suspended status and good standing with the Illinois Secretary of State.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The pre-qualification process also includes a financial and administrative risk assessment using an Internal Controls Questionnaire (ICQ). "), _c('strong', [_vm._v("The ICQ must be submitted through the GATA portal and approved by a State cognizant agency by the date of application submission in order for an application to be reviewed.")]), _vm._v("    All applications will be pre-screened for completeness and ICQ approval. Applications from agencies that do not have an approved ICQ will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171031TRC/TRCNOFO.pdf"
    }
  }, [_vm._v("View the Notice of Funding Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Applications are due at "), _c('strong', [_vm._v("11:59 p.m., January 10, 2018")]), _vm._v(". Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies interested in submitting an application "), _c('strong', [_vm._v("MUST")]), _vm._v(" complete an online Notice of Intent form by "), _c('strong', [_vm._v("11:59 p.m., December 18, 2017")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.surveygizmo.com/s3/3867318/VOCA-Trauma-Recovery-Center-Notice-of-Intent"
    }
  }, [_vm._v(" Please use this form to submit your Notice of Intent.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions may be submitted via email at "), _c('a', {
    attrs: {
      "href": "mailto:cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(". The deadline for submitting questions is 11:59 p.m., January 3, 2018. All substantive questions and responses will be posted on the\n    ICJIA website at "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/"
    }
  }, [_vm._v("http://www.icjia.state.il.us/")]), _vm._v(". Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or indirectly with any Authority employee other than\n    the respondent of this email address. Only written answers to questions shall be binding on the state.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/cvbv_R528ho"
    }
  }, [_vm._v("Recording 1: Trauma Recovery Center NOFO (25:12)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/zPaIPFXZvmg"
    }
  }, [_vm._v("Recording 2: General Requirements (11:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://youtu.be/wqIrwI5U0eY"
    }
  }, [_vm._v("Recording 3: VOCA Match (4:19)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/sQYCekU2pIw"
    }
  }, [_vm._v("Recording 4: Budget (19:03)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/mjp5PZx0oaY"
    }
  }, [_vm._v("Recording 5: Indirect Costs (6:18)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/embed/Q8UaLYqslJs"
    }
  }, [_vm._v("Recording 6: Prior Approval Requirements (6:05)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Release of NOFO and open application period")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("November 1, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Notice of Intent Due")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("December 18, 2017")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Last date for question submission")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("January 3, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("Application deadline")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., January 10, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Budget Committee Review")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("March 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Award and rejection letters sent")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("by April 1, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("Start Program Performance Period")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("April 1, 2018")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(" by "), _c('strong', [_vm._v("11:59 p.m., January 10, 2018")]), _vm._v(", to be considered for funding. Proposals will not be accepted by mail, fax,\n    or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies are encouraged to submit their applications 72 hours in advance of the deadline to avoid unforeseen technical difficulties. Technical difficulties should be reported immediately to ICJIA at "), _c('a', {
    attrs: {
      "href": "cja.vocagrantsunit@illinois.gov"
    }
  }, [_vm._v("cja.vocagrantsunit@illinois.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped table-responsive"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Document")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Word")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Excel")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Completed and signed Uniform State Grant Application for each agency requesting funding. "), _c('strong', [_vm._v("This document will need to be signed and scanned.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Completed Program Narrative in Word that meets program requirements outlined in Section A. Applicant’s narrative must be submitted in Word and formatted in the posted Program Narrative. Application should be 40 pages maximum, drafted in Times\n                New Roman 12-point font and double-spaced with 1 inch margins. Please number pages.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("One completed Budget/Budget Narrative in Excel for each funded agency.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Signed letter(s) of commitment from TRC Coordination Group members outside your organization and from anticipated referral agencies")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("For Non-Profit Agencies Only")]), _vm._v(": United States Internal Revenue Service 501©(3) determination letter for nonprofit organizations.")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171031TRC/TRCApplication.docx"
    }
  }, [_vm._v("Uniform Application")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171031TRC/TRCNarrative.docx"
    }
  }, [_vm._v("Program Narrative")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20171031TRC/TRCBudget.xlsx"
    }
  }, [_vm._v("Uniform Budget Template")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Updates to NOFO materials, and questions from applicants and their responses are revised weekly."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/assets/pdf/trc2017/TRCResponsetoApplicantQuestions.pdf"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "introduction"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority is soliciting proposals from county criminal justice and\n            victim service agencies interested in maintaining or expanding multidisciplinary programs incorporating prosecution,\n            county and/or local law enforcement, probation, and victim service agency partnerships. Grants will be made\n            with Violence Against Women Act (VAWA) funds. A total of $3,250,000 in funding is available through this solicitation.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("PROGRAM REQUIREMENTS")]), _vm._v(" "), _c('p', [_vm._v("Programs must provide a meaningful response to the needs of sexual assault or domestic violence victim populations\n            through coordinated responses from community law enforcement agencies, prosecutors, courts/probation, victim\n            services agencies, and other state agencies and departments. The applicant must demonstrate that it has the\n            expertise in providing relevant and accessible community-based outreach and intervention services or has the\n            capacity to link to existing services in the community tailored to the needs of the population. Applicants\n            must also have implemented or plan to work toward fully implementing best practices.")]), _vm._v(" "), _c('p', [_vm._v("A maximum of $650,000 from Federal Fiscal Years 2017, 2016, 2015 and 2014 funds shall be made available to\n            local agencies for multi-disciplinary programs that meet the following criteria:")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "view-the-notice-of-funding-opportunity"
    }
  }, [_vm._v("VIEW THE NOTICE OF FUNDING OPPORTUNITY")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility-information"
    }
  }, [_vm._v("ELIGIBILITY INFORMATION")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("DEADLINE")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("AVAILABLE FUNDS")]), _vm._v(" "), _c('p', [_vm._v("Applicants may request a maximum of $650,000 to be spent over a 12-month period. A 25-percent cash or in-kind\n            match requirement will be imposed on grant funds under this program. Match funds must be spent in support of\n            the program’s goals and objectives.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("CONTACT INFORMATION:")]), _vm._v(" "), _c('p', [_vm._v("Shataun Hailey")]), _vm._v(" "), _c('p', [_vm._v("Program Administrator")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("312-814-8100")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("TIMELINE")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("REPORTING")]), _vm._v(" "), _c('p', [_vm._v("Recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress\n            reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.\n            Future awards and fund drawdowns may be withheld if reports are delinquent.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "required-documents"
    }
  }, [_vm._v("REQUIRED DOCUMENTS")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "questions"
    }
  }, [_vm._v("QUESTIONS")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', [_vm._v("Due to the competitive nature of this solicitation, applicants may not discuss this opportunity directly or\n            indirectly with any Authority employee other than the respondent of this email address. Only written answers\n            to questions shall be binding on the state.\n          ")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#program-requirements"
    }
  }, [_vm._v("Program Requirements")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#questions"
    }
  }, [_vm._v("Questions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("One Stop Services – Co-location of victim service advocates and law enforcement, either at a central location\n              such as a family justice center or at the county justice center. If co-location does not currently exist,\n              applicant must demonstrate how they are working toward implementation.")]), _vm._v(" "), _c('li', [_vm._v("Specialized Training – The Applicant must develop and execute a plan for the cross-training of law enforcement,\n              first responders, and community-based advocacy, which includes the identification of each discipline’s roles\n              and procedures related to domestic violence and/or sexual assault.")]), _vm._v(" "), _c('li', [_vm._v("Program Assessment – All VAWA funded programs must demonstrate progress toward meeting project goals and\n              objectives annually, and describe and justify any planned program modifications to continuously improve")]), _vm._v(" "), _c('li', [_vm._v("Implementation Plan - Provide a step by step plan of how the program or project will be implemented. Include\n              the personnel title of the person, who will be responsible for the associated work for the program or project,\n              resources to be used and anticipated results.\n            ")]), _vm._v(" "), _c('li', [_vm._v("Time table - Insert these steps into a timetable demonstrative of the entire performance period to be funded\n              by this grant. Start and end dates of the major milestone in the program or project must be included")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.NOFO.pdf"
    }
  }, [_vm._v("Download the Violence Against Women Act (VAWA):\n              Multidisciplinary Team Response Program Application\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Agencies must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,\n            "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award.\n            Applicants must have completed the GATA pre-qualification process and received approval of their Internal Control\n            Questionnaire (ICQ) by the date of application to be considered for funding. Applications from agencies that\n            have not received ICQ approval will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Eligible Applicants:")]), _vm._v(" Only not-for-profit organizations and units of government may apply.\n            Proposals for multidisciplinary coordinated programs shall list all partner agencies, but funding is limited\n            to prosecution, law enforcement, courts/probation, and victim services agencies.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018vawaNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.2018vawaNOFO@Illinois.gov")]), _vm._v("\n            by "), _c('strong', [_vm._v("11:59 p.m., September 21, 2018")]), _vm._v(", to be considered for funding. Proposals will not be accepted\n            by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Shataun.Hailey@illinois.gov"
    }
  }, [_vm._v("Shataun.Hailey@illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_c('strong', [_vm._v("Task")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("Date")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Tuesday, August 21, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NOFO question submission deadline")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Monday, September 10, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., Friday, September 21, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Budget Committee review/approval of recommended designations")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Thursday, October 18, 2018")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Tuesday, January 1, 2019")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("In addition, funded programs will be required to report performance measures through the U.S. Department of\n            Justice Bureau of Justice Assistance portal at "), _c('a', {
    attrs: {
      "href": "https://bjapmt.ojp.gov"
    }
  }, [_vm._v("https://bjapmt.ojp.gov")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The following documents must be emailed to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018vawaNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.2018vawaNOFO@Illinois.gov")]), _vm._v("\n            by the "), _c('strong', [_vm._v("11:59 p.m., Friday, September 21, 2018")]), _vm._v(", deadline for application review. Click the\n            links below to download copies.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.ApplicationChecklist.pdf"
    }
  }, [_vm._v("Application Checklist")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.APPLICATION.docx"
    }
  }, [_vm._v("Completed and signed Uniform State\n                Grant Application (Word).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.NARRATIVE.docx"
    }
  }, [_vm._v("Completed Program Narrative (Word).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.BUDGET.xlsx"
    }
  }, [_vm._v("Completed Budget/Budget Narrative (Excel).")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/Attachment 2b - Objective + PM Guide.docx"
    }
  }, [_vm._v("Attachment 2b: Objectives\n                and Performance Measures Guide for use in Program Narrative")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "/static/grants/20180821VAWAMulti/2018.VAWAMDT.alldocs.zip"
    }
  }, [_vm._v("DOWNLOAD ZIP FILE OF ALL REQUIRED APPLICATION\n              DOCUMENTS\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Questions regarding this NOFO may be submitted to "), _c('a', {
    attrs: {
      "href": "mailto:CJA.2018vawaNOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.2018vawaNOFO@Illinois.gov")]), _vm._v("\n            by September 10, 2018.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("All substantive questions and responses will be posted. Updates to NOFO materials, and questions from applicants\n            and their responses are revised weekly. "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us/"
    }
  }, [_vm._v("View them here.")])])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._v("\n\n        Contact Info here\n\n\n      ")])])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "myNav"
    }
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-light bg-faded"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarTogglerDemo01"
    }
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "tag": "a",
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "nav-a"
  }, [_vm._v("ICJIA | GATA INFORMATION")])]), _vm._v(" "), _c('ul', {
    staticClass: "navbar-nav mr-auto mt-2 mt-lg-0",
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          About\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/overview"
    }
  }, [_vm._v("General Overview")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/news",
      "exact": ""
    }
  }, [_vm._v("News & Announcements")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("ICJIA Home")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          Grant Opportunities\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('h6', {
    staticClass: "dropdown-header"
  }, [_vm._v("Current Grant Opportunities")]), _vm._v(" "), (_vm.grants.length > 0) ? _c('div', _vm._l((_vm.grants), function(grant) {
    return _c('span', [_c('router-link', {
      staticClass: "dropdown-item",
      attrs: {
        "tag": "a",
        "to": grant.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(_vm._f("truncateMiddle")(grant.title)))])], 1)
  })) : _c('div', [_c('h6', {
    staticClass: "dropdown-header",
    staticStyle: {
      "color": "#bbb"
    }
  }, [_vm._v("There are no current grant opportunities")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('h6', {
    staticClass: "dropdown-header"
  }, [_vm._v("Archived Grant Opportunities")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/grants",
      "exact": ""
    }
  }, [_vm._v("View archive")])], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "tag": "a",
      "to": "/documents"
    }
  }, [_vm._v("Documents")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "javascript:void(null)",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n          Training\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/webinars"
    }
  }, [_vm._v("Webinars")]), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "tag": "a",
      "to": "/faqs"
    }
  }, [_vm._v("FAQs")])], 1)])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse bg-about-icjia",
    attrs: {
      "id": "navbarHeader"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 py-4"
  }, [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v("About the ICJIA")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Created in 1983, the "), _c('a', {
    attrs: {
      "href": "http://www.icjia.state.il.us",
      "target": "_blank"
    }
  }, [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" is a state agency dedicated to improving the administration of criminal justice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("The Authority brings together key leaders from the justice system and the public to identify critical issues facing the criminal justice system in Illinois, and to propose and evaluate policies, programs, and legislation that address those issues. The agency also works to ensure the criminal justice system in Illinois is efficient and effective. The Authority’s specific powers and duties are detailed in the "), _c('a', {
    attrs: {
      "href": "http://www.ilga.gov/legislation/ilcs/ilcs3.asp?ActID=397&ChapterID=5",
      "target": "_blank"
    }
  }, [_vm._v("Illinois Criminal Justice Information Act.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 py-4"
  }, [_c('h4', {
    staticClass: "text-white"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "http://www.icjia.state.il.us"
    }
  }, [_vm._v("Visit website")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://twitter.com/icjia_illinois?lang=en"
    }
  }, [_vm._v("Follow on Twitter")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://www.facebook.com/ICJIA/"
    }
  }, [_vm._v("Like on Facebook")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://www.youtube.com/channel/UCtZMzk8D3P4OixYTwsfPeKA"
    }
  }, [_vm._v("View on YouTube")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "https://visitor.r20.constantcontact.com/manage/optin?v=001MqUcqqvjwLCJXlLMSWbTe3zHHmEQgFeBuHvBcJWTbwgrxFbDSGx4HSUPpI6DJWMUPgbljtLxffqIcGFTgCnr-auak88ybvRxpoJlTMGPtZs%3D"
    }
  }, [_vm._v("Join mailing list")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-white",
    attrs: {
      "href": "mailto: cja.irc@illinois.gov"
    }
  }, [_vm._v("Send email")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarTogglerDemo01",
      "aria-controls": "navbarTogglerDemo01",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}

/***/ })
],[217]);


// WEBPACK FOOTER //
// static/js/app.86a75098e52e140961d6.js